export default {
  "en": {
    "FAQModal": {
      "use-email-instead-of-customer": "Please use your email address instead of your customer number to reset your password.",
      "missing-verification-email": "I don't receive the verification email.",
      "missing-forgot-password-email": "I don't receive the \"forgot password\" email.",
      "creating-your-personalized": "You are trying to create your personalized user account with your email address. Please sign in with your customer number first in order to create your personalized user account.",
      "use-email-instead-of-your-customer": "Please use your email address instead of your customer number while signing in.",
      "frequently-asked-questions": "Frequently Asked Questions",
      "personalized-user-account": "Did you create your personalized user account?",
      "no": "No",
      "use-customer-without-de": "Please use your customer number (without the \"DE\" prefix) to reset your password.",
      "yes": "Yes",
      "use-customer-without-de-prefix": "Please use your customer number (without the \"DE\" prefix) while signing in and follow the steps to create your personalized user account.",
      "i-cannot-sign-in-to-my-account": "I can't sign in to my account."
    },
    "api": {
      "incorrect-username-or-password": "Incorrect username or password.",
      "invalid-code-provided": "An error occurred. Start the password change from begin.",
      "user-does-not-exist": "User does not exist.",
      "password-validation-error": "The password doesn’t fulfill the requirements.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "User does not exist.",
      "password-missing-number": "The password doesn’t fulfill the requirements. Enter a password with at least 1 number.",
      "incorrect-old-password": "Incorrect old password",
      "user-is-already-registered": "User is already registered.",
      "your-password-has-been-changed": "Your password has been changed.",
      "password-missing-uppercase": "The password doesn’t fulfill the requirements. Enter a password with at least 1 capital letter.",
      "invalid-verification-provided": "Expired link was used. Please click the link in the latest reset password email.",
      "email-used-by-different-user": "Email address is used by a different user.",
      "password-not-long-enough": "The password doesn’t fulfill the requirements. Enter a password with at least 8 characters.",
      "an-error-occurred": "An error occurred. Please try again later.",
      "attempt-limit-exceeded": "You tried too often to change your password. Wait a while and start the password change from begin.",
      "incorrect_old_password": "Incorrect old password",
      "password-missing-lowercase": "The password doesn’t fulfill the requirements. Enter a password with at least 1 small letter.",
      "generic-api-message": "Error: Please verify your input and type it again manually. If the error persists, contact our support."
    },
    "common": {
      "please-wait": "Please wait",
      "send-code": "Send the code.",
      "passwords-does-not-match": "Passwords do not match.",
      "your-account": "Your Hella Gutmann user account",
      "close": "Close",
      "please-fill-in-this-field": "Please fill in this field.",
      "hgsKey": "E-mail address (if you have created your personal user account) or customer number",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Manage your user profile with Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Please start the process again later.</0>If the problem occurs again, please contact the Customer Center.",
      "this-field-cannot-be-left-blank": "This field cannot be left blank.",
      "please-enter-your-login": "Please enter your login and we will send you a verification email.\n  Please click the verification button in the email.",
      "password-validation-error": "The password doesn’t fulfill the requirements.",
      "hide-password": "Hide Password",
      "go-to-login": "Go to Login",
      "invalid-characters": "You entered some values that are not valid. Please change your entry.",
      "first-name-and-last-name-too-short": "Please enter only alphabetical characters and a minimum of 2 characters.",
      "an-error-occurred": "An error occurred.",
      "please-enter-a-valid-email-address": "Please enter a valid email address. Allowed characters are alphanumeric characters and the following special characters",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "User does not exist.",
      "show-password": "Show Password",
      "no-number-and-email": "Please enter a valid email address or your customer number consisting solely of numbers.",
      "user-does-not-exist": "User does not exist.",
      "your-user-profile": "Your user profile",
      "enter-code": "Please enter the code."
    },
    "dashboard": {
      "logout": "Logout",
      "lead": "Please select the application that you want to access with your Hella Gutmann account.",
      "userProfile": "User Profile"
    },
    "dashboardInfo": {
      "back": "Back",
      "s20-please-start-device-content": "To be able to use the mega macs S 20, you require the mega macs S 20 app installed on your Android device. The app is available in the Play Store.",
      "x20-please-sign-in-title": "Login for CSC-Tool X 20",
      "x20-please-sign-in-content": "Please log in to your CSC-Tool X 20 with your Hella Gutmann Account.",
      "s20-please-start-device-title": "Login for mega macs S 20"
    },
    "errorMessage": {
      "error": "Error",
      "something-went-wrong": "Something went wrong."
    },
    "faq": {
      "howDoIChangePassword": "How can I change the password for the Hella Gutmann account?",
      "howDoIGetAHellaGutmannAccount": "How do I get a Hella Gutmann Account?",
      "possibleToUseMultipleAccounts": "The solution enables customers to log in securely to several Hella Gutmann applications and websites with just a single access and a single login.",
      "backToLogin": "Back to Login",
      "itIsASingleSignOnSolution": "The Hella Gutmann Account is the single sign-on solution (SSO) from Hella Gutmann. An e-mail address and a password of your choice are required for access",
      "title": "Frequently Asked Questions (FAQ)",
      "whatIsAHellaGutmannAccount": "What is the Hella Gutmann account?",
      "supportedAppsConstantlyExpanded": "The number of supported applications is constantly being expanded. The Hella Gutmann Account currently supports the following applications",
      "alternativeContactSupport": "Alternatively, please contact our support team.",
      "howDoIResetPassword": "How do I reset the password for the Hella Gutmann account?",
      "asSoonAsYouGetAccessToProducts": "As soon as you have purchased one of the supported products or have been authorized to access macs365, you will receive an e-mail to set up a Hella Gutmann account. The e-mail will be sent to the e-mail address we have on file via an automated process.",
      "whatToDoIfNoEMailReceived": "What can I do if I have not received the e-mail to set up the Hella Gutmann account?",
      "clickOnForgotPassword": "One option is to request the required e-mail via <1>Forgot password</1>. Please make sure that the e-mail address you enter matches the e-mail address we have on file.",
      "changeEmailOnUserProfile": "You can change the e-mail address of your Hella Gutmann Account, which you use for the login, under User profile (the user profile is currently available only for customers with access to macs365).",
      "changePasswordOnUserProfile": "You can change the password for the Hella Gutmann Account under User profile (the user profile is currently available only for customers with access to macs365).",
      "howDoIChangeEmailAddress": "How can I change the e-mail address for the Hella Gutmann account?",
      "whichAppsAreSupported": "Which applications are supported by the Hella Gutmann Account?"
    },
    "footer": {
      "imprint": "Imprint",
      "faq": "FAQ",
      "faq-heading": "Frequently Asked Questions (FAQ)",
      "data-privacy-policy": "Data Privacy Policy",
      "terms-and-conditions": "Terms & Conditions"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Sending an email was not possible because of too many failed attempts. Try again in a few hours.",
      "send-email": "Send",
      "reset-your-password": "Reset your password",
      "forgot-password-button-clicked-alert": "The email was sent successfully. The delivery might take up to a couple of minutes under certain circumstances.",
      "back-to-login": "Back to login",
      "enter-your-login-V2": "E-mail address",
      "please-enter-your-login": "Please enter your login and we will send you a verification email. Please click the verification button in the email.",
      "enter-your-login": "Your login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Choose a strong password and enter it into both fields.",
      "reset-your-password": "Set new password",
      "repeat-password": "Repeat new password",
      "a-verification-email-has-been-sent-to-you": "A verification email has been sent to you.",
      "reset-password": "Set Password",
      "new-password": "New password",
      "passwords-do-not-match": "Both passwords don’t match. Verify your entry."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Your new password is now ready to use.",
      "setting-new-password-successful": "Setting new password successful",
      "go-to-login": "Go to Login"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH\n\nAm Krebsbach 2\n\nD-79241 Ihringen\n\nTel: +49 7668 9900 888\n\nFax: +49 7668 9900 3999\n\ninfo@hella-gutmann.com\n\nSteuernummer: 07011/39801\n\nUSt-IdNr: DE 14 220 8666\n\nHandelsregister: HRB 290194, Freiburg\n\nCEO: Adnan Cemal",
      "header": "Imprint",
      "back": "Back to login"
    },
    "menu": {
      "digital-products": "Digital Products"
    },
    "migration": {
      "helper-text-surname": "Enter your last name",
      "description-submit": "Once you submitted the form, we will send you a message to the entered email address. Click on the button in this message to confirm your email.",
      "firstname": "First name",
      "description-login": "Afterwards you login with your email address and your existing password. A login with your customer number won’t be possible anymore.",
      "submit": "Submit",
      "email": "Email address",
      "page-title": "Your Hella Gutmann user account",
      "helper-text-firstname": "Enter your first name.",
      "surname": "Last name",
      "title": "Change of your login",
      "helper-text-email": "Enter your email address",
      "description-user-account": "Hella Gutmann introduces personalized user accounts. Enter here your first name, your last name and an email address for your personal user account."
    },
    "migrationError": {
      "go-to-login": "Go to Login",
      "your-email-address-could-not-get-confirmed": "Your email address couldn't get confirmed. Most probably as the link in your email had already been expired when you clicked it. Please login with your again and start the process from Begin.",
      "change-of-your-login-failed": "Change of your login failed"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": " <strong>We sent you an email</strong> to the entered email address. To confirm your email address, go to your mailbox and <strong>click on the button in the email</strong>.",
      "for-security-reasons": "For security reasons the link expires after 24 hours. In that case re-start the process.",
      "sending-successful": "Sending successful"
    },
    "migrationVerify": {
      "verification-button": "Verify",
      "verification-header": "Verification of user account",
      "verification-description": "Please click the button to verify the creation of your personalized user account"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Email address confirmed",
      "from-now-on-please-login-with-the-email": "From now on please login with the email address and your password.",
      "your-email-address-has-been-confirmed": "Your email address has been confirmed."
    },
    "needHelp": {
      "for-further-questions": "For further questions our hotline<1/> is available Monday to Friday from 8:00 am to 5:00 pm.",
      "need-help-logging-in": "Need help logging in?",
      "here-you-will-find": "<0>Here</0> you will find solutions to <2>frequently asked questions.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "small letter",
      "uppercase-letter": "capital letter",
      "the-new-password-requires": "Password restrictions:",
      "characters": "characters",
      "number": "number"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Cancellation Period"
    },
    "settings": {
      "user-information-saved": "User Information saved.",
      "update-user-information": "Update user information",
      "new-password": "New password",
      "resend-verification": "Resend Verification",
      "save": "Save",
      "language-preference-saved": "Language preference saved.",
      "email-has-been-sent": "A verification email has been sent to you.",
      "firstname": "First name",
      "repeat-password": "Repeat password",
      "your-user-data": "User profile",
      "set-new-password": "Set new password",
      "email-is-not-verified-yet": "Email is not verified yet",
      "old-password": "Old password",
      "new-login-info": "Keep in mind that your new email address will also be your login.",
      "update-your-email": "Update your email address",
      "email": "Email address",
      "incorrect-username-or-password": "Incorrect password.",
      "back": "Back",
      "resend": "Resend",
      "update-your-language": "Language preference",
      "surname": "Last name",
      "passwords-do-not-match": "Both passwords don’t match. Verify your entry.",
      "submit-new-email-info": "When you submit a new email address, we will send you a confirmation email. Click the link in that email to confirm your new email address.",
      "this-language-will-be-used": "This language will be used for your personalized user account and emails. It does not affect invoice emails."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Forgot your password?",
      "your-login-V2": "E-mail address",
      "your-password": "Your password",
      "sign-in-at-hella-gutmann": "Sign in to your Hella Gutmann account"
    },
    "signUp": {
      "noMatchedPasswords": "The passwords do not match.",
      "noMatchedEmails": "The email addresses do not match.",
      "lead": "Enter information in order to create a Hella Gutmann account.",
      "descriptionUserAccountV2": "Hella Gutmann introduces personalized user accounts. Enter here your first name, your last name and a password for your personal user account.",
      "password": "Password",
      "descriptionLogin": "After verification you can login with your email address and your password.",
      "passwordLead": "Choose a strong password and enter it into both fields.",
      "familyName": "Last name",
      "repeatEmail": "Repeat email address",
      "header": "Sign up",
      "email": "Email address",
      "signup": "Sign Up",
      "givenName": "First name",
      "repeatPassword": "Repeat password",
      "descriptionUserAccount": "Hella Gutmann introduces personalized user accounts. Enter here your first name, your last name, your email address and a password for your personal user account."
    },
    "signUpComplete": {
      "header": "Registration completed",
      "info": "Please regard: To be able to log in to your Hella Gutmann Account, you will use the password given just this moment and the e-mail address to which we have sent the registration e-mail.",
      "yourUserProfile": "Your user profile"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Sending successful",
      "forSecurityReasons": "For security reasons the link expires after 24 hours. In that case login with your old credentials again and re-start the process.",
      "weSentYouAnEmail": "<0>We sent you an email</0> to the entered email address. To confirm your email address, go to your mailbox and <2>click on the button in the email</2>.",
      "for-security-reasons": "For security reasons the link expires after 24 hours. In that case re-start the process."
    },
    "signUpVerify": {
      "description": "Please click the button to verify the creation of your personalized user account",
      "header": "Verification of user account",
      "button": "Verify"
    },
    "test": {
      "uwetest": "<0>Here</0> you will find solutions to <2>frequently asked questions.</2>"
    },
    "verify": {
      "verification-description": "Please click the button to verify your email address",
      "verification-header": "Verification of email address",
      "verification-button": "VERIFY"
    },
    "verifySuccess": {
      "your-user-profile": "Your user profile",
      "from-now-on-we-will-send-you-messages": "Going forward, we will send messages related to your user account to this e-mail address.",
      "keep-in-mind-that-this-email": "This e-mail address is also your new username for your login.",
      "change-of-email-address-successful": "Your e-mail address was confirmed"
    },
    "wizard": {
      "close": "Close macs365"
    }
  },
  "de": {
    "FAQModal": {
      "use-email-instead-of-customer": "Statt Ihre Kundennummer, nutzen Sie bitte Ihre E-Mail-Adresse um Ihr Passwort zurückzusetzen.",
      "missing-verification-email": "Ich bekomme die Bestätigungs-E-Mail nicht.",
      "missing-forgot-password-email": "Ich bekomme die \"Passwort vergessen\" E-mail nicht.",
      "creating-your-personalized": "Sie versuchen Ihr persönliches Nutzerkonto direkt mit Ihrer E-Mail-Adresse zu erstellen. Loggen Sie bitte sich erst mit Ihrer Kundennummer und folgen Sie die Schritte um Ihr persönliches Nutzerkonto zu erstellen.",
      "use-email-instead-of-your-customer": "Statt Ihre Kundennummer, nutzen Sie bitte Ihre E-Mail-Adresse beim Einloggen.",
      "frequently-asked-questions": "Häufig gestellten Fragen",
      "personalized-user-account": "Haben Sie Ihr persönliches Nutzerkonto erstellt?",
      "no": "Nein",
      "use-customer-without-de": "Nutzen Sie bitte Ihre Kundennummer (ohne das \"DE\"-Präfix) um Ihr Passwort zurückzusetzen.",
      "yes": "Ja",
      "use-customer-without-de-prefix": "Nutzen Sie bitte Ihre Kundennummer (ohne das \"DE\"-Präfix) um einzuloggen und folgen Sie die Schritte um Ihr persönliches Nutzerkonto zu erstellen.",
      "i-cannot-sign-in-to-my-account": "Ich kann mich nicht anmelden."
    },
    "api": {
      "incorrect-username-or-password": "Falscher Benutzername oder falsches Passwort.",
      "invalid-code-provided": "Es ist ein Fehler aufgetreten. Starten Sie die Passwortänderung von vorn.",
      "user-does-not-exist": "Benutzer existiert nicht",
      "password-validation-error": "Das Passwort entspricht nicht den Anforderungen.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Benutzer existiert nicht",
      "password-missing-number": "Das Passwort entspricht nicht den Anforderungen. Geben Sie ein Passwort mit min. 1 Ziffer ein.",
      "incorrect-old-password": "Falsches altes Passwort",
      "user-is-already-registered": "Der Benutzer ist bereits registriert.",
      "your-password-has-been-changed": "Ihr Passwort wurde geändert.",
      "password-missing-uppercase": "Das Passwort entspricht nicht den Anforderungen. Geben Sie ein Passwort mit min. 1 Großbuchstaben ein.",
      "invalid-verification-provided": "Abgelaufener Link wurde verwendet. Bitte klicken Sie auf den Link in der letzten \"Passwort Zurücksetzen\" E-Mail.",
      "email-used-by-different-user": "Die E-Mail-Adresse wird von einem anderen Benutzer verwendet.",
      "password-not-long-enough": "Das Passwort entspricht nicht den Anforderungen. Geben Sie ein Passwort mit min. 8 Stellen ein.",
      "an-error-occurred": "Es ist ein Fehler aufgetreten. Bitte probieren Sie es später noch einmal.",
      "attempt-limit-exceeded": "Sie haben zu oft versucht, das Passwort zu wechseln. Warten Sie eine Weile und starten Sie die Passwortänderung von vorn.",
      "incorrect_old_password": "Falsches altes Passwort",
      "password-missing-lowercase": "Das Passwort entspricht nicht den Anforderungen. Geben Sie ein Passwort mit min. 1 Kleinbuchstaben ein.",
      "generic-api-message": "Bitten überprüfen Sie Ihre Eingabe. Tippen Sie es erneut per Hand ein. Wenn der Fehler weiterhin besteht, kontaktieren Sie unseren Support."
    },
    "common": {
      "please-wait": "Bitte warten",
      "send-code": "Code Senden",
      "passwords-does-not-match": "Die Passwörter stimmen nicht überein.",
      "your-account": "Ihr Hella Gutmann Nutzerkonto",
      "close": "Schließen",
      "please-fill-in-this-field": "Bitte füllen Sie dieses Feld aus.",
      "hgsKey": "E-Mail-Adresse (falls Sie Ihr persönliches Nutzerkonto erstellt haben) oder Kundennummer",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Verwalten Sie Ihr Benutzerprofil mit Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Starten Sie den Vorgang später noch einmal.</0> Sollte das Problem noch einmal auftreten, kontaktieren Sie bitte das Customer Center.",
      "this-field-cannot-be-left-blank": "Dieses Feld darf nicht leer gelassen werden.",
      "please-enter-your-login": "Bitte geben Sie hier Ihr Login ein. Wir werden Ihnen dann einen 6-stelligen Code an Ihre E-Mail-Adresse schicken. Geben Sie diesen Code auf der folgenden Seite ein. Schließen Sie nicht Ihren Browser.",
      "password-validation-error": "Das Passwort entspricht nicht den Anforderungen.",
      "hide-password": "Passwort Verbergen",
      "go-to-login": "Zum Einloggen",
      "invalid-characters": "Sie haben unzulässige Zeichen eingegeben. Bitte ändern Sie Ihre Eingabe.",
      "first-name-and-last-name-too-short": "Bitte geben Sie nur alphabetische Zeichen und mindestens zwei Zeichen ein.",
      "an-error-occurred": "Ein Fehler ist aufgetreten",
      "please-enter-a-valid-email-address": "Bitte geben Sie eine gültige E-Mail-Adresse ein. Erlaubte Zeichen sind alphanumerische Zeichen und die folgenden Sonderzeichen: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Benutzer existiert nicht",
      "show-password": "Passwort Anzeigen",
      "no-number-and-email": "Bitte geben Sie eine gültige E-Mail-Adresse oder Ihre ausschließlich aus Zahlen bestehende Kundennummer ein.",
      "user-does-not-exist": "Benutzer existiert nicht",
      "your-user-profile": "Ihr Nutzerprofil",
      "enter-code": "Geben Sie den Code ein"
    },
    "dashboard": {
      "logout": "Abmelden",
      "lead": "Bitte wählen Sie die Anwendung aus, auf welche Sie mit Ihrem Hella Gutmann Account zugreifen wollen.",
      "userProfile": "Benutzerprofil"
    },
    "dashboardInfo": {
      "back": "Zurück",
      "s20-please-start-device-content": "Bitte starten Sie die S 20 App auf Ihrem Android Gerät und melden Sie sich dort mit Ihrem Hella Gutmann Account ein.",
      "x20-please-sign-in-title": "Anmeldung bei CSC-Tool X 20",
      "x20-please-sign-in-content": "Bitte loggen Sie sich mit Ihrem Hella Gutmann Account auf ihrem CSC-Tool X 20 ein.",
      "s20-please-start-device-title": "Anmeldung bei mega macs S 20"
    },
    "errorMessage": {
      "error": "Fehler",
      "something-went-wrong": "Etwas lief nicht in Ordnung."
    },
    "faq": {
      "howDoIChangePassword": "Wie kann ich das Passwort für den Hella Gutmann Account ändern?",
      "howDoIGetAHellaGutmannAccount": "Wie erhalte ich einen Hella Gutmann Account?",
      "possibleToUseMultipleAccounts": "Die Lösung ermöglicht es Kunden, sich sicher bei mehreren Anwendungen und Webseiten von Hella Gutmann mit nur einem einzigen Zugang und einer einmaligen Anmeldung einzuloggen.",
      "backToLogin": "ZURÜCK ZUM EINLOGGEN",
      "itIsASingleSignOnSolution": "Der Hella Gutmann Account ist die Single Sign-on Lösung (SSO) von Hella Gutmann. Für den Zugang ist eine E-Mail-Adresse und ein selbst gewähltes Passwort erforderlich.",
      "title": "Häufig gestellte Fragen (FAQ)",
      "whatIsAHellaGutmannAccount": "Was ist der Hella Gutmann Account?",
      "supportedAppsConstantlyExpanded": "Die Anzahl der unterstützen Anwendungen wird kontinuierlich erweitert. Derzeit unterstützt der Hella Gutmann Account die folgenden Anwendungen",
      "alternativeContactSupport": "Alternativ kontaktieren Sie bitte unseren Support.",
      "howDoIResetPassword": "Wie setze ich das Passwort für den Hella Gutmann Account zurück?",
      "asSoonAsYouGetAccessToProducts": "Sobald Sie eines der unterstützen Produkte erworben haben oder zum Zugriff auf macs365 berechtigt wurden, erhalten Sie eine E-Mail zur Einrichtung eines Hella Gutmann Accounts. Die E-Mail wird   über einen automatisierten Prozess an die bei uns hinterlegte E-Mail-Adresse gesendet.",
      "whatToDoIfNoEMailReceived": "Was kann ich tun, wenn ich die E-Mail zur Einrichtung des Hella Gutmann Accounts nicht erhalten habe?",
      "clickOnForgotPassword": "Eine Möglichkeit ist, die erforderliche E-Mail über <1>Passwort vergessen</1> anzufordern. Beachten Sie dabei, dass die eingegebene E-Mail-Adresse mit der bei uns hinterlegten E-Mail-Adresse übereinstimmt.",
      "changeEmailOnUserProfile": "Sie können die E-Mail-Adresse Ihres Hella Gutmann Accounts, welche Sie für den Login verwenden, über die Seite Benutzerprofil ändern (das Benutzerprofil steht derzeit nur Kunden mit Zugang zu macs365 zur Verfügung)",
      "changePasswordOnUserProfile": "Sie können das Passwort für den Hella Gutmann Account über die Seite Benutzerprofil ändern (das Benutzerprofil steht derzeit nur Kunden mit Zugang zu macs365 zur Verfügung).",
      "howDoIChangeEmailAddress": "Wie kann ich die E-Mail-Adresse für den Hella Gutmann Account ändern?",
      "whichAppsAreSupported": "Welche Anwendungen werden vom Hella Gutmann Account unterstützt?"
    },
    "footer": {
      "imprint": "Impressum",
      "faq": "FAQ",
      "faq-heading": "Häufig gestellte Fragen (FAQ)",
      "data-privacy-policy": "Datenschutzerklärung",
      "terms-and-conditions": "Nutzungsbedingungen"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Das Versenden einer E-Mail war aufgrund zu vieler Fehlversuche nicht möglich. Versuchen Sie es in ein paar Stunden erneut.",
      "send-email": "Abschicken",
      "reset-your-password": "Ihr Passwort zurücksetzen",
      "forgot-password-button-clicked-alert": "E-Mail wurde erfolgreich verschickt. Unter Umständen kann die Zustellung ein Paar Minuten dauern.",
      "back-to-login": "Zurück zum Einloggen",
      "enter-your-login-V2": "E-Mail-Adresse",
      "please-enter-your-login": "Bitte geben Sie Ihr Login ein und wir senden Ihnen eine Bestätigungs-E-Mail. Bitte klicken Sie auf die Verifizierungsschaltfläche in der E-Mail.",
      "enter-your-login": "Ihr Login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Wählen Sie ein sicheres Passwort und geben Sie es in beide Felder ein.",
      "reset-your-password": "Neues Passwort setzen",
      "repeat-password": "Neues Passwort wiederholen",
      "a-verification-email-has-been-sent-to-you": "Eine Bestätigungs-E-Mail wurde an Sie gesendet.",
      "reset-password": "Passwort Setzen",
      "new-password": "Neues Passwort",
      "passwords-do-not-match": "Die beiden Passwörter stimmen nicht überein. Überprüfen Sie Ihre Eingabe."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Ihr neues Passwort ist nun einsatzbereit. ",
      "setting-new-password-successful": "Neues Passwort erfolgreich gesetzt!",
      "go-to-login": "Zum Einloggen"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH\n\nAm Krebsbach 2\n\nD-79241 Ihringen\n\nTel.: +49 7668 9900 888\n\nFax: +49 7668 9900 3999\n\ninfo@hella-gutmann.com\n\nSteuernummer: 07011/39801\n\nUSt-IdNr: DE 14 220 8666\n\nHandelsregister: HRB 290194, Freiburg\n\nCEO: Adnan Cemal",
      "header": "Impressum",
      "back": "ZURÜCK ZUM EINLOGGEN"
    },
    "menu": {
      "digital-products": "Digitale Produkte"
    },
    "migration": {
      "helper-text-surname": "Geben Sie einen Nachnamen ein",
      "description-submit": "Nachdem Sie das Formular abgeschickt haben, senden wir Ihnen eine Nachricht an die angegebene E-Mail-Adresse. Klicken Sie auf den Verifizierungsschaltfläche in dieser Nachricht, um Ihre E-Mail-Adresse zu bestätigen.",
      "firstname": "Vorname",
      "description-login": "Loggen Sie sich danach mit Ihrer E-Mail-Adresse und Ihrem aktuellen Passwort ein. Ein Login mit Ihrer Kundennummer wird nicht mehr möglich sein.",
      "submit": "Abschicken",
      "email": "E-Mail-Adresse",
      "page-title": "Ihr Hella Gutmann Nutzerkonto",
      "helper-text-firstname": "Geben Sie einen Vornamen ein",
      "surname": "Nachname",
      "title": "Umstellung Ihres Logins",
      "helper-text-email": "Geben Sie eine E-Mail-Adresse ein",
      "description-user-account": "Hella Gutmann stellt um auf persönliche Nutzerkonten. Geben Sie hier einen Vornamen, einen Nachnamen und eine E-Mail-Adresse für Ihr persönliches Nutzerkonto ein."
    },
    "migrationError": {
      "go-to-login": "Zum Einloggen",
      "your-email-address-could-not-get-confirmed": "Ihre neue E-Mail-Adresse konnte nicht bestätigt werden. Höchstwahrscheinlich war der Link in Ihrer E-Mail bereits abgelaufen. Bitte melden Sie sich erneut an und starten Sie den Vorgang von Beginn.",
      "change-of-your-login-failed": "Umstellung Ihres Logins fehlgeschlagen"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Wir haben Ihnen eine E-Mail</0> an die eingegebene E-Mail-Adresse gesendet. Um die E-Mail-Adresse zu bestätigen, gehen Sie zu Ihrem Postfach und <2>klicken Sie auf den Verifizierungsschaltfläche in der E-Mail</2>.",
      "for-security-reasons": "Aus Sicherheitsgründen wird der Link nach 24 Stunden ungültig. Falls dieser Fall eintritt, starten Sie den Vorgang erneut.",
      "sending-successful": "Übermittlung erfolgreich"
    },
    "migrationVerify": {
      "verification-button": "Bestätigen",
      "verification-header": "Bestätigung des Benutzerkontos",
      "verification-description": "Klicken Sie bitte auf den Button, um die Erstellung Ihres personalisierten Benutzerkontos zu bestätigen"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "E-Mail-Adresse bestätigt",
      "from-now-on-please-login-with-the-email": "Melden Sie sich von nun an mit dieser E-Mail-Adresse und Ihrem Passwort an.",
      "your-email-address-has-been-confirmed": "Ihre E-Mail-Adresse wurde bestätigt"
    },
    "needHelp": {
      "for-further-questions": "Für weitere Fragen ist unsere Hotline<1/> Montags bis Freitags von 8:00 bis 17:00 für Sie erreichbar.",
      "need-help-logging-in": "Brauchen Sie Hilfe beim Einloggen?",
      "here-you-will-find": "<0>Hier</0> finden Sie Lösungen zu <2>häufig gestellten Fragen.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "kleiner Buchstabe",
      "uppercase-letter": "großer Buchstabe",
      "the-new-password-requires": "Passwortvorgaben:",
      "characters": "Stellen",
      "number": "Ziffer"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Kündigungsfrist"
    },
    "settings": {
      "user-information-saved": "Nutzerinformationen wurden gespeichert.",
      "update-user-information": "Nutzerprofil",
      "new-password": "Neues Passwort",
      "resend-verification": "Verifizierung erneut senden",
      "save": "Speichern",
      "language-preference-saved": "Spracheinstellung wurde gespeichert.",
      "email-has-been-sent": "Eine Bestätigungs-E-Mail wurde an Sie gesendet.",
      "firstname": "Vorname",
      "repeat-password": "Passwort wiederholen",
      "your-user-data": "Ihre Nutzerdaten",
      "set-new-password": "Neues Passwort festlegen",
      "email-is-not-verified-yet": "E-Mail ist noch nicht verifiziert",
      "old-password": "Altes Passwort",
      "new-login-info": "Denken Sie daran, dass Ihre neue E-Mail-Adresse auch Ihr Login sein wird.",
      "update-your-email": "Aktualisieren Sie Ihre E-Mail-Adresse",
      "email": "E-Mail-Adresse",
      "incorrect-username-or-password": "Falsches Passwort.",
      "back": "Zurück",
      "resend": "Erneut senden",
      "update-your-language": "Bevorzugte Sprache",
      "surname": "Nachname",
      "passwords-do-not-match": "Die beiden Passwörter stimmen nicht überein. Überprüfen Sie Ihre Eingabe.",
      "submit-new-email-info": "Wenn Sie eine neue E-Mail-Adresse angeben, senden wir Ihnen eine Bestätigungs-E-Mail. Klicken Sie auf den Link in dieser E-Mail, um Ihre neue E-Mail-Adresse zu bestätigen.",
      "this-language-will-be-used": "Diese Sprache wird für Ihr persönliches Benutzerkonto und Ihre E-Mails verwendet. Rechnungs-E-Mails sind davon nicht betroffen."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Passwort vergessen?",
      "your-login-V2": "E-Mail-Adresse",
      "your-password": "Ihr Passwort",
      "sign-in-at-hella-gutmann": "Bei Hella Gutmann einloggen"
    },
    "signUp": {
      "noMatchedPasswords": "Die Passwörter stimmen nicht überein.",
      "noMatchedEmails": "The Email Adressen stimmen nicht überein.",
      "lead": "Geben Sie Ihre Informationen ein, um ein Hella Gutmann-Konto zu erstellen.",
      "descriptionUserAccountV2": "Hella Gutmann stellt um auf persönliche Nutzerkonten. Geben Sie hier einen Vornamen, einen Nachnamen und ein Passwort für Ihr persönliches Nutzerkonto ein.",
      "password": "Passwort",
      "descriptionLogin": "Nach der Überprüfung loggen Sie sich danach mit Ihrer E-Mail-Adresse und Ihrem Passwort ein.",
      "passwordLead": "Wählen Sie ein sicheres Passwort und geben Sie es in beide Felder ein.",
      "familyName": "Nachname",
      "repeatEmail": "E-Mail-Adresse wiederholen",
      "header": "Registrierung",
      "email": "E-Mail-Adresse",
      "signup": "Registrieren",
      "givenName": "Vorname",
      "repeatPassword": "Passwort wiederholen",
      "descriptionUserAccount": "Hella Gutmann stellt um auf persönliche Nutzerkonten. Geben Sie hier einen Vornamen, einen Nachnamen, eine E-Mail-Adresse und ein Passwort für Ihr persönliches Nutzerkonto ein."
    },
    "signUpComplete": {
      "header": "Registrierung erfolgreich",
      "info": "Bitte beachten Sie: Um sich bei Ihrem Hella Gutmann Account anzumelden, verwenden Sie neben dem gerade vergebenen Passwort, die E-Mail-Adresse, an die wir die Registrierungs-E-Mail gesendet haben.",
      "yourUserProfile": "Ihr Nutzerprofil"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Übermittlung erfolgreich",
      "forSecurityReasons": "Aus Sicherheitsgründen wird der Link nach 24 Stunden ungültig. Falls dieser Fall eintritt loggen Sie sich erneut mit Ihren alten Zugangsdaten ein und starten Sie den Vorgang erneut.",
      "weSentYouAnEmail": "<0>Wir haben Ihnen eine E-Mail</0> an die eingegebene E-Mail-Adresse gesendet. Um die E-Mail-Adresse zu bestätigen, gehen Sie zu Ihrem Postfach und <2>klicken Sie auf den Verifizierungsschaltfläche in der E-Mail</2>.",
      "for-security-reasons": "Aus Sicherheitsgründen wird der Link nach 24 Stunden ungültig. Falls dieser Fall eintritt, starten Sie den Vorgang erneut."
    },
    "signUpVerify": {
      "description": "Klicken Sie bitte auf den Button, um die Erstellung Ihres personalisierten Benutzerkontos zu bestätigen",
      "header": "Bestätigung des Benutzerkontos",
      "button": "Bestätigen"
    },
    "test": {
      "uwetest": "<0>Here</0> you will find solutions to <2>frequently asked questions.</2>"
    },
    "verify": {
      "verification-description": "Klicken Sie bitte auf den Button, um Ihre E-Mail-Adresse zu bestätigen",
      "verification-header": "Bestätigung der E-Mail-Adresse",
      "verification-button": "BESTÄTIGEN"
    },
    "verifySuccess": {
      "your-user-profile": "Ihr Nutzerprofil",
      "from-now-on-we-will-send-you-messages": "Wir werden Nachrichten, die Ihr Benutzerkonto betreffen, künftig an diese E-Mail-Adresse senden.",
      "keep-in-mind-that-this-email": "Diese E-Mail-Adresse ist auch Ihr neuer Benutzername beim Login.",
      "change-of-email-address-successful": "Ihre E-Mail-Adresse wurde bestätigt"
    },
    "wizard": {
      "close": "macs365 schliessen"
    }
  },
  "sv": {
    "FAQModal": {
      "use-email-instead-of-customer": "Använd din e-postadress istället för ditt kundnummer för att återställa ditt lösenord.",
      "missing-verification-email": "Jag har inte fått något bekräftelsemejl.",
      "missing-forgot-password-email": "Jag får inget e-postmeddelande \"Glömt lösenordet\".",
      "creating-your-personalized": "Du försöker att skapa ditt personliga användarkonto med din e-postadress. Logga först in med ditt kundnummer och följ instruktionerna för att skapa ditt personliga användarkonto.",
      "use-email-instead-of-your-customer": "Använd din e-postadress istället för ditt kundnummer för att logga in.",
      "frequently-asked-questions": "Frågor och svar",
      "personalized-user-account": "Har du skapat ditt personliga användarkonto?",
      "no": "Nej",
      "use-customer-without-de": "Använd ditt kundnummer (utan prefix \"DE\") för att återställa ditt lösenord.",
      "yes": "Ja",
      "use-customer-without-de-prefix": "Använd ditt kundnummer (utan prefix \"DE\") för att logga in och följ instruktionerna för att skapa ditt personliga användarkonto.",
      "i-cannot-sign-in-to-my-account": "Jag kan inte logga in."
    },
    "api": {
      "incorrect-username-or-password": "Fel användarnamn eller fel lösenord.",
      "invalid-code-provided": "Ett fel har uppstått. Starta ändringen av lösenordet på nytt.",
      "user-does-not-exist": "Användaren existerar inte",
      "password-validation-error": "Lösenordet uppfyller inte kraven.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Användaren existerar inte",
      "password-missing-number": "Lösenordet uppfyller inte kraven. Ange ett lösenord med minst 1 siffra.",
      "incorrect-old-password": "Felaktigt gammalt lösenord",
      "user-is-already-registered": "Användaren är redan registrerad.",
      "your-password-has-been-changed": "Ditt lösenord har ändrats.",
      "password-missing-uppercase": "Lösenordet uppfyller inte kraven. Ange ett lösenord med minst 1 stor bokstav.",
      "invalid-verification-provided": "Du har använt en ogiltig länk. Klicka på länken i det senaste e-postmeddelandet \"Återställa lösenord\".",
      "email-used-by-different-user": "E-postadressen används av en annan användare.",
      "password-not-long-enough": "Lösenordet uppfyller inte kraven. Ange ett lösenord med minst 8 tecken.",
      "an-error-occurred": "Ett fel har uppstått. Försök igen senare.",
      "attempt-limit-exceeded": "Du har försökt att ändra ditt lösenord för ofta. Vänta ett tag och starta ändringen av lösenordet på nytt.",
      "incorrect_old_password": "Felaktigt gammalt lösenord",
      "password-missing-lowercase": "Lösenordet uppfyller inte kraven. Ange ett lösenord med minst 1 liten bokstav.",
      "generic-api-message": "Kontrollera dina uppgifter. Skriv in för hand igen. Kontakta vår support om felet kvarstår."
    },
    "common": {
      "please-wait": "Var god vänta",
      "send-code": "Skicka kod",
      "your-account": "Ditt användarkonto hos Hella Gutmann",
      "close": "Stäng",
      "please-fill-in-this-field": "Fyll i detta fält.",
      "hgsKey": "E-postadress (om du har skapat ditt personliga användarkonto) eller kundnummer",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Hantera din användarprofil med Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Starta proceduren senare igen.</0> Kontakta kundtjänst om problemet inträffar igen.",
      "this-field-cannot-be-left-blank": "Fältet får inte vara tomt.",
      "please-enter-your-login": "Ange ditt användarnamn för inloggningen. Vi skickar då en kod bestående av 6 tecken till din e-postadress. Ange denna kod på följande sida. Stäng inte din webbläsare.",
      "password-validation-error": "Lösenordet uppfyller inte kraven.",
      "hide-password": "Dölj lösenordet",
      "go-to-login": "Till inloggning",
      "invalid-characters": "Du har använt ej tillåtna tecken. Ändra dina uppgifter.",
      "first-name-and-last-name-too-short": "Ange bara alfabetiska tecken och åtminstone två tecken.",
      "an-error-occurred": "Ett fel har inträffat",
      "please-enter-a-valid-email-address": "Ange en giltig e-postadress. Alfanumeriska tecken är tillåtna samt följande specialtecken: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Användaren existerar inte",
      "show-password": "Visa lösenordet",
      "no-number-and-email": "Ange en giltig e-postadress eller ditt kundnummer som bara består av siffror.",
      "passwords-does-not-match": "Lösenorden stämmer inte överens.",
      "user-does-not-exist": "Användaren existerar inte",
      "your-user-profile": "Din användarprofil",
      "enter-code": "Ange koden"
    },
    "dashboard": {
      "logout": "Logga ut",
      "lead": "Välj den applikation som du vill komma åt med ditt Hella Gutmann-konto."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "För att kunna använda mega macs S 20 måste mega macs S 20-appen vara installerad på din Android-enhet. Appen finns tillgänglig via Play Store.",
      "x20-please-sign-in-title": "\t\nInloggning till CSC-Tool X 20",
      "x20-please-sign-in-content": "Vänligen logga in på din CSC-Tool X 20 med ditt Hella Gutmann-konto.",
      "s20-please-start-device-title": "Inloggning till mega macs S 20"
    },
    "errorMessage": {
      "error": "Fel",
      "something-went-wrong": "Något gick fel."
    },
    "faq": {
      "howDoIChangePassword": "Hur kan jag ändra lösenordet för Hella Gutmann-kontot?",
      "howDoIGetAHellaGutmannAccount": "Hur skaffar jag ett Hella Gutmann-konto?",
      "possibleToUseMultipleAccounts": "Lösningen gör det möjligt för kunderna att logga in säkert på flera av Hella Gutmanns applikationer och webbplatser med bara en enda åtkomst och en enda inloggning.",
      "backToLogin": "TILLBAKA TILL INLOGGNINGEN",
      "itIsASingleSignOnSolution": "Hella Gutmann-kontot är Hella Gutmanns Single Sign-On-lösning (SSO). För åtkomst krävs en e-postadress och ett lösenord som du själv väljer.",
      "title": "Vanliga frågor (FAQ)",
      "whatIsAHellaGutmannAccount": "Vad är Hella Gutmann-kontot?",
      "supportedAppsConstantlyExpanded": "Antalet applikationer som stöds utökas ständigt. Hella Gutmann-kontot stöder för närvarande följande applikationer",
      "alternativeContactSupport": "Alternativt kan du kontakta vårt supportteam.",
      "howDoIResetPassword": "Hur återställer jag lösenordet för Hella Gutmann-kontot?",
      "asSoonAsYouGetAccessToProducts": "Så snart du har köpt en av de produkter som stöds eller har fått behörighet till macs365 kommer du att få ett e-postmeddelande om att skapa ett Hella Gutmann-konto. E-postmeddelandet skickas till den e-postadress som vi har registrerad via en automatiserad process.",
      "whatToDoIfNoEMailReceived": "Vad kan jag göra om jag inte har fått e-postmeddelandet om att skapa ett Hella Gutmann-konto?",
      "clickOnForgotPassword": "Ett alternativ är att begära den nödvändiga e-postadressen via <1>Glömt lösenord</1>. Se till att den e-postadress du anger stämmer överens med den e-postadress vi har registrerad.",
      "changeEmailOnUserProfile": "Du kan ändra den e-postadress som du använder för att logga in till ditt Hella Gutmann-konto på sidan Användarprofil (användarprofilen är för närvarande endast tillgänglig för kunder med tillgång till macs365).",
      "changePasswordOnUserProfile": "Du kan ändra lösenordet för Hella Gutmann-kontot på sidan Användarprofil (användarprofilen är för närvarande endast tillgänglig för kunder med tillgång till macs365).",
      "howDoIChangeEmailAddress": "Hur kan jag ändra e-postadressen för Hella Gutmann-kontot?",
      "whichAppsAreSupported": "Vilka applikationer stöds av Hella Gutmann-kontot?"
    },
    "footer": {
      "imprint": "Ansvarig utgivare",
      "faq": "FAQ",
      "faq-heading": "Vanliga frågor (FAQ)",
      "data-privacy-policy": "Integritetsförklaring",
      "terms-and-conditions": "Användarvillkor"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Det gick inte att skicka ett e-postmeddelande eftersom för många felaktiga försök har gjorts. Försök igen om ett par timmar.",
      "send-email": "Skicka",
      "reset-your-password": "Återställ lösenordet",
      "forgot-password-button-clicked-alert": "E-postmeddelandet har skickats. Det kan i vissa fall ta ett par minuter innan du får meddelandet.",
      "back-to-login": "Tillbaka till inloggning",
      "enter-your-login-V2": "E-postadressen",
      "please-enter-your-login": "Ange ditt användarnamn för inloggningen. Vi skickar då ett bekräftelsemejl. Klicka på verifieringsfältet i e-postmeddelandet.",
      "enter-your-login": "Ditt användarnamn"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Välj ett säkert lösenord och ange detta i båda fälten.",
      "reset-your-password": "Ställ in nytt lösenord",
      "repeat-password": "Upprepa det nya lösenordet",
      "a-verification-email-has-been-sent-to-you": "Det har nu skickats ett bekräftelsemejl.",
      "reset-password": "Ställ in lösenord",
      "new-password": "Nytt lösenord",
      "passwords-do-not-match": "De två lösenorden stämmer inte överens. Kontrollera dina uppgifter."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Nu kan du använda ditt nya lösenord.",
      "setting-new-password-successful": "Det nya lösenordet har ställts in!",
      "go-to-login": "Till inloggning"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTelefon: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nSkattenummer: 07011/39801 \n\nmomsregistreringsnummer: DE 14 220 8666 \n\nHandelsregister: HRB 290194, Freiburg \n\nVD: Adnan Cemal",
      "header": "Ansvarig utgivare",
      "back": "TILLBAKA TILL INLOGGNINGEN"
    },
    "menu": {
      "digital-products": "Digitala produkter"
    },
    "migration": {
      "helper-text-surname": "Ange ett efternamn",
      "description-submit": "När du har skickat in formuläret skickar vi ett meddelande till den e-postadress som du har angett. Klicka på verifieringsknappen i detta meddelande för att bekräfta din e-postadress.",
      "firstname": "Förnamn",
      "description-login": "Logga sedan in med din e-postadress och ditt nuvarande lösenord. Det kommer inte längre att vara möjligt att logga in med ditt kundnummer.",
      "submit": "Skicka",
      "email": "E-postadress",
      "page-title": "Ditt användarkonto hos Hella Gutmann",
      "helper-text-firstname": "Ange ett förnamn",
      "surname": "Efternamn",
      "title": "Ändra din inloggning",
      "helper-text-email": "Ange en e-postadress",
      "description-user-account": "Hella Gutmann går över till personliga användarkonton. Ange förnamn, efternamn och en e-postadress för ditt personliga användarkonto här."
    },
    "migrationError": {
      "go-to-login": "Till inloggning",
      "your-email-address-could-not-get-confirmed": "Din nya e-postadress kunde inte bekräftas. Troligen har länken i ditt e-postmeddelande redan löpt ut. Vänligen logga in igen och börja om processen från början.",
      "change-of-your-login-failed": "Ändringen av din inloggning misslyckades"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Vi har skickat ett e-postmeddelande</0> till angiven e-postadress. För att bekräfta e-postadressen måste du gå till inkorgen och <2>klicka på verifieringsfältet i meddelandet</2>.",
      "for-security-reasons": "Av säkerhetsskäl blir länken ogiltig efter 24 timmar. Starta om processen om detta inträffar.",
      "sending-successful": "Överföringen lyckades"
    },
    "migrationVerify": {
      "verification-button": "Bekräfta",
      "verification-header": "Bekräfta användarkontot",
      "verification-description": "Klicka på knappen för att bekräfta ditt personliga användarkonto"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Bekräfta e-postadress",
      "from-now-on-please-login-with-the-email": "Logga från och med nu in med denna e-postadress och ditt lösenord.",
      "your-email-address-has-been-confirmed": "Din e-postadress har bekräftats"
    },
    "needHelp": {
      "for-further-questions": "Du kan kontakta vårt tekniska callcenter<1/> måndag till fredag från kl. 8:00 till 17:00.",
      "need-help-logging-in": "Behöver du hjälp med inloggningen?",
      "here-you-will-find": "<0>Här</0> hittar du svar på <2>vanliga frågor.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "liten bokstav",
      "uppercase-letter": "stor bokstav",
      "the-new-password-requires": "Specifikationer för lösenord:",
      "characters": "Tecken",
      "number": "Siffror"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Uppsägningstid"
    },
    "settings": {
      "user-information-saved": "Användarinformationen har sparats.",
      "update-user-information": "Användarprofil",
      "new-password": "Nytt lösenord",
      "resend-verification": "Skicka verifieringsmeddelandet igen",
      "save": "Spara",
      "language-preference-saved": "Språkinställningen har sparats.",
      "email-has-been-sent": "Det har nu skickats ett bekräftelsemejl.",
      "firstname": "Förnamn",
      "repeat-password": "Upprepa lösenordet",
      "your-user-data": "Dina användardata",
      "set-new-password": "Ställ in nytt lösenord",
      "email-is-not-verified-yet": "E-postmeddelandet har inte verifierats än",
      "old-password": "Gammalt lösenord",
      "new-login-info": "Tänk på att din nya e-postadress även är ditt användarnamn för inloggningen.",
      "update-your-email": "Uppdatera din e-postadress",
      "email": "E-postadress",
      "incorrect-username-or-password": "Fel lösenord.",
      "back": "Tillbaka",
      "resend": "Skicka igen",
      "update-your-language": "Önskat språk",
      "surname": "Efternamn",
      "passwords-do-not-match": "De två lösenorden stämmer inte överens. Kontrollera dina uppgifter.",
      "submit-new-email-info": "När du anger en ny e-postadress skickar vi ett bekräftelsemejl till denna adress. Klicka på länken i meddelandet för att bekräfta din nya e-postadress.",
      "this-language-will-be-used": "Det här språket används för ditt personliga användarkonto och för dina e-postmeddelanden. E-postmeddelanden med fakturor berörs inte av detta."
    },
    "signIn": {
      "sign-in": "Logga in",
      "forgot-your-password": "Glömt lösenordet?",
      "your-login-V2": "E-postadressen",
      "your-password": "Ditt lösenord",
      "sign-in-at-hella-gutmann": "Logga in till Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Lösenorden stämmer inte överens.",
      "noMatchedEmails": "E-postadresserna stämmer inte överens.",
      "lead": "Ange dina uppgifter här för att skapa ett Hella Gutmann-konto.",
      "descriptionUserAccountV2": "Hella Gutmann går över till personliga användarkonton. Ange förnamn, efternamn och ett lösenord för ditt personliga användarkonto här.",
      "password": "Lösenord",
      "descriptionLogin": "Logga in med din e-postadress och ditt lösenord efter kontrollen.",
      "passwordLead": "Välj ett säkert lösenord och ange detta i båda fälten.",
      "familyName": "Efternamn",
      "repeatEmail": "Upprepa e-postadressen",
      "header": "Registrering",
      "email": "E-postadress",
      "signup": "Registrera",
      "givenName": "Förnamn",
      "repeatPassword": "Upprepa lösenordet",
      "descriptionUserAccount": "Hella Gutmann går över till personliga användarkonton. Ange förnamn, efternamn, en e-postadress och ett lösenord för ditt personliga användarkonto här."
    },
    "signUpComplete": {
      "header": "Registreringen lyckades",
      "info": "Observera följande: Vid inloggningen till ditt Hella Gutmann-konto ska du använda lösenordet som just tilldelades och den e-postadress dit registreringsmeddelandet skickades.",
      "yourUserProfile": "Din användarprofil"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Överföringen lyckades",
      "forSecurityReasons": "Av säkerhetsskäl blir länken ogiltig efter 24 timmar. Logga i sådant fall in med de gamla användaruppgifterna igen och starta proceduren på nytt.",
      "weSentYouAnEmail": "<0>Vi har skickat ett e-postmeddelande</0> till angiven e-postadress. För att bekräfta e-postadressen måste du gå till inkorgen och <2>klicka på verifieringsfältet i meddelandet</2>.",
      "for-security-reasons": "Av säkerhetsskäl blir länken ogiltig efter 24 timmar. Starta om processen om detta inträffar."
    },
    "signUpVerify": {
      "description": "Klicka på knappen för att bekräfta ditt personliga användarkonto",
      "header": "Bekräfta användarkontot",
      "button": "Bekräfta"
    },
    "verify": {
      "verification-description": "Klicka på knappen för att bekräfta din e-postadress",
      "verification-header": "Bekräfta e-postadressen",
      "verification-button": "BEKRÄFTA"
    },
    "verifySuccess": {
      "your-user-profile": "Din användarprofil",
      "from-now-on-we-will-send-you-messages": "Vi kommer nu att använda din nya e-postadress för all kommunikation om macs365.",
      "keep-in-mind-that-this-email": "Observera att din nya e-postadress används som användarnamn för inloggningen.",
      "change-of-email-address-successful": "Din e-postadress har ändrats."
    },
    "wizard": {
      "close": "Stäng macs365"
    }
  },
  "fi": {
    "FAQModal": {
      "use-email-instead-of-customer": "Asiakasnumerosi sijasta käytä sähköpostiosoitettasi salasanan resetoimiseksi.",
      "missing-verification-email": "Minulle ei ole tullut vahvistussähköpostia.",
      "missing-forgot-password-email": "Minulle ei ole tullut sähköpostia \"Salasana unohtunut\".",
      "creating-your-personalized": "Yrität suoraan luoda henkilökohtaisen käyttäjätilin sähköpostiosoitteesi avulla. Kirjaudu ensin asiakasnumerollasi ja sen jälkeen vaihe-vaiheelta luo henkilökohtainen käyttäjätili.",
      "use-email-instead-of-your-customer": "Käytä sisäänkirjautumiseen asiakasnumerosi sijasta sähköpostiosoitettasi.",
      "frequently-asked-questions": "Yleisimmin esitetyt kysymykset",
      "personalized-user-account": "Oletko perustanut henkilökohtaisen käyttäjätilin?",
      "no": "Ei",
      "use-customer-without-de": "Käytä asiakasnumeroasi (ilman \"DE-liitettä\") salasanasi resetointia varten.",
      "yes": "Kyllä",
      "use-customer-without-de-prefix": "Käytä sisäänkirjautumiseen asiakasnumeroasi (ilman \"DE-liitettä\") ja sen jälkeen vaihe-vaiheelta luo henkilökohtainen käyttäjätili.",
      "i-cannot-sign-in-to-my-account": "En voi kirjautua sisään."
    },
    "api": {
      "incorrect-username-or-password": "Väärä käyttäjätunnus tai väärä salasana.",
      "invalid-code-provided": "On tapahtunut virhe. Aloita salasanan muutos alusta.",
      "user-does-not-exist": "Käyttäjää ei löytynyt",
      "password-validation-error": "Salasana ei vastaa pyyntöä.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Käyttäjää ei löytynyt",
      "password-missing-number": "Salasana ei vastaa vaatimuksia.Anna salasana, jossa on vähintään yksi iso merkki.",
      "incorrect-old-password": "Väärä vanha salasana",
      "user-is-already-registered": "Käyttäjä on jo rekisteröitynyt.",
      "your-password-has-been-changed": "Salasanasi on vaihdettu.",
      "password-missing-uppercase": "Salasana ei vastaa vaatimuksia. Anna salasana, jossa on vähintään yksi iso kirjain.",
      "invalid-verification-provided": "Käytetty vanhentunutta linkkiä. Klikkaa viimeksi saamasi sähköpostin linkkiä \"Salasanan resetointi\".",
      "email-used-by-different-user": "Sähköpostiosoite on toisen käyttäjän hallinnassa.",
      "password-not-long-enough": "Salasana ei vastaa vaatimuksia. Anna salasana, jossa on vähintään 8 merkkiä.",
      "an-error-occurred": "On tapahtunut virhe. Tarkista myöhemmin, onko ongelma poistunut.",
      "attempt-limit-exceeded": "Olet yrittänyt vaihtaa salasanaa liian usein. Odota hetki ja aloita salasanan vaihtoprosessi alusta alkaen.",
      "incorrect_old_password": "Väärä vanha salasana",
      "password-missing-lowercase": "Salasana ei vastaa vaatimuksia. Anna salasana, jossa on vähintään yksi pieni kirjain.",
      "generic-api-message": "Tarkasta syöttämäsi tiedot. Klikkaa itsesi uudelleen manuaalisesti sisään. Mikäli virhe ilmenee toistuvasti, ota yhteys tukeemme."
    },
    "common": {
      "please-wait": "Ole hyvä, odota",
      "send-code": "Koodin lähettäminen",
      "your-account": "Hella Gutmann -käyttäjätilisi",
      "close": "Sulje",
      "please-fill-in-this-field": "Täytä tämä kenttä.",
      "hgsKey": "Sähköpostiosoite (mikäli olet perustanut henkilökohtaisen käyttäjätilin) tai asiakasnumero",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Hallinnoi käyttäjäprofiiliasi Hella Gutmann Accounts:in avulla.",
      "please-start-the-process-again-later": "<0> Käynnistä toimenpide myöhemmin uudelleen.<0> Mikäli ongelma ilmenee uudestaan, ota yhteys asiakaspalveluun.",
      "this-field-cannot-be-left-blank": "Tämä kenttä ei saa jäädä tyhjäksi.",
      "please-enter-your-login": "Syötä tässä Login-tietosi. Olemme nyt lähettäneet sähköpostiisi 6-merkkisen koodin. Syötä tämä koodi seuraavalla sivulla. Älä sulje selainta.",
      "password-validation-error": "Salasana ei vastaa pyyntöä.",
      "hide-password": "Suojaa salasana",
      "go-to-login": "Sisäänkirjautumiseen",
      "invalid-characters": "Olet syöttänyt ei-sallittuja merkkejä. Muuta syöttämiäsi tietoja.",
      "first-name-and-last-name-too-short": "Syötä vain aakkosmerkkejä ja vähintään kaksi merkkiä.",
      "an-error-occurred": "On tapahtunut virhe",
      "please-enter-a-valid-email-address": "Syötä käytössä oleva sähköpostiosoite. Sallittuja merkkejä ovat alfanumeeriset merkit ja seuraavat erikoismerkit: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Käyttäjää ei löytynyt",
      "show-password": "Näytä salasana",
      "no-number-and-email": "Syötä käytössä oleva sähköpostiosoite tai yksinomaan vastaanottamassasi laskussa oleva asiakasnumero.",
      "passwords-does-not-match": "Salasanat eivät vastaa toisiaan.",
      "user-does-not-exist": "Käyttäjää ei löytynyt",
      "your-user-profile": "Käyttäjäprofiilisi",
      "enter-code": "Syötä koodi"
    },
    "dashboard": {
      "logout": "Uloskirjautuminen",
      "lead": "Valitse, millaisia sovelluksia käytät ja mihin toimintoihin haluat Hella Gutmann Account-tiliäsi käyttää."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Jotta mega macs S20:stä voidaan käyttää, tulee asentaa mega macs S20-sovellus Android-laitteeseenne. Sovellus on saatavilla Play Store-kaupasta.",
      "x20-please-sign-in-title": "Login CSC-Tool X 20:een",
      "x20-please-sign-in-content": "Ole hyvä ja kirjaudu Hella Gutmann Account-tilillesi CSC-Tool X 20:n välityksellä.",
      "s20-please-start-device-title": "Login mega macsS20:een"
    },
    "errorMessage": {
      "error": "Virhe",
      "something-went-wrong": "Nyt jokin ei täsmää."
    },
    "faq": {
      "howDoIChangePassword": "Miten Hella Gutmann Account-salasanan voi vaihtaa?",
      "howDoIGetAHellaGutmannAccount": "Miten vastaanottaa Hella Gutmann Account?",
      "possibleToUseMultipleAccounts": "Asiakkaille ratkaisu mahdollistaa kätevän tavan käyttää useampaa Hella Gutmannin verkkosivujen sovellusta yhdellä ja samalla sisäänkirjautumisella.",
      "backToLogin": "TAKAISIN SISÄÄNKIRJAUTUMISEEN",
      "itIsASingleSignOnSolution": "Hella Gutmann Account on Hella Gutmannin Single Sign-on (SSO) -ratkaisu. Pääsyyn vaaditaan sähköpostiosoite ja valittu salasana.",
      "title": "Yleisimmin esitetyt kysymykset (FAQ)",
      "whatIsAHellaGutmannAccount": "Mikä on Hella Gutmann Account?",
      "supportedAppsConstantlyExpanded": "Tuettujen sovellusten lukumäärä kasvaa kaiken aikaa. Tällä hetkellä Hella Gutmann Account tukee seuraavia sovelluksia",
      "alternativeContactSupport": "Vaihtoehtoisesti ota yhteys tukeemme.",
      "howDoIResetPassword": "Miten palautan Hella Gutmann Account-salasanan?",
      "asSoonAsYouGetAccessToProducts": "Heti, kun tuetut tuotteet on hankittu tai kunnes pääsy macs365:een on vahvistettu, vastaanotat sähköpostin pääsystä Hella Gutmann Account-tilille. Hella Gutmann luo tämän sähköpostin automatisoidun prosessin avulla lähettäen sen meille ilmoitettuun sähköpostiosoitteeseen.",
      "whatToDoIfNoEMailReceived": "Mitä voin tehdä, jo en ole vastaanottanut sähköpostia Hella Gutmann Account-tiliä varten?",
      "clickOnForgotPassword": "Yksi tapa pyytää tarvittava sähköposti on mahdollista toiminnolla <1>Salasana unohtunut</1>. Ota huomioon, että ilmoitetun ja tallentamamme sähköpostiosoitteen tulee olla yksi ja sama.",
      "changeEmailOnUserProfile": "Hella Gutmann -tilille kirjautumiseen käytettävää sähköpostiosoitetta voidaan muuttaa Käyttäjäprofiili-sivulla (käyttäjäprofiili on tällä hetkellä käytettävissä vain niillä asiakkailla, joilla on pääsy macs365:een).",
      "changePasswordOnUserProfile": "Hella Gutmann -tilin salasanaa voidaan muuttaa Käyttäjäprofiili-sivulla (käyttäjäprofiili on tällä hetkellä käytettävissä vain niillä asiakkailla, joilla on pääsy macs365:een).",
      "howDoIChangeEmailAddress": "Miten Hella Gutmann Account-sähkopostiosoitteen voi vaihtaa?",
      "whichAppsAreSupported": "Mitä sovelluksia Hella Gutmann Account tukee?"
    },
    "footer": {
      "imprint": "Painatus",
      "faq": "FAQ",
      "faq-heading": "Yleisimmin esitetyt kysymykset (FAQ)",
      "data-privacy-policy": "Tietosuojalauseke",
      "terms-and-conditions": "Käyttöehdot"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Sähköpostin lähettäminen ei ollut mahdollista liian monesta virheellisestä yrityksestä johtuen. Yritä väh. kahden tunnin päästä uudelleen.",
      "send-email": "Lähetä",
      "reset-your-password": "Resetoi salasana",
      "forgot-password-button-clicked-alert": "Sähköposti on lähetetty onnistuneesti. Olosuhteista johtuen sen saapuminen voi kestää muutaman minuutin.",
      "back-to-login": "Takaisin sisäänkirjautumiseen",
      "enter-your-login-V2": "Sähköpostiosoite",
      "please-enter-your-login": "Syötä Login-tietosi ja me lähetämme sinulle vahvistussähköpostin. Klikkaa sen jälkeen sähköpostin vahvistuspainiketta.",
      "enter-your-login": "Sinun Login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Valitse turvallinen salasana ja syötä se molempiin kenttiin.",
      "reset-your-password": "Syötä uusi salasana",
      "repeat-password": "Toista uusi salasana",
      "a-verification-email-has-been-sent-to-you": "Vahvistussähköposti on lähetetty sinulle.",
      "reset-password": "Syötä salasana",
      "new-password": "Uusi salasana",
      "passwords-do-not-match": "Salasanat eivät vastaa toisiaan. Tarkasta syöttämäsi tiedot."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Uusi salasanasi on nyt käyttövalmis.",
      "setting-new-password-successful": "Uusi salasana on asetettu onnistuneesti!",
      "go-to-login": "Sisäänkirjautumiseen"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH\n\nAm Krebsbach 2\n\nD-79241 Ihringen Saksa\n\nPuhelin: +49 7668 9900 888\n\nTelefax: +49 7668 9900-3999\n\ninfo@hella-gutmann.com\n\nVeronumero: 07011/39801\n\nALV-tunnus: DE 14 220 8666\n\nKaupparekisteri: HRB 290194, Freiburg\n\nCEO: Adnan Cemal",
      "header": "Painatus",
      "back": "TAKAISIN SISÄÄNKIRJAUTUMISEEN"
    },
    "menu": {
      "digital-products": "Digitaalinen profiili"
    },
    "migration": {
      "helper-text-surname": "Syötä sukunimet",
      "description-submit": "Lomakkeen lähettämisen jälkeen lähetämme viestin ilmoitettuun sähköpostiosoitteeseen. Sähköpostiosoitteen vahvistamiseksi mene postilaatikkoosi ja klikkaa tämän viestin vahvistuspainiketta.",
      "firstname": "Etunimi",
      "description-login": "Kirjaudu tämän jälkeen käyttäen käytössäsi olevaa sähköpostiosoitettasi ja voimassa olevaa salasanaasi. Kirjautuminen käyttäen asiakasnumeroasi ei enää ole mahdollista.",
      "submit": "Lähetä",
      "email": "Sähköpostiosoite",
      "page-title": "Hella Gutmann -käyttäjätilisi",
      "helper-text-firstname": "Syötä etunimi",
      "surname": "Sukunimi",
      "title": "Muuta sisäänkirjautumisesi",
      "helper-text-email": "Syötä sähköpostiosoitteesi",
      "description-user-account": "Hella Gutmann perustaa henkilökohtaisen käyttäjätilin. Syötä tähän kohtaan etunimesi, sukunimesi ja sähköpostiosoitteesi henkilökohtaista käyttäjätiliäsi varten."
    },
    "migrationError": {
      "go-to-login": "Sisäänkirjautumiseen",
      "your-email-address-could-not-get-confirmed": "Uutta sähköpostiosoitettasi ei voida vahvistaa. Mitä suurimmalla todennäköisyydellä saamasi sähköpostin linkki on vanhentunut. Tee uusi ilmoitus ja käynnistä toimenpide alusta alkaen uudelleen.",
      "change-of-your-login-failed": "Sisäänkirjautumisesi muuttaminen epäonnistui"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Olemme lähettäneet sinulle sähköpostin<0> annettuun sähköpostiosoitteeseen. Sähköpostiosoitteen vahvistamiseksi mene postilaatikkoosi ja<2> klikkaa sähköpostin vahvistuspainiketta<2>.",
      "for-security-reasons": "Turvallisuussyistä johtuen oheinen linkki on voimassa vain 24 tuntia. Mikäli linkkiä ei käytetä tässä ajassa, aloita toimenpide uudelleen.",
      "sending-successful": "Lähetys onnistui"
    },
    "migrationVerify": {
      "verification-button": "Vahvista",
      "verification-header": "Käyttäjätilin vahvistus",
      "verification-description": "Klikkaa oheisesta painikkeesta vahvistaaksesi henkilökohtaisen käyttäjätilisi perustamisen"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Vahvista sähköpostiosoite",
      "from-now-on-please-login-with-the-email": "Kirjaa itsesi sisään käyttäen tätä sähköpostiosoitetta ja omaa salasanaasi.",
      "your-email-address-has-been-confirmed": "Sähköpostiosoitteesi on vahvistettu"
    },
    "needHelp": {
      "for-further-questions": "Mahdollisia lisäkysymyksiä varten asiakaspalvelumme<1/> päivystää maanantaista perjantaihin klo 8-17.",
      "need-help-logging-in": "Tarvitsetko apua sisäänkirjautumisessa?",
      "here-you-will-find": "<0>Tästä<0> löydät vastauksia <2>yleisesti esitettyihin kysymyksiin.<2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "pienet kirjaimet",
      "uppercase-letter": "isot kirjaimet",
      "the-new-password-requires": "Salasana-asetukset:",
      "characters": "Merkkiä",
      "number": "Numeromerkki"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Irtisanomisaika"
    },
    "settings": {
      "user-information-saved": "Käyttäjätiedot tallennettu.",
      "update-user-information": "Käyttäjäprofiili",
      "new-password": "Uusi salasana",
      "resend-verification": "Vahvistus lähetetään uudelleen",
      "save": "Tallenna",
      "language-preference-saved": "Kieliasetukset on tallennettu.",
      "email-has-been-sent": "Vahvistussähköposti on lähetetty sinulle.",
      "firstname": "Etunimi",
      "repeat-password": "Toista salasana",
      "your-user-data": "Käyttäjätietosi",
      "set-new-password": "Uuden salasanan asettaminen",
      "email-is-not-verified-yet": "Sähköpostia ei ole vahvistettu",
      "old-password": "Vanha salasana",
      "new-login-info": "Ota huomioon, että uusi sähköpostiosoitteesi on myös Login-tietosi.",
      "update-your-email": "Päivitä sähköpostiosoitteesi",
      "email": "Sähköpostiosoite",
      "incorrect-username-or-password": "Väärä salasana.",
      "back": "Takaisin",
      "resend": "Lähetä uudelleen",
      "update-your-language": "Suositeltava kieli",
      "surname": "Sukunimi",
      "passwords-do-not-match": "Salasanat eivät vastaa toisiaan. Tarkasta syöttämäsi tiedot.",
      "submit-new-email-info": "Kun uusi sähköpostiosoite on annettu, lähetämme sinulle vahvistussähköpostin. Klikkaa tämän sähköpostin linkkiä vahvistaaksesi uuden sähköpostiosoitteesi.",
      "this-language-will-be-used": "Tätä kieltä käytetään käyttäjätililläsi ja sähköposteissasi. Tämä ei kuitenkaan koske laskujasi."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Salasana unohtunut?",
      "your-login-V2": "Sähköpostiosoite",
      "your-password": "Salasanasi",
      "sign-in-at-hella-gutmann": "Kirjautunut sisään Hella Gutmannille"
    },
    "signUp": {
      "noMatchedPasswords": "Salasanat eivät vastaa toisiaan.",
      "noMatchedEmails": "Sähköpostiosoitteet eivät vastaa toisiaan.",
      "lead": "Syötä tietosi Hella Gutmann -tilin perustamiseksi.",
      "descriptionUserAccountV2": "Hella Gutmann perustaa henkilökohtaisen käyttäjätilin. Syötä tähän kohtaan etunimesi, sukunimesi, sähköpostiosoitteesi ja anna käyttäjätilillesi salasana.",
      "password": "Salasana",
      "descriptionLogin": "Kirjaudu tarkastuksen jälkeen käyttäen sähköpostiosoitettasi ja salasanaasi.",
      "passwordLead": "Valitse turvallinen salasana ja syötä se molempiin kenttiin.",
      "familyName": "Sukunimi",
      "repeatEmail": "Toista sähköpostiosoite",
      "header": "Registration",
      "email": "Sähköpostiosoite",
      "signup": "Rekisteröinti",
      "givenName": "Etunimi",
      "repeatPassword": "Toista salasana",
      "descriptionUserAccount": "Hella Gutmann perustaa henkilökohtaisen käyttäjätilin. Syötä tähän kohtaan etunimesi, sukunimesi, sähköpostiosoitteesi ja anna käyttäjätilillesi salasana."
    },
    "signUpComplete": {
      "header": "Rekisteröinti onnistui",
      "info": "Huomaa: Käytä Hella Gutmann -tilille kirjautumista varten juuri määrittämäsi salasanan lisäksi sitä sähköpostiosoitetta, johon lähetimme rekisteröitymissähköpostin.",
      "yourUserProfile": "Käyttäjäprofiilisi"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Lähetys onnistui",
      "forSecurityReasons": "Turvallisuussyistä johtuen oheinen linkki on voimassa vain 24 tuntia. Mikäli sisään ei kirjauduta tämän ajan puitteissa tai yritetään kirjautua vanhoilla tiedoilla, tulee toimenpide aloittaa alusta.",
      "weSentYouAnEmail": "<0>Olemme lähettäneet sinulle sähköpostin<0> annettuun sähköpostiosoitteeseen. Sähköpostiosoitteen vahvistamiseksi mene postilaatikkoosi ja<2> klikkaa sähköpostin vahvistuspainiketta<2>.",
      "for-security-reasons": "Turvallisuussyistä johtuen oheinen linkki on voimassa vain 24 tuntia. Mikäli linkkiä ei käytetä tässä ajassa, aloita toimenpide uudelleen."
    },
    "signUpVerify": {
      "description": "Klikkaa oheisesta painikkeesta vahvistaaksesi henkilökohtaisen käyttäjätilisi perustamisen",
      "header": "Käyttäjätilin vahvistus",
      "button": "Vahvista"
    },
    "verify": {
      "verification-description": "Klikkaa oheisesta painikkeesta vahvistaaksesi sähköpostiosoitteesi",
      "verification-header": "Sähköpostiosoitteen vahvistus",
      "verification-button": "VAHVISTA"
    },
    "verifySuccess": {
      "your-user-profile": "Käyttäjäprofiilisi",
      "from-now-on-we-will-send-you-messages": "Tästä eteenpäin käytämme uutta sähköpostiosoitettasi kaikkeen macs365-kommunikaatioon.",
      "keep-in-mind-that-this-email": "Ota huomioon, että uusi sähköpostiosoitteesi on sama kuin käyttäjänimesi palvelussa.",
      "change-of-email-address-successful": "Sähköpostiosoitteen vaihtaminen onnistui."
    },
    "wizard": {
      "close": "sulje macs365"
    }
  },
  "da": {
    "FAQModal": {
      "use-email-instead-of-customer": "Nulstil din adgangskode via din e-mailadresse i stedet for via dit kundenummer.",
      "missing-verification-email": "Jeg har ikke modtaget en bekræftelsesmail.",
      "missing-forgot-password-email": "Jeg har ikke modtaget en e-mail om \"Glemt adgangskode\".",
      "creating-your-personalized": "Du forsøger at oprette din personlige brugerkonto direkte med din e-mailadresse. Log først ind med dit kundenummer, og følg derefter trinene til oprettelse af din personlige brugerkonto.",
      "use-email-instead-of-your-customer": "Log ind med din e-mailadresse i stedet for dit kundenummer.",
      "frequently-asked-questions": "FAQ",
      "personalized-user-account": "Har du oprettet din personlige brugerkonto?",
      "no": "Nej",
      "use-customer-without-de": "Nulstil din adgangskode via dit kundenummer (uden foranstillet \"DE-\").",
      "yes": "Ja",
      "use-customer-without-de-prefix": "Log ind med dit kundenummer (uden foranstillet \"DE\"-), og følg trinene til oprettelse af din personlige brugerkonto.",
      "i-cannot-sign-in-to-my-account": "Jeg kan ikke logge ind."
    },
    "api": {
      "incorrect-username-or-password": "Forkert brugernavn eller adgangskode.",
      "invalid-code-provided": "Der opstod en fejl. Prøv at ændre din adgangskode igen.",
      "user-does-not-exist": "Brugeren findes ikke.",
      "password-validation-error": "Adgangskoden opfylder ikke kravene.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Brugeren findes ikke.",
      "password-missing-number": "Adgangskoden opfylder ikke kravene. Indtast en adgangskode med mindst 1 tal.",
      "incorrect-old-password": "Den gamle adgangskode er forkert.",
      "user-is-already-registered": "Brugeren er allerede registreret.",
      "your-password-has-been-changed": "Din adgangskode er blevet ændret.",
      "password-missing-uppercase": "Adgangskoden opfylder ikke kravene. Indtast en adgangskode med mindst 1 stort bogstav.",
      "invalid-verification-provided": "Du brugte et udløbet link. Klik på det link, du modtog i den seneste e-mail \"Nulstil adgangskode\".",
      "email-used-by-different-user": "E-mailadressen bliver brugt af en anden bruger.",
      "password-not-long-enough": "Adgangskoden opfylder ikke kravene. Indtast en adgangskode på mindst 8 tegn.",
      "an-error-occurred": "Der opstod en fejl. Prøv igen senere.",
      "attempt-limit-exceeded": "Du har forsøgt at ændre din adgangskode for mange gange. Vent lidt, og prøv så at ændre din adgangskode igen.",
      "incorrect_old_password": "Den gamle adgangskode er forkert.",
      "password-missing-lowercase": "Adgangskoden opfylder ikke kravene. Indtast en adgangskode med mindst 1 lille bogstav.",
      "generic-api-message": "Kontrollér din indtastning. Indtast igen i hånden. Kontakt vores support, hvis fejlen stadig opstår."
    },
    "common": {
      "please-wait": "Vent venligst",
      "send-code": "Send kode",
      "your-account": "Din Hella Gutmann-brugerkonto",
      "close": "Luk",
      "please-fill-in-this-field": "Udfyld dette felt.",
      "hgsKey": "E-mailadresse (hvis du har oprettet din personlige brugerkonto) eller kundenummer",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Administrer din brugerprofil med Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Start proceduren igen senere.</0> Kontakt Customer Center, hvis problemet opstår igen.",
      "this-field-cannot-be-left-blank": "Dette felt skal udfyldes.",
      "please-enter-your-login": "Indtast dit login. Herefter sender vi en kode på 6 tegn til din e-mailadresse. Indtast koden på den næste side. Luk ikke din browser.",
      "password-validation-error": "Adgangskoden opfylder ikke kravene.",
      "hide-password": "Skjul adgangskode",
      "go-to-login": "Gå til Log ind",
      "invalid-characters": "Du har indtastet ugyldige tegn. Foretag en ny indtastning.",
      "first-name-and-last-name-too-short": "Indtast kun alfabetiske tegn og mindst 2 tegn.",
      "an-error-occurred": "Der opstod en fejl",
      "please-enter-a-valid-email-address": "Indtast en gyldig e-mailadresse. Gyldige tegn er alfanumeriske tegn og følgende specialtegn: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Brugeren findes ikke.",
      "show-password": "Vis adgangskode",
      "no-number-and-email": "Indtast en gyldig e-mailadresse eller dit kundenummer, som kun må indeholde tal.",
      "passwords-does-not-match": "Adgangskoderne er forskellige.",
      "user-does-not-exist": "Brugeren findes ikke.",
      "your-user-profile": "Din brugerprofil",
      "enter-code": "Indtast kode"
    },
    "dashboard": {
      "logout": "Log af",
      "lead": "Vælg den applikation, du ønsker at få adgang til med din Hella Gutmann-konto."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "For at kunne benytte mega macs S 20 skal mega macs S 20-appen være installeret på din Android-enhed. Appen kan hentes i Play Butik.",
      "x20-please-sign-in-title": "Login på CSC-Tool X 20",
      "x20-please-sign-in-content": "Log på dit CSC-Tool X 20 med din Hella Gutmann-konto.",
      "s20-please-start-device-title": "Login på mega macs S 20"
    },
    "errorMessage": {
      "error": "Fejl",
      "something-went-wrong": "Noget gik galt."
    },
    "faq": {
      "howDoIChangePassword": "Hvordan kan jeg ændre passwordet for Hella Gutmann-kontoen?",
      "howDoIGetAHellaGutmannAccount": "Hvordan får jeg en Hella Gutmann-konto?",
      "possibleToUseMultipleAccounts": "Løsningen giver kunderne mulighed for at logge sikkert ind på flere af Hella Gutmanns applikationer og hjemmesider med kun én adgang og ét login.",
      "backToLogin": "TILBAGE TIL LOG IND",
      "itIsASingleSignOnSolution": "Hella Gutmann-kontoen er Hella Gutmanns Single Sign-on-løsning (SSO). For at få adgang skal du angive en e-mailadresse og en adgangskode, du selv har valgt.",
      "title": "Ofte stillede spørgsmål (FAQ)",
      "whatIsAHellaGutmannAccount": "Hvad er Hella Gutmann-kontoen?",
      "supportedAppsConstantlyExpanded": "Antallet af understøttede applikationer udvides løbende. Hella Gutmann-kontoen understøtter i øjeblikket følgende applikationer",
      "alternativeContactSupport": "Du kan også kontakte vores support.",
      "howDoIResetPassword": "Hvordan resetter jeg passwordet for Hella Gutmann-kontoen?",
      "asSoonAsYouGetAccessToProducts": "Så snart du har købt et af de understøttede produkter eller er blevet autoriseret til at få adgang til macs365, modtager du en e-mail til oprettelse af en Hella Gutmann-konto. E-mailen sendes via en automatiseret proces til den e-mailadresse, vi har registreret.",
      "whatToDoIfNoEMailReceived": "Hvad kan jeg gøre, hvis jeg ikke har modtaget e-mailen om at oprette en Hella Gutmann-konto?",
      "clickOnForgotPassword": "En mulighed er at anmode om den nødvendige e-mail via <1>Glemt password</1>. Sørg her for, at den indtastede e-mailadresse stemmer overens med den e-mailadresse, vi har registreret.",
      "changeEmailOnUserProfile": "Du kan ændre e-mailadressen til din Hella Gutmann-konto, som du bruger til login, via siden Brugerprofil (Brugerprofil er i øjeblikket kun tilgængelig for kunder med adgang til macs365).",
      "changePasswordOnUserProfile": "Du kan ændre passwordet til Hella Gutmann-kontoen via siden Brugerprofil (Brugerprofil er i øjeblikket kun tilgængelig for kunder med adgang til macs365).",
      "howDoIChangeEmailAddress": "Hvordan kan jeg ændre e-mailadressen for Hella Gutmann-kontoen?",
      "whichAppsAreSupported": "Hvilke applikationer understøttes af Hella Gutmann-kontoen?"
    },
    "footer": {
      "imprint": "Virksomhedsoplysninger",
      "faq": "FAQ",
      "faq-heading": "Ofte stillede spørgsmål (FAQ)",
      "data-privacy-policy": "Data- og privatlivspolitik",
      "terms-and-conditions": "Anvendelsesbetingelser"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "En e-mail kunne ikke sendes på grund af for mange mislykkede forsøg. Prøv igen om et par timer.",
      "send-email": "Send",
      "reset-your-password": "Nulstil din adgangskode",
      "forgot-password-button-clicked-alert": "E-mailen blev afsendt. I nogle tilfælde kan leveringen vare et par minutter.",
      "back-to-login": "Gå tilbage til Log ind",
      "enter-your-login-V2": "E-mailadressen",
      "please-enter-your-login": "Indtast dit login, og vi sender dig en bekræftelsesmail. Klik på verificieringsknappen i e-mailen.",
      "enter-your-login": "Dit login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Vælg en sikker adgangskode, og indtast den i begge felter.",
      "reset-your-password": "Opret ny adgangskode",
      "repeat-password": "Gentag ny adgangskode",
      "a-verification-email-has-been-sent-to-you": "Vi har sendt en bekræftelsesmail til dig.",
      "reset-password": "Opret adgangskode",
      "new-password": "Ny adgangskode",
      "passwords-do-not-match": "Adgangskoderne er forskellige. Kontrollér din indtastning."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Din nye adgangskode er klar til brug.",
      "setting-new-password-successful": "Ny adgangskode er blevet oprettet!",
      "go-to-login": "Gå til Log ind"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTlf.: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nSkattenummer: 07011/39801 \n\nMomsnummer: DE 14 220 8666 \n\nHandelsregister: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Virksomhedsoplysninger",
      "back": "TILBAGE TIL LOG IND"
    },
    "menu": {
      "digital-products": "Digitale produkter"
    },
    "migration": {
      "helper-text-surname": "Indtast et efternavn",
      "description-submit": "Når du har afsendt formularen, sender vi dig en meddelelse til den angivne e-mailadresse. Klik på verificeringsknappen i denne meddelelse for at bekræfte din e-mailadresse.",
      "firstname": "Fornavn",
      "description-login": "Log derefter ind med din e-mailadresse og dit aktuelle password. Det er ikke længere muligt at logge ind med dit kundenummer.",
      "submit": "Send",
      "email": "E-mailadresse",
      "page-title": "Din Hella Gutmann-brugerkonto",
      "helper-text-firstname": "Indtast et fornavn",
      "surname": "Efternavn",
      "title": "Ændring af dit login",
      "helper-text-email": "Indtast en e-mailadresse",
      "description-user-account": "Hella Gutmann skifter til personlige brugerkonti. Indtast fornavn, efternavn og e-mailadresse for din personlige brugerkonto."
    },
    "migrationError": {
      "go-to-login": "Gå til Log ind",
      "your-email-address-could-not-get-confirmed": "Din nye e-mailadresse kunne ikke bekræftes. Sandsynligvis er linket i din e-mail allerede udløbet. Log ind igen, og start processen fra begyndelsen.",
      "change-of-your-login-failed": "Ændring af dit login mislykket"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Vi har sendt en e-mail</0> til den indtastede e-mailadresse. Bekræft e-mailadressen ved at åbne din mailboks og <2>klikke på verificeringsknappen i e-mailen.</2>.",
      "for-security-reasons": "Af sikkerhedsmæssige årsager er linket kun gyldigt i 24 timer. Hvis dette sker, skal du starte processen igen.",
      "sending-successful": "Overførsel lykkedes"
    },
    "migrationVerify": {
      "verification-button": "Bekræft",
      "verification-header": "Bekræftelse af brugerkonto",
      "verification-description": "Klik på knappen for at bekræfte oprettelsen af din personlige brugerkonto."
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "E-mailadresse bekræftet",
      "from-now-on-please-login-with-the-email": "Log fra nu af ind med denne e-mailadresse og dit password.",
      "your-email-address-has-been-confirmed": "Din e-mailadresse blev bekræftet"
    },
    "needHelp": {
      "for-further-questions": "Hvis du har yderligere spørgsmål, kan du kontakte vores hotline<1/> mandag til fredag fra 8:00 til 17:00.",
      "need-help-logging-in": "Mangler du hjælp til login?",
      "here-you-will-find": "<0>Her</0> finder du svar på <2>FAQ.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "lille bogstav",
      "uppercase-letter": "stort bogstav",
      "the-new-password-requires": "Krav til adgangskoden:",
      "characters": "tegn",
      "number": "tal"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Opsigelsesfrist"
    },
    "settings": {
      "user-information-saved": "Brugeroplysningerne blev gemt.",
      "update-user-information": "Brugerprofil",
      "new-password": "Ny adgangskode",
      "resend-verification": "Send verificering igen",
      "save": "Gem",
      "language-preference-saved": "Sprogindstillingen blev gemt.",
      "email-has-been-sent": "Vi har sendt en bekræftelsesmail til dig.",
      "firstname": "Fornavn",
      "repeat-password": "Gentag adgangskode",
      "your-user-data": "Dine brugerdata",
      "set-new-password": "Opret ny adgangskode",
      "email-is-not-verified-yet": "E-mailen er endnu ikke verificeret",
      "old-password": "Gammel adgangskode",
      "new-login-info": "Husk, at din nye e-mailadresse også er dit login.",
      "update-your-email": "Opdater din e-mailadresse",
      "email": "E-mailadresse",
      "incorrect-username-or-password": "Forkert adgangskode.",
      "back": "Gå tilbage",
      "resend": "Send igen",
      "update-your-language": "Foretrukket sprog",
      "surname": "Efternavn",
      "passwords-do-not-match": "Adgangskoderne er forskellige. Kontrollér din indtastning.",
      "submit-new-email-info": "Hvis du angiver en ny e-mailadresse, sender vi dig en bekræftelsesmail. Klik på linket i denne e-mail for at bekræfte din nye e-mailadresse.",
      "this-language-will-be-used": "Dette sprog vil blive brugt til din personlige brugerkonto og til dine e-mails. Sproget vil ikke blive anvendt i e-mails med regninger."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Har du glemt din adgangskode?",
      "your-login-V2": "E-mailadressen",
      "your-password": "Din adgangskode",
      "sign-in-at-hella-gutmann": "Log ind hos Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Adgangskoderne er forskellige.",
      "noMatchedEmails": "E-mailadresserne er forskellige.",
      "lead": "Indtast dine oplysninger for at oprette en Hella Gutmann-konto.",
      "descriptionUserAccountV2": "Hella Gutmann skifter til personlige brugerkonti. Indtast fornavn, efternavn og password for din personlige brugerkonto.",
      "password": "Adgangskode",
      "descriptionLogin": "Log ind med din e-mailadresse og adgangskode efter kontrollen.",
      "passwordLead": "Vælg en sikker adgangskode, og indtast den i begge felter.",
      "familyName": "Efternavn",
      "repeatEmail": "Gentag e-mailadresse",
      "header": "Registrering",
      "email": "E-mailadresse",
      "signup": "Registrering",
      "givenName": "Fornavn",
      "repeatPassword": "Gentag adgangskode",
      "descriptionUserAccount": "Hella Gutmann skifter til personlige brugerkonti. Indtast fornavn, efternavn, e-mailadresse og adgangskode til din personlige brugerkonto."
    },
    "signUpComplete": {
      "header": "Registrering lykkedes",
      "info": "Bemærk venligst: For at logge ind på din Hella Gutmann-konto skal du ud over det password, der lige er tildelt, bruge den e-mailadresse, som vi har sendt registrerings-e-mailen til.",
      "yourUserProfile": "Din brugerprofil"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Overførsel lykkedes",
      "forSecurityReasons": "Af sikkerhedsmæssige årsager er linket kun gyldigt i 24 timer. Hvis linket udløber, skal du logge ind igen med dine gamle adgangsdata, og starte proceduren igen.",
      "weSentYouAnEmail": "<0>Vi har sendt en e-mail</0> til den indtastede e-mailadresse. Bekræft e-mailadressen ved at åbne din mailboks og <2>klikke på verificeringsknappen i e-mailen.</2>.",
      "for-security-reasons": "Af sikkerhedsmæssige årsager er linket kun gyldigt i 24 timer. Hvis dette sker, skal du starte processen igen."
    },
    "signUpVerify": {
      "description": "Klik på knappen for at bekræfte oprettelsen af din personlige brugerkonto.",
      "header": "Bekræftelse af brugerkonto",
      "button": "Bekræft"
    },
    "verify": {
      "verification-description": "Klik på knappen for at bekræfte din e-mailadresse.",
      "verification-header": "Bekræftelse af e-mailadresse",
      "verification-button": "BEKRÆFT"
    },
    "verifySuccess": {
      "your-user-profile": "Din brugerprofil",
      "from-now-on-we-will-send-you-messages": "Din nye e-mailadresse vil fremover blive brugt til kommunikation om macs365.",
      "keep-in-mind-that-this-email": "Vær opmærksom på, at din nye e-mailadresse også er brugernavnet ved login.",
      "change-of-email-address-successful": "Ændring af e-mailadresse lykkedes"
    },
    "wizard": {
      "close": "Luk macs365"
    }
  },
  "nb": {
    "FAQModal": {
      "use-email-instead-of-customer": "Vennligst bruk din e-postadresse i stedet for ditt kundenummer for å tilbakestille passordet.",
      "missing-verification-email": "Jeg får ikke e-posten med bekreftelsen.",
      "missing-forgot-password-email": "Jeg får ikke e-posten med \"Glemt passord\".",
      "creating-your-personalized": "Du forsøker å opprette din personlige brukerkonto direkte med din e-postadresse. Logg deg først på med kundenummer, og følg så trinnene for å opprette din personlige brukerkonto.",
      "use-email-instead-of-your-customer": "Benytt din e-postadresse i stedet for kundenummer når du logger deg på.",
      "frequently-asked-questions": "Ofte stilte spørsmål",
      "personalized-user-account": "Har du opprettet en personlig brukerkonto?",
      "no": "Nei",
      "use-customer-without-de": "Benytt ditt kundenummer (uten prefikset \"DE\") for å tilbakestille passordet.",
      "yes": "Ja",
      "use-customer-without-de-prefix": "Benytt ditt kundenummer (uten prefikset \"DE\") for å logge deg på, og følg så trinnene for å opprette din personlige brukerkonto.",
      "i-cannot-sign-in-to-my-account": "Jeg kan ikke logge meg på."
    },
    "api": {
      "incorrect-username-or-password": "Feil brukernavn eller feil passord.",
      "invalid-code-provided": "Det har oppstått en feil. Start endringen av passord på nytt.",
      "user-does-not-exist": "Brukeren eksisterer ikke",
      "password-validation-error": "Passordet oppfyller ikke kravene.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Brukeren eksisterer ikke",
      "password-missing-number": "Passordet oppfyller ikke kravene. Legg inn et passord med minst 1 tall.",
      "incorrect-old-password": "Feil gammelt passord",
      "user-is-already-registered": "Brukeren er registrert fra før.",
      "your-password-has-been-changed": "Passordet ble endret.",
      "password-missing-uppercase": "Passordet oppfyller ikke kravene. Legg inn et passord med minst 1 stor bokstav.",
      "invalid-verification-provided": "Det ble brukt en utløpt lenke. Klikk på lenken i den siste e-posten for å tilbakestille passordet.",
      "email-used-by-different-user": "E-postadressen brukes av en annen bruker.",
      "password-not-long-enough": "Passordet oppfyller ikke kravene. Legg inn et passord med minst 8 tegn.",
      "an-error-occurred": "Det har oppstått en feil. Prøv på nytt senere.",
      "attempt-limit-exceeded": "Du har forsøkt å endre passord for ofte. Vent en stund, og start så endringen av passord fra begynnelsen.",
      "incorrect_old_password": "Feil gammelt passord",
      "password-missing-lowercase": "Passordet oppfyller ikke kravene. Legg inn et passord med minst 1 liten bokstav.",
      "generic-api-message": "Kontroller innstillingen din. Tast det inn på nytt for hånd. Kontakt vår support dersom feilen fortsatt foreligger."
    },
    "common": {
      "please-wait": "Vennligst vent",
      "send-code": "Send kode",
      "your-account": "Din Hella Gutmann-konto",
      "close": "Lukk",
      "please-fill-in-this-field": "Fyll ut dette feltet.",
      "hgsKey": "E-postadresse (hvis du har opprettet en personlig brukerkonto) eller kundenummer",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Administrer brukerprofilen din med Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Start prosedyren på nytt senere.</0> Kontakt Customer Center dersom problemet oppstår på nytt.",
      "this-field-cannot-be-left-blank": "Dette feltet må ikke være tomt.",
      "please-enter-your-login": "Angi din Login her. Vi sender så en 6-sifret kode til din e-postadresse. Tast inn denne koden på følgende side. Ikke lukk nettleseren.",
      "password-validation-error": "Passordet oppfyller ikke kravene.",
      "hide-password": "Skjul passord",
      "go-to-login": "Til Logg inn",
      "invalid-characters": "Du har lagt inn ikke tillatte tegn. Vennligst endre innstillingen.",
      "first-name-and-last-name-too-short": "Legg kun inn alfabetiske tegn og minst to tegn.",
      "an-error-occurred": "Det har oppstått en feil",
      "please-enter-a-valid-email-address": "Oppgi en gyldig e-postadresse. Tillatte tegn er alfanumeriske tegn og følgende spesialtegn: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Brukeren eksisterer ikke",
      "show-password": "Vis passord",
      "no-number-and-email": "Legg inn en gyldig e-postadresse eller ditt kundenummer som utelukkende består av tall.",
      "passwords-does-not-match": "Passordene stemmer ikke overens.",
      "user-does-not-exist": "Brukeren eksisterer ikke",
      "your-user-profile": "Din brukerprofil",
      "enter-code": "Legg inn koden"
    },
    "dashboard": {
      "logout": "Logge av",
      "lead": "Vennligst velg applikasjon som du vil bruke for å ta tilgang til din Hella Gutmann Account."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "\t\nFor å bruke mega macs S 20 må mega macs S 20-appen være installert på Android-enheten din. Appen er tilgjengelig via Play Store.",
      "x20-please-sign-in-title": "Logg inn på CSC-Tool X 20",
      "x20-please-sign-in-content": "Vennligst logg inn på CSC-Tool X 20 med din Hella Gutmann-konto.",
      "s20-please-start-device-title": "Logg inn på mega macs S 20"
    },
    "errorMessage": {
      "error": "Feil",
      "something-went-wrong": "Noe gikk galt."
    },
    "faq": {
      "howDoIChangePassword": "Hvordan kan jeg endre passordet for Hella Gutmann Account?",
      "howDoIGetAHellaGutmannAccount": "Hvordan får jeg en Hella Gutmann Account?",
      "possibleToUseMultipleAccounts": "Løsningen gir kunden anledning til å logge seg sikkert inn på flere applikasjoner og nettsteder til Hella Gutmann med bare en eneste tilgang og en enkelt påmelding én gang.",
      "backToLogin": "TILBAKE TIL LOGG INN",
      "itIsASingleSignOnSolution": "Hella Gutmann Account er Hella Gutmanns Single Sign-on løsning (SSO) . En e-postadresse og et selv valgt passord er nødvendig for å få tilgang.",
      "title": "Ofte stilte spørsmål (FAQ)",
      "whatIsAHellaGutmannAccount": "Hva er Hella Gutmann Account?",
      "supportedAppsConstantlyExpanded": "Antallet støttede applikasjoner utvides kontinuerlig. Per i dag støtter Hella Gutmann Account følgende applikasjoner",
      "alternativeContactSupport": "Alternativt kan du ta kontakt med vår kundeservice.",
      "howDoIResetPassword": "Hvordan tilbakestiller jeg passordet for Hella Gutmann Account?",
      "asSoonAsYouGetAccessToProducts": "Så snart du har kjøpt et av de støttede produktene, eller har fått berettigelse til å ta tilgang til macs365, mottar du en e-post med informasjon av innstillingen av en Hella Gutmann Account. E-posten sendes til den e-postadressen som er registrert hos oss gjennom en automatisert prosess.",
      "whatToDoIfNoEMailReceived": "Hva kan jeg gjøre hvis jeg ikke har mottatt e-posten for oppretting av Hella Gutmann Account?",
      "clickOnForgotPassword": "En mulighet er å søke om å få nødvendig e-post via<1>Passwort vergessen</1>. Påse da at angitt e-postadresse er identisk med den e-postadressen som er registrert hos oss.",
      "changeEmailOnUserProfile": "Du kan endre e-postadressen for din Hella Gutmann Account, som du bruker til login, via siden Brukerprofil (Brukerprofil er per i dag kun tilgjengelig for kunder med tilgang til macs365).",
      "changePasswordOnUserProfile": "Du kan endre passordet for Hella Gutmann Account via siden Brukerprofil (Brukerprofil er per i dag kun tilgjengelig for kunder med tilgang til macs365).",
      "howDoIChangeEmailAddress": "Hvordan kan jeg endre e-postadressen for Hella Gutmann Account?",
      "whichAppsAreSupported": "Hvilke applikasjoner støttes av Hella Gutmann Account?"
    },
    "footer": {
      "imprint": "Impressum",
      "faq": "FAQ",
      "faq-heading": "Ofte stilte spørsmål (FAQ)",
      "data-privacy-policy": "Personvernerklæring",
      "terms-and-conditions": "Betingelser for bruk"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "På grunn av for mange feil forsøk var det ikke mulig å sende en e-post. Prøv på nytt om et par timer.",
      "send-email": "Send",
      "reset-your-password": "Tilbakestill passordet ditt",
      "forgot-password-button-clicked-alert": "E-post ble vellykket sendt. Det kan i visse tilfeller ta et par minutter før den blir mottatt.",
      "back-to-login": "Tilbake til Logg inn",
      "enter-your-login-V2": "E-postadressen",
      "please-enter-your-login": "Angi din Login, så sender vi deg en e-post med bekreftelse. Klikk på knappen for verifisering i e-posten.",
      "enter-your-login": "Din Login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Velg et sikkert passord, og legg det inn i de to feltene.",
      "reset-your-password": "Sett nytt passord",
      "repeat-password": "Gjenta nytt passord",
      "a-verification-email-has-been-sent-to-you": "Det ble sendt deg en e-post med bekreftelse.",
      "reset-password": "Sett passord",
      "new-password": "Nytt passord",
      "passwords-do-not-match": "De to passordene stemmer ikke overens. Kontroller innstillingen."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Ditt nye passord er nå klar til bruk.",
      "setting-new-password-successful": "Nytt passord vellykket satt!",
      "go-to-login": "Til Logg inn"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTlf.: +49 7668 9900 888 \n\nFaks: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nFøderalt skattenummer: 07011/39801 \n\nMVA ID-nr: DE 14 220 8666 \n\nHandelsregister: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Impressum",
      "back": "TILBAKE TIL LOGG INN"
    },
    "menu": {
      "digital-products": "Digitale produkter"
    },
    "migration": {
      "helper-text-surname": "Angi etternavn",
      "description-submit": "Når du har sendt inn skjemaet, sender vi deg en melding til den angitte e-postadressen. Klikk på knappen for verifisering i denne meldingen for å bekrefte din e-postadresse.",
      "firstname": "Fornavn",
      "description-login": "Logg deg deretter på med din e-postadresse og ditt aktuelle passord. Pålogging med kundenummer vil ikke lenger være mulig.",
      "submit": "Send",
      "email": "E-postadresse",
      "page-title": "Din Hella Gutmann-konto",
      "helper-text-firstname": "Angi et fornavn",
      "surname": "Etternavn",
      "title": "Omstilling av din Login",
      "helper-text-email": "Angi en e-postadresse",
      "description-user-account": "Hella Gutmann omstiller til personlige brukerkontoer. Her må du legge inn et fornavn, et etternavn og en e-postadresse for din personlige brukerkonto."
    },
    "migrationError": {
      "go-to-login": "Til Logg inn",
      "your-email-address-could-not-get-confirmed": "Det var ikke mulig å bekrefte din nye e-postadresse. Sannsynligvis var lenken i din e-post blitt ugyldig. Vennligst registrer deg på nytt og start prosedyren fra begynnelsen igjen.",
      "change-of-your-login-failed": "Omstillingen av din Login mislyktes"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Vi har sendt deg en e-post</0> til den angitte e-postadressen. For å bekrefte e-postadressen må du gå til innboksen din og<2>klikke på knappen for verifisering i e-posten</2>.",
      "for-security-reasons": "Av sikkerhetsgrunner blir lenken ugyldig etter 24 timer. Hvis dette oppstår, må du starte prosedyren på nytt.",
      "sending-successful": "Overføring vellykket"
    },
    "migrationVerify": {
      "verification-button": "Bekreft",
      "verification-header": "Bekreftelse av brukerkonto",
      "verification-description": "Klikk på knappen for å bekrefte opprettelsen av din personalisert brukerkonto"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "E-postadresse bekreftet",
      "from-now-on-please-login-with-the-email": "Heretter må du logge deg på med denne e-postadressen og ditt passord.",
      "your-email-address-has-been-confirmed": "Din E-postadresse er bekreftet"
    },
    "needHelp": {
      "for-further-questions": "Vår hotline<1/> er tilgjengelig fra mandag til fredag, kl. 8:00 til 17:00 dersom du har flere spørsmål.",
      "need-help-logging-in": "Trenger du hjelp med påloggingen?",
      "here-you-will-find": "<0>Her</0> finner du løsninger på <2>ofte stilte spørsmål.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "liten bokstav",
      "uppercase-letter": "stor bokstav",
      "the-new-password-requires": "Regler for passord:",
      "characters": "Antall tegn",
      "number": "Tall"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Oppsigelsesfrist"
    },
    "settings": {
      "user-information-saved": "Brukerinformasjonen er lagret.",
      "update-user-information": "Brukerprofil",
      "new-password": "Nytt passord",
      "resend-verification": "Send verifisering på nytt",
      "save": "Lagre",
      "language-preference-saved": "Språkinnstillingen er lagret.",
      "email-has-been-sent": "Det ble sendt deg en e-post med bekreftelse.",
      "firstname": "Fornavn",
      "repeat-password": "Gjenta passord",
      "your-user-data": "Dine brukeropplysninger",
      "set-new-password": "Fastsette nytt passord",
      "email-is-not-verified-yet": "E-post er ikke verifisert enda",
      "old-password": "Gammelt passord",
      "new-login-info": "Husk at din nye e-postadresse også vil være din Login.",
      "update-your-email": "Oppdater e-postadressen din",
      "email": "E-postadresse",
      "incorrect-username-or-password": "Feil passord.",
      "back": "Tilbake",
      "resend": "Send på nytt",
      "update-your-language": "Foretrukket språk",
      "surname": "Etternavn",
      "passwords-do-not-match": "De to passordene stemmer ikke overens. Kontroller innstillingen.",
      "submit-new-email-info": "Når du oppgir en ny e-postadresse, sender vi deg en e-post med bekreftelse. Klikk på lenken i denne e-posten for å bekrefte din nye e-postadresse.",
      "this-language-will-be-used": "Dette språket benyttes for din personlige brukerkonto og dine e-poster. E-poster med faktura berøres ikke av dette."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Glemt passord?",
      "your-login-V2": "E-postadressen",
      "your-password": "Ditt passord",
      "sign-in-at-hella-gutmann": "Logge på hos Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Passordene stemmer ikke overens.",
      "noMatchedEmails": "E-postadressene stemmer ikke overens.",
      "lead": "Legg inn dine opplysninger for å opprette en Hella Gutmann-konto.",
      "descriptionUserAccountV2": "Hella Gutmann omstiller til personlige brukerkontoer. Her må du legge inn et fornavn, et etternavn og et passord for din personlige brukerkonto.",
      "password": "Passord",
      "descriptionLogin": "Etter kontrollen må du logge deg på med din e-postadresse og ditt passord.",
      "passwordLead": "Velg et sikkert passord, og legg det inn i de to feltene.",
      "familyName": "Etternavn",
      "repeatEmail": "Gjenta e-postadressen",
      "header": "Registrering",
      "email": "E-postadresse",
      "signup": "Registrering",
      "givenName": "Fornavn",
      "repeatPassword": "Gjenta passord",
      "descriptionUserAccount": "Hella Gutmann omstiller til personlige brukerkontoer. Her må du legge inn et fornavn, et etternavn, en e-postadresse og et passord for din personlige brukerkonto."
    },
    "signUpComplete": {
      "header": "Registrering vellykket",
      "info": "Vær oppmerksom på dette: For å kunne logge deg på din Hella Gutmann Account må du, i tillegg til å bruke det nettopp tildelte passordet, bruke den e-postadressen som vi sendte e-post med registreringsmeldingen til.",
      "yourUserProfile": "Din brukerprofil"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Overføring vellykket",
      "forSecurityReasons": "Av sikkerhetsgrunner blir lenken ugyldig etter 24 timer. Hvis dette skjer, må du logge deg inn på nytt med dine gamle tilgangsdata og starte prosedyren på nytt.",
      "weSentYouAnEmail": "<0>Vi har sendt deg en e-post</0> til den angitte e-postadressen. For å bekrefte e-postadressen må du gå til innboksen din og<2>klikke på knappen for verifisering i e-posten</2>.",
      "for-security-reasons": "Av sikkerhetsgrunner blir lenken ugyldig etter 24 timer. Hvis dette oppstår, må du starte prosedyren på nytt."
    },
    "signUpVerify": {
      "description": "Klikk på knappen for å bekrefte opprettelsen av din personalisert brukerkonto",
      "header": "Bekreftelse av brukerkonto",
      "button": "Bekreft"
    },
    "verify": {
      "verification-description": "Klikk på knappen for å bekrefte din e-postadresse",
      "verification-header": "Bekreftelse av e-postadresse",
      "verification-button": "BEKREFT"
    },
    "verifySuccess": {
      "your-user-profile": "Din brukerprofil",
      "from-now-on-we-will-send-you-messages": "Fra og med nå vil vi bruke din nye e-postadresse til all kommunikasjon med macs365.",
      "keep-in-mind-that-this-email": "Vær oppmerksom på at din nye e-postadresse fungerer som brukernavn under pålogging.",
      "change-of-email-address-successful": "Endringen av e-postadresse var vellykket."
    },
    "wizard": {
      "close": "Avslutte macs365"
    }
  },
  "cs": {
    "FAQModal": {
      "use-email-instead-of-customer": "K resetování hesla použijte místo svého čísla zákazníka svou e-mailovou adresu.",
      "missing-verification-email": "Neobdržel(a) jsem potvrzovací e-mail.",
      "missing-forgot-password-email": "Neobdržel(a) jsem e-mail \"Zapomenuté heslo\".",
      "creating-your-personalized": "Pokoušíte se vytvořit svůj osobní uživatelský účet přímo pomocí své e-mailové adresy. Nejprve se přihlaste svým číslem zákazníka a k vytvoření svého osobního uživatelského účtu postupujte podle kroků.",
      "use-email-instead-of-your-customer": "K přihlášení použijte místo svého čísla zákazníka svou e-mailovou adresu.",
      "frequently-asked-questions": "Často kladené otázky",
      "personalized-user-account": "Vytvořil(a) jste svůj osobní uživatelský účet?",
      "no": "Ne",
      "use-customer-without-de": "K resetování hesla použijte své číslo zákazníka (bez předpony \"DE\").",
      "yes": "Ano",
      "use-customer-without-de-prefix": "K přihlášení použijte své číslo zákazníka (bez předpony \"DE\") a k vytvoření svého osobního uživatelského účtu postupujte podle kroků.",
      "i-cannot-sign-in-to-my-account": "Nemohu se přihlásit."
    },
    "api": {
      "incorrect-username-or-password": "Chybné uživatelské jméno nebo neplatné heslo.",
      "invalid-code-provided": "Vyskytla se chyba. Se změnou hesla začněte znovu.",
      "user-does-not-exist": "Uživatel neexistuje",
      "password-validation-error": "Heslo nedpovídá požadavkům.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Uživatel neexistuje",
      "password-missing-number": "Heslo nedpovídá požadavkům. Zdejte heslo obsahující min. 1 číslici.",
      "incorrect-old-password": "Neplatné staré heslo",
      "user-is-already-registered": "Uživatel je již registrovaný.",
      "your-password-has-been-changed": "Vaše heslo bylo změněno.",
      "password-missing-uppercase": "Heslo nedpovídá požadavkům. Zadejte heslo obsahující min. 1 velké písmeno.",
      "invalid-verification-provided": "Byl použit již neplatný odkaz. Klikněte na odkaz v posledním e-mailu \"Resetovat heslo\".",
      "email-used-by-different-user": "E-mailovou adresu používá jiný uživatel.",
      "password-not-long-enough": "Heslo nedpovídá požadavkům. Zadejte heslo obsahující min. 8 míst.",
      "an-error-occurred": "Vyskytla se chyba. Zkuste to prosím znovu později.",
      "attempt-limit-exceeded": "Zkoušeli jste příliš často změnit heslo. Chvíli počkejte a se změnou hesla začněte znovu.",
      "incorrect_old_password": "Neplatné staré heslo",
      "password-missing-lowercase": "Heslo nedpovídá požadavkům. Zadejte heslo obsahující min. 1 malé písmeno.",
      "generic-api-message": "Zkontrolujte své zadání. Natipujte znovu rukou. Pokud chyba přetrvává, kontaktujte naši podporu."
    },
    "common": {
      "please-wait": "Čekejte prosím",
      "send-code": "Odeslat kód",
      "your-account": "Váš uživatelský účet Hella Gutmann",
      "close": "Zavřít",
      "please-fill-in-this-field": "Vyplňte toto políčko.",
      "hgsKey": "E-mailová adresa (pokud jste vytvořili svůj osobní uživatelský účet) nebo číslo zákazníka",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Spravujte svůj uživatelský profil s účtem Hella Gutmann.",
      "please-start-the-process-again-later": "<0>Spusťte proces později ještě jednou.</0> Pokud se problém vyskytne znovu, kontaktujte zákaznické centrum.",
      "this-field-cannot-be-left-blank": "Toto políčko nesmí zůstat prázdné.",
      "please-enter-your-login": "Zde zadejte své přihlášení. Na vaši e-mailovou adresu vám pak zašleme 6-místný kód. Zadejte tento kód na následující stránce. Nezavírejte svůj prohlížeč.",
      "password-validation-error": "Heslo nedpovídá požadavkům.",
      "hide-password": "Heslo již zadáno",
      "go-to-login": "K přihlášení",
      "invalid-characters": "Zadali jste nepřípustné znaky. Změňte své zadání.",
      "first-name-and-last-name-too-short": "Zadávejte jen abecední znaky a nejméně dva znaky.",
      "an-error-occurred": "Vyskytla se chyba",
      "please-enter-a-valid-email-address": "Zadejte platnou e-mailovou adresu. Povolené znaky jsou alfanumerické znaky a následující zvláštní znaky: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Uživatel neexistuje",
      "show-password": "Zobrazit heslo",
      "no-number-and-email": "Zadejte platnou e-mailovou adresu nebo číslo zákazníka obsahující výhradně číslice.",
      "passwords-does-not-match": "Hesla nejsou shodná.",
      "user-does-not-exist": "Uživatel neexistuje",
      "your-user-profile": "Váš uživatelský profil",
      "enter-code": "Zadejte kód"
    },
    "dashboard": {
      "logout": "Odhlásit",
      "lead": "Vyberte prosím aplikaci, ke které chcete mít přístup prostřednictvím svého účtu Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Pro používání mega macs S20 musí být na Vašem přístroji s androidem instalovaná aplikace mega macs S20. Aplikaci získáte v Play Store.",
      "x20-please-sign-in-title": "\t\nLogin k CSC-Tool X 20",
      "x20-please-sign-in-content": "Přihlaste se prosím vaším účtem Hella Gutmann Account do svého nástroje CSC X 20.",
      "s20-please-start-device-title": "Login k megamacsS20"
    },
    "errorMessage": {
      "error": "Chyba",
      "something-went-wrong": "Něco není OK."
    },
    "faq": {
      "howDoIChangePassword": "Jak je možné změnit heslo k účtu Hella Gutmann?",
      "howDoIGetAHellaGutmannAccount": "Jak získám účet Hella Gutmann?",
      "possibleToUseMultipleAccounts": "Řešení umožňuje zákazníkům přihlásit se bezpečně do více aplikací a na webové stránky Hella Gutmann prostřednictvím pouze jednoho přístupu a jednoho přihlášení.",
      "backToLogin": "ZPĚT K PŘIHLÁŠENÍ",
      "itIsASingleSignOnSolution": "Účet Hella Gutmann je řešení jednotného přihlášení (SSO) od společnosti Hella Gutmann. Pro přístup je vyžadována e-mailová adresa a heslo, které si sami zvolíte.",
      "title": "Nejčastější dotazy (FAQ)",
      "whatIsAHellaGutmannAccount": "Co je Hella Gutmann Account?",
      "supportedAppsConstantlyExpanded": "Počet podporovaných aplikací se neustále zvyšuje. Momentálně podporuje účet Hella Gutmann následující aplikace",
      "alternativeContactSupport": "Případně kontaktujte náš tým podpory.",
      "howDoIResetPassword": "Jak je možné obnovit heslo k účtu Hella Gutmann?",
      "asSoonAsYouGetAccessToProducts": "Jakmile získáte jeden z podporovaných produktů nebo oprávnění k přístupu k macs365, obdržíte e-mail ke zřízení účtu Hella Gutmann. E-mail je odesílán na e-mailovou adresu, která je u nás uložena prostřednictvím automatizovaného procesu.",
      "whatToDoIfNoEMailReceived": "Co mám dělat, když mi nepřišel e-mail ke zřízení účtu Hella Gutmann?",
      "clickOnForgotPassword": "Jednou z možností je vyžádat si potřebný e-mail přes <1>Zapomenuté heslo</1>. Ujistěte se, že zadaná e-mailová adresa je stejná jako e-mailová adresa, která je u nás uložena.",
      "changeEmailOnUserProfile": "E-mailovou adresu k vašemu účtu Hella Gutmann, kterou používáte k přihlašování, můžete změnit přes stránku Uživatelský profil (uživatelský profil je momentálně k dispozici pouze pro zákazníky s přístupem k macs365).",
      "changePasswordOnUserProfile": "Heslo k účtu Hella Gutmann můžete změnit přes stránku Uživatelský profil (uživatelský profil je momentálně k dispozici pouze pro zákazníky s přístupem k macs365).",
      "howDoIChangeEmailAddress": "Jak se změní e-mailová adresa k účtu Hella Gutmann?",
      "whichAppsAreSupported": "Jaké aplikace podporuje účet Hella Gutmann?"
    },
    "footer": {
      "imprint": "Tiráž",
      "faq": "FAQ",
      "faq-heading": "Nejčastější dotazy (FAQ)",
      "data-privacy-policy": "Prohlášení o ochraně osobních údajů",
      "terms-and-conditions": "Podmínky použití"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Z důvodu příliš mnoha chybných pokusů nebylo možné odeslání e-mailu. Zkuste to za pár hodin znovu.",
      "send-email": "Odeslat",
      "reset-your-password": "Resetovat své heslo",
      "forgot-password-button-clicked-alert": "E-mail byl úspěšně odeslán. Doručení může popř. trvat několik minut.",
      "back-to-login": "Zpět k přihlášení",
      "enter-your-login-V2": "E-mailová adresa",
      "please-enter-your-login": "Zadejte své přihlášení a my vám zašleme potvrzovací e-mail. V e-mailu klikněte na ověřovací plochu.",
      "enter-your-login": "Vaše přihlášení"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Zvolte bezpečné heslo a zadejte ho do obou políček.",
      "reset-your-password": "Určete nové heslo",
      "repeat-password": "Opakujte nové heslo",
      "a-verification-email-has-been-sent-to-you": "Byl vám zaslán potvrzující e-mail.",
      "reset-password": "Určete heslo",
      "new-password": "Nové heslo",
      "passwords-do-not-match": "Obě hesla se neshodují. Zkontrolujte své zadání."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Vaše nové heslo nyní můžete používat.",
      "setting-new-password-successful": "Nové heslo bylo úspěšně vytvořeno!",
      "go-to-login": "K přihlášení"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH\n\nAm Krebsbach 2\n\nD-79241 Ihringen\n\nTel.: +49 7668 9900 888\n\nFax: +49 7668 9900 3999\n\ninfo@hella-gutmann.com\n\nDaňové číslo: 07011/39801\n\nDIČ: DE 14 220 8666\n\nObchodní rejstřík: HRB 290194, Freiburg\n\nCEO: Adnan Cemal",
      "header": "Tiráž",
      "back": "ZPĚT K PŘIHLÁŠENÍ"
    },
    "menu": {
      "digital-products": "Digitální produkty"
    },
    "migration": {
      "helper-text-surname": "Zadejte příjmení",
      "description-submit": "Po odeslání formuláře vám zašleme zprávu na uvedenou e-mailovou adresu. Pro potvrzení vaší e-mailové adresy klikněte na ověřovací ikonu v této zprávě.",
      "firstname": "Jméno",
      "description-login": "Pak se přihlaste svou e-mailovou adresou a svým aktuálním heslem. Přihlášení prostřednictvím čísla zákazníka už nebude možné.",
      "submit": "Odeslat",
      "email": "E-mailová adresa",
      "page-title": "Váš uživatelský účet Hella Gutmann",
      "helper-text-firstname": "Zadejte křestní jméno",
      "surname": "Příjmení",
      "title": "Změna přihlašovacích údajů",
      "helper-text-email": "Zadejte e-mailovou adresu",
      "description-user-account": "Hella Gutmann přechází na osobní uživatelské účty. Zadejte zde své jméno, příjmení a e-mailovou adresu svého osobního uživatelského účtu."
    },
    "migrationError": {
      "go-to-login": "K přihlášení",
      "your-email-address-could-not-get-confirmed": "Nebylo možné potvrdit vaši novou e-mailovou adresu. Pravděpodobně již vypršela platnost odkazu ve vašem e-mailu. Přihlaste se prosím znovu a spusťte proces od začátku.",
      "change-of-your-login-failed": "Změna přihlašovacích údajů se nezdařila"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Uaslali jsme vám e-mail</0> na zadanou e-mailovou adresu. K potvrzení e-mailové adresy přejděte do své schránky a <2>klikněte na ověřovací plochu v e-mailu</2>.",
      "for-security-reasons": "Z bezpečnostních důvodů tento odkaz ztrácí svou platnost po 24 hodinách. Pokud k tomu dojde, znovu spusťte proces.",
      "sending-successful": "Předání bylo úspěšné"
    },
    "migrationVerify": {
      "verification-button": "Potvrdit",
      "verification-header": "Potvrzení uživatelského účtu",
      "verification-description": "K potvrzení vytvoření svého osobního uživatelského účtu klikněte na tlačítko"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "E-mailová adresa potvrzená",
      "from-now-on-please-login-with-the-email": "Od teď se přihlašujte prostřednictvím této e-mailové adresy a svého hesla.",
      "your-email-address-has-been-confirmed": "Vaše e-mailová adresa byla potvrzena"
    },
    "needHelp": {
      "for-further-questions": "V případě dalších dotazů je vám k dispozici naše technické call centrum <1/> pondělí až pátek v době od 8:00 do 17:00 hodin.",
      "need-help-logging-in": "Potřebujete při přihlášení pomoc?",
      "here-you-will-find": "<0>Zde</0> najdete řešení na <2>nejčastěji kladené dotazy.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "malé písmeno",
      "uppercase-letter": "velké písmeno",
      "the-new-password-requires": "Zadání pro heslo:",
      "characters": "místa",
      "number": "číslice"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Výpovědní lhůta"
    },
    "settings": {
      "user-information-saved": "Uživatelské informace byly uloženy.",
      "update-user-information": "Uživatelský profil",
      "new-password": "Nové heslo",
      "resend-verification": "Znovu odeslat ověření",
      "save": "Uložit",
      "language-preference-saved": "Nastavení jazyka bylo uloženo.",
      "email-has-been-sent": "Byl vám zaslán potvrzující e-mail.",
      "firstname": "Jméno",
      "repeat-password": "Opakování hesla",
      "your-user-data": "Vaše uživatelské údaje",
      "set-new-password": "Určete nové heslo",
      "email-is-not-verified-yet": "E-mail ještě není ověřen",
      "old-password": "Staré heslo",
      "new-login-info": "Nezapomeňte, že vaše nová e-mailová adresa bude také vašim přihlášením.",
      "update-your-email": "Aktualizujte svou e-mailovou adresu",
      "email": "E-mailová adresa",
      "incorrect-username-or-password": "Neplatné heslo.",
      "back": "Zpět",
      "resend": "Znovu odeslat",
      "update-your-language": "Upřednostňovaný jazyk",
      "surname": "Příjmení",
      "passwords-do-not-match": "Obě hesla se neshodují. Zkontrolujte své zadání.",
      "submit-new-email-info": "Pokud zadáte novou e-mailovou adresu, zašleme vám potvrzovací e-mail. K potvrzení své nové e-mailové adresy klikněte na odkaz v tomto e-mailu.",
      "this-language-will-be-used": "Tento jazyk se bude používat pro váš osobní uživatelský účet a vaše e-maily. E-mailů s fakturami se to netýká."
    },
    "signIn": {
      "sign-in": "Přihlášení",
      "forgot-your-password": "Zapomenuté heslo?",
      "your-login-V2": "E-mailová adresa",
      "your-password": "Vaše heslo",
      "sign-in-at-hella-gutmann": "Přihlášení u Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Hesla nejsou shodná.",
      "noMatchedEmails": "E-mailové adresy se neshodují.",
      "lead": "K vytvoření účtu Hella Gutmann zadejte své informace.",
      "descriptionUserAccountV2": "Hella Gutmann přechází na osobní uživatelské účty. Zadejte zde své jméno, příjmení a heslo svého osobního uživatelského účtu.",
      "password": "Heslo",
      "descriptionLogin": "Po kontrole se pak přihlaste svou e-mailovou adresou a svým heslem.",
      "passwordLead": "Zvolte bezpečné heslo a zadejte ho do obou políček.",
      "familyName": "Příjmení",
      "repeatEmail": "Opakujte e-mailovou adresu",
      "header": "Registrace",
      "email": "E-mailová adresa",
      "signup": "Registrovat",
      "givenName": "Jméno",
      "repeatPassword": "Opakujte heslo",
      "descriptionUserAccount": "Hella Gutmann mění na osobní uživatelské účty. Zadejte zde své jméno, příjmení, e-mailovou adresu a heslo svého osobního uživatelského účtu."
    },
    "signUpComplete": {
      "header": "Registrace byla úspěšná",
      "info": "Upozornění: Pro přihlášení k vašemu účtu Hella Gutmann použijte kromě právě zadaného hesla e-mailovou adresu, na kterou jsme zaslali registrační e-mail.",
      "yourUserProfile": "Váš uživatelský profil"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Předání bylo úspěšné",
      "forSecurityReasons": "Z bezpečnostních důvodů tento odkaz ztrácí svou platnost po 24 hodinách. Pokud k tomu dojde, přihlaste se znovu pomocí svých starých přístupových údajů a znovu spusťte proces.",
      "weSentYouAnEmail": "<0>Uaslali jsme vám e-mail</0> na zadanou e-mailovou adresu. K potvrzení e-mailové adresy přejděte do své schránky a <2>klikněte na ověřovací plochu v e-mailu</2>.",
      "for-security-reasons": "Z bezpečnostních důvodů tento odkaz ztrácí svou platnost po 24 hodinách. Pokud k tomu dojde, znovu spusťte proces."
    },
    "signUpVerify": {
      "description": "K potvrzení vytvoření svého osobního uživatelského účtu klikněte na tlačítko",
      "header": "Potvrzení uživatelského účtu",
      "button": "Potvrdit"
    },
    "verify": {
      "verification-description": "K potvrzení své e-mailové adresy klikněte na tlačítko",
      "verification-header": "Potvrzení e-mailové adresy",
      "verification-button": "POTVRDIT"
    },
    "verifySuccess": {
      "your-user-profile": "Váš uživatelský profil",
      "from-now-on-we-will-send-you-messages": "Pro veškerou komunikaci k macs365 budeme od tohoto okamžiku používat vaši novou e-mailovou adresu.",
      "keep-in-mind-that-this-email": "Myslete na to, že vaše nová e-mailová adresa je uživatelským jménem k přihlášení.",
      "change-of-email-address-successful": "Změna e-mailové adresy byla úspěšná."
    },
    "wizard": {
      "close": "Zavřít macs365"
    }
  },
  "el": {
    "FAQModal": {
      "use-email-instead-of-customer": "Αντί για τον αριθμό πελάτη σας, χρησιμοποιήστε τη διεύθυνση e-mail σας για να επαναφέρετε τον κωδικό πρόσβασής σας.",
      "missing-verification-email": "Δεν λαμβάνω το e-mail επιβεβαίωσης.",
      "missing-forgot-password-email": "Δεν λαμβάνω το e-mail \"Ξέχασα τον κωδικό πρόσβασής μου\".",
      "creating-your-personalized": "Προσπαθήστε να δημιουργήσετε τον προσωπικό λογαριασμό χρήστη σας απευθείας με τη διεύθυνση e-mail σας. Συνδεθείτε πρώτα με τον αριθμό πελάτη σας και ακολουθήστε τα βήματα, για να δημιουργήσετε τον προσωπικό σας λογαριασμό χρήστη.",
      "use-email-instead-of-your-customer": "Αντί για τον αριθμό πελάτη σας, χρησιμοποιήστε τη διεύθυνση e-mail σας κατά τη σύνδεση.",
      "frequently-asked-questions": "Συχνές ερωτήσεις",
      "personalized-user-account": "Έχετε δημιουργήσει προσωπικό λογαριασμό χρήστη;",
      "no": "Όχι",
      "use-customer-without-de": "Χρησιμοποιήστε τον αριθμό πελάτη σας (χωρίς το πρόθεμα \"DE\") για να επαναφέρετε τον κωδικό πρόσβασής σας.",
      "yes": "Ναι",
      "use-customer-without-de-prefix": "Χρησιμοποιήστε τον αριθμό πελάτη σας (χωρίς το πρόθεσμα \"DE\") για να συνδεθείτε και ακολουθήστε τα βήματα, για να δημιουργήσετε τον προσωπικό σας λογαριασμό χρήστη.",
      "i-cannot-sign-in-to-my-account": "Δεν μπορώ να συνδεθώ."
    },
    "api": {
      "incorrect-username-or-password": "Εσφαλμένο όνομα χρήστη ή εσφαλμένος κωδικός πρόσβασης.",
      "invalid-code-provided": "Προέκυψε ένα σφάλμα. Ξεκινήστε από την αρχή την αλλαγή του κωδικού πρόσβασης.",
      "user-does-not-exist": "Ο χρήστης δεν υπάρχει",
      "password-validation-error": "Ο κωδικός πρόσβασης δεν πληροί τις προδιαγραφές.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Ο χρήστης δεν υπάρχει",
      "password-missing-number": "Ο κωδικός πρόσβασης δεν πληροί τις προδιαγραφές. Καταχωρίστε έναν κωδικό πρόσβασης με τουλάχιστον 1 ψηφίο.",
      "incorrect-old-password": "Εσφαλμένος παλιός κωδικός πρόσβασης",
      "user-is-already-registered": "Ο χρήστης έχει καταχωριστεί ήδη.",
      "your-password-has-been-changed": "Ο κωδικός πρόσβασής σας άλλαξε.",
      "password-missing-uppercase": "Ο κωδικός πρόσβασης δεν πληροί τις προδιαγραφές. Καταχωρίστε έναν κωδικό πρόσβασης με τουλάχιστον 1 κεφαλαίο γράμμα.",
      "invalid-verification-provided": "Ο σύνδεσμος που χρησιμοποιήθηκε δεν ισχύει. Κάντε κλικ στον σύνδεσμο στο τελευταίο e-mail \"Επαναφορά κωδικού πρόσβασης\" που λάβατε.",
      "email-used-by-different-user": "Η διεύθυνση e-mail σας χρησιμοποιείται από άλλον χρήστη.",
      "password-not-long-enough": "Ο κωδικός πρόσβασης δεν πληροί τις προδιαγραφές. Καταχωρίστε έναν κωδικό πρόσβασης με τουλάχιστον 8 ψηφία.",
      "an-error-occurred": "Προέκυψε ένα σφάλμα. Δοκιμάστε ξανά αργότερα.",
      "attempt-limit-exceeded": "Δοκιμάσατε πολλές φορές να αλλάξετε τον κωδικό πρόσβασης. Περιμένετε λίγο και ξεκινήστε από την αρχή την αλλαγή του κωδικού πρόσβασης.",
      "incorrect_old_password": "Εσφαλμένος παλιός κωδικός πρόσβασης",
      "password-missing-lowercase": "Ο κωδικός πρόσβασης δεν πληροί τις προδιαγραφές. Καταχωρίστε έναν κωδικό πρόσβασης με τουλάχιστον 1 μικρό γράμμα.",
      "generic-api-message": "Ελέγξτε την καταχώρισή σας. Πληκτρολογήστε ξανά χειροκίνητα. Εάν εξακολουθεί να υπάρχει σφάλμα, επικοινωνήστε με την Υποστήριξή μας."
    },
    "common": {
      "please-wait": "Περιμένετε",
      "send-code": "Αποστολή κωδικού",
      "your-account": "Ο λογαριασμός χρήστη σας για τη Hella Gutmann",
      "close": "Κλείσιμο",
      "please-fill-in-this-field": "Συμπληρώστε αυτό το πεδίο.",
      "hgsKey": "Διεύθυνση e-mail (εάν έχετε δημιουργήσει προσωπικό λογαριασμό χρήστη) ή αριθμός πελάτη",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Διαχειριστείτε το προφίλ χρήστη σας με τους λογαριασμούς Hella Gutmann.",
      "please-start-the-process-again-later": "<0>Επανεκκινήστε τη διαδικασία αργότερα.</0> Εάν το πρόβλημα εμφανιστεί ξανά, επικοινωνήστε με το Customer Center.",
      "this-field-cannot-be-left-blank": "Αυτό το πεδίο δεν μπορεί να παραμείνει κενό.",
      "please-enter-your-login": "Καταχωρίστε εδώ τα στοιχεία σύνδεσής σας. Θα σας στείλουμε έναν 6ψήφιο κωδικό στη διεύθυνση e-mail σας. Καταχωρίστε αυτόν τον κωδικό στην παρακάτω σελίδα. Μην κλείσετε το πρόγραμμα περιήγησής σας.",
      "password-validation-error": "Ο κωδικός πρόσβασης δεν πληροί τις προδιαγραφές.",
      "hide-password": "Απόκρυψη κωδικού πρόσβασης",
      "go-to-login": "Μετάβαση στη σύνδεση",
      "invalid-characters": "Έχετε καταχωρίσει μη επιτρεπόμενα στοιχεία. Αλλάξτε την καταχώρισή σας.",
      "first-name-and-last-name-too-short": "Καταχωρίστε μόνο αλφαβητικά στοιχεία και τουλάχιστον 2 στοιχεία.",
      "an-error-occurred": "Προέκυψε ένα σφάλμα",
      "please-enter-a-valid-email-address": "Καταχωρίστε μια έγκυρη διεύθυνση e-mail. Τα επιτρεπόμενα στοιχεία είναι οι αλφαριθμητικοί χαρακτήρες και οι παρακάτω ειδικοί χαρακτήρες: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Ο χρήστης δεν υπάρχει",
      "show-password": "Εμφάνιση κωδικού πρόσβασης",
      "no-number-and-email": "Καταχωρίστε μια έγκυρη διεύθυνση e-mail ή τον αριθμό πελάτη σας, που αποτελείται αποκλειστικά από αριθμητικά ψηφία.",
      "passwords-does-not-match": "Οι κωδικοί πρόσβασης δεν συμφωνούν.",
      "user-does-not-exist": "Ο χρήστης δεν υπάρχει",
      "your-user-profile": "Το προφίλ χρήστη σας",
      "enter-code": "Καταχωρίστε τον κωδικό"
    },
    "dashboard": {
      "logout": "Αποσύνδεση",
      "lead": "Επιλέξτε την εφαρμογή στην οποία θέλετε να αποκτήσετε πρόσβαση με τον λογαριασμό Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Για να χρησιμοποιήσετε τα mega macs S 20, η εφαρμογή mega macs S 20 πρέπει να είναι εγκατεστημένη στη συσκευή σας Android. Η εφαρμογή είναι διαθέσιμη μέσω του Play Store.",
      "x20-please-sign-in-title": "Συνδεθείτε στο CSC-Tool X 20",
      "x20-please-sign-in-content": "Συνδεθείτε στο CSC-Tool X 20 με τον λογαριασμό σας στην Hella Gutmann.",
      "s20-please-start-device-title": "Συνδεθείτε στο mega macs S 20"
    },
    "errorMessage": {
      "error": "Σφάλμα",
      "something-went-wrong": "Κάτι πήγε στραβά."
    },
    "faq": {
      "howDoIChangePassword": "Πώς μπορώ να αλλάξω τον κωδικό πρόσβασης για τον λογαριασμό Hella Gutmann;",
      "howDoIGetAHellaGutmannAccount": "Πώς αποκτώ έναν λογαριασμό Hella Gutmann;",
      "possibleToUseMultipleAccounts": "Η λύση επιτρέπει στους πελάτες να συνδέονται με ασφάλεια σε πολλές εφαρμογές και ιστοσελίδες της Hella Gutmann με μία και μόνο πρόσβαση και σύνδεση.",
      "backToLogin": "ΕΠΙΣΤΡΟΦΗ ΣΤΗ ΣΥΝΔΕΣΗ",
      "itIsASingleSignOnSolution": "Ο λογαριασμός Hella Gutmann είναι η λύση Single Sign-on (SSO) της Hella Gutmann. Για την πρόσβαση απαιτείται μια διεύθυνση e-mail και ένας ελεύθερα επιλεγόμενος κωδικός πρόσβασης.",
      "title": "Συχνές Ερωτήσεις (FAQ)",
      "whatIsAHellaGutmannAccount": "Τι είναι ο λογαριασμός Hella Gutmann;",
      "supportedAppsConstantlyExpanded": "Το πλήθος των υποστηριζόμενων εφαρμογών διευρύνεται συνεχώς. Προς το παρόν, ο λογαριασμός Hella Gutmann υποστηρίζει τις παρακάτω εφαρμογές",
      "alternativeContactSupport": "Εναλλακτικά, επικοινωνήστε με το τμήμα υποστήριξης της εταιρείας μας.",
      "howDoIResetPassword": "Πώς ορίζω τον κωδικό πρόσβασης για τον λογαριασμό Hella Gutmann;",
      "asSoonAsYouGetAccessToProducts": "Μόλις αγοράσετε κάποιο από τα υποστηριζόμενα προϊόντα ή αποκτήσετε δικαιώματα πρόσβασης στο macs365, θα λάβετε ένα e-mail για να δημιουργήσετε έναν λογαριασμό Hella Gutmann. Το e-mail στέλνεται μέσω μιας αυτοματοποιημένης διαδικασίας στη διεύθυνση e-mail που έχετε δηλώσει.",
      "whatToDoIfNoEMailReceived": "Τι μπορώ να κάνω αν δεν λάβω το e-mail για τη δημιουργία του λογαριασμού Hella Gutmann;",
      "clickOnForgotPassword": "Μια δυνατότητα είναι να ζητηθεί το απαιτούμενο e-mail μέσω <1>Απώλεια κωδικού πρόσβασης</1>. Προσέξτε ότι η εισαγμένη διεύθυνση e-mail πρέπει να συμφωνεί με τη διεύθυνση e-mail που έχετε δηλώσει.",
      "changeEmailOnUserProfile": "Μπορείτε να αλλάξετε τη διεύθυνση e-mail του λογαριασμού Hella Gutmann που χρησιμοποιείτε για τη σύνδεση από τη σελίδα Προφίλ χρήστη (το Προφίλ χρήστη είναι προς το παρόν διαθέσιμο μόνο για πελάτες με πρόσβαση στο macs365).",
      "changePasswordOnUserProfile": "Μπορείτε να αλλάξετε τον κωδικό πρόσβασης του λογαριασμού Hella Gutmann από τη σελίδα Προφίλ χρήστη (το Προφίλ χρήστη είναι προς το παρόν διαθέσιμο μόνο για πελάτες με πρόσβαση στο macs365).",
      "howDoIChangeEmailAddress": "Πώς μπορώ να αλλάξω τη διεύθυνση e-mail για τον λογαριασμό Hella Gutmann;",
      "whichAppsAreSupported": "Ποιες εφαρμογές υποστηρίζονται από τον λογαριασμό Hella Gutmann;"
    },
    "footer": {
      "imprint": "Στοιχεία εκτύπωσης",
      "faq": "FAQ",
      "faq-heading": "Συχνές Ερωτήσεις (FAQ)",
      "data-privacy-policy": "Πολιτική απορρήτου",
      "terms-and-conditions": "Όροι χρήσης"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Η αποστολή ενός e-mail δεν ήταν δυνατή λόγω πολλών εσφαλμένων προσπαθειών. Προσπαθήστε ξανά σε μερικές ώρες.",
      "send-email": "Αποστολή",
      "reset-your-password": "Επαναφορά του κωδικού πρόσβασής σας",
      "forgot-password-button-clicked-alert": "Το e-mail σας εστάλη με επιτυχία. Η παράδοση μπορεί να διαρκέσει μερικά λεπτά υπό ορισμένες συνθήκες.",
      "back-to-login": "Επιστροφή στη σύνδεση",
      "enter-your-login-V2": "Διεύθυνση e-mail",
      "please-enter-your-login": "Καταχωρίστε εδώ τα στοιχεία σύνδεσής σας και θα σας στείλουμε ένα e-mail επιβεβαίωσης. Κάντε κλικ στην επιφάνεια επαλήθευσης στο e-mail.",
      "enter-your-login": "Τα στοιχεία σύνδεσής σας"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Επιλέξτε έναν ασφαλή κωδικό πρόσβασης και καταχωρίστε τον και στα δύο πεδία.",
      "reset-your-password": "Ορισμός νέου κωδικού πρόσβασης",
      "repeat-password": "Επανάληψη νέου κωδικού πρόσβασης",
      "a-verification-email-has-been-sent-to-you": "Θα σας σταλεί ένα e-mail επιβεβαίωσης.",
      "reset-password": "Ορισμός κωδικού πρόσβασης",
      "new-password": "Νέος κωδικός πρόσβασης",
      "passwords-do-not-match": "Οι δύο κωδικοί πρόσβασης δεν συμφωνούν. Ελέγξτε την καταχώρισή σας."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Ο νέος κωδικός πρόσβασής σας είναι έτοιμος να χρησιμοποιηθεί.",
      "setting-new-password-successful": "Επιτυχής ορισμός νέου κωδικού πρόσβασης!",
      "go-to-login": "Μετάβαση στη σύνδεση"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nΤηλ.: +49 7668 9900 888 \n\nΦαξ: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nΑρ. φορ. μητρώου: 07011/39801 \n\nΑρ. ΦΠΑ: DE 14 220 8666 \n\nΕμπορικό μητρώο: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Στοιχεία εκτύπωσης",
      "back": "ΕΠΙΣΤΡΟΦΗ ΣΤΗ ΣΥΝΔΕΣΗ"
    },
    "menu": {
      "digital-products": "Ψηφιακά προϊόντα"
    },
    "migration": {
      "helper-text-surname": "Καταχωρίστε ένα επώνυμο",
      "description-submit": "Αφότου στείλετε τη φόρμα, θα σας στείλουμε ένα μήνυμα στην αναφερόμενη διεύθυνση e-mail. Κάντε κλικ στο κουμπί επιβεβαίωσης αυτού του μηνύματος για να επιβεβαιώσετε τη διεύθυνση e-mail.",
      "firstname": "Όνομα",
      "description-login": "Κατόπιν συνδεθείτε με τη διεύθυνση e-mail σας και τον ισχύοντα κωδικό πρόσβασης. Δεν είναι πλέον εφικτή η σύνδεση με αριθμό πελάτη.",
      "submit": "Αποστολή",
      "email": "Διεύθυνση e-mail",
      "page-title": "Ο λογαριασμός χρήστη σας για τη Hella Gutmann",
      "helper-text-firstname": "Καταχωρίστε ένα όνομα",
      "surname": "Επώνυμο",
      "title": "Αλλαγή του τρόπου σύνδεσης",
      "helper-text-email": "Καταχωρίστε μια διεύθυνση e-mail",
      "description-user-account": "Η Hella Gutmann μεταβαίνει σε προσωπικούς λογαριασμούς χρηστών. Καταχωρίστε εδώ ένα όνομα, ένα επώνυμο και μια διεύθυνση e-mail για τον προσωπικό σας λογαριασμό χρήστη."
    },
    "migrationError": {
      "go-to-login": "Μετάβαση στη σύνδεση",
      "your-email-address-could-not-get-confirmed": "Η νέα διεύθυνση e-mail δεν ήταν εφικτό να επιβεβαιωθεί. Πιθανότατα έληξε ο σύνδεσμος του e-mail. Συνδεθείτε ξανά και ξεκινήστε τη διαδικασία από την αρχή.",
      "change-of-your-login-failed": "Η αλλαγή του τρόπου σύνδεσης απέτυχε"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Σας στείλαμε ένα e-mail</0> στη διεύθυνση e-mail που καταχωρίστηκε. Για να επιβεβαιώσετε τη διεύθυνση e-mail, πηγαίνετε στα εισερχόμενά σας και <2>κάντε κλικ στην επιφάνεια επαλήθευσης στο e-mail</2>.",
      "for-security-reasons": "Ο σύνδεσμος καθίσταται ανενεργός μετά από 24 ώρες για λόγους ασφαλείας. Σε περίπτωση που συμβεί αυτό, ξεκινήστε ξανά τη διαδικασία.",
      "sending-successful": "Επιτυχής μετάδοση"
    },
    "migrationVerify": {
      "verification-button": "Επιβεβαίωση",
      "verification-header": "Επιβεβαίωση του λογαριασμού χρήστη",
      "verification-description": "Κάντε κλικ στο κουμπί, για να επιβεβαιώσετε τη δημιουργία του προσωποποιημένου λογαριασμού χρήστη σας"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Η διεύθυνση e-mail επιβεβαιώθηκε",
      "from-now-on-please-login-with-the-email": "Από τώρα μπορείτε να συνδέεστε με αυτή τη διεύθυνση e-mail και τον κωδικό πρόσβασής σας.",
      "your-email-address-has-been-confirmed": "Η διεύθυνση e-mail σας επιβεβαιώθηκε"
    },
    "needHelp": {
      "for-further-questions": "Για περισσότερες απορίες, μπορείτε να επικοινωνήσετε με την γραμμή εξυπηρέτησης <1/> από τη Δευτέρα έως την Παρασκευή, 8:00 έως 17:00.",
      "need-help-logging-in": "Χρειάζεστε βοήθεια για να συνδεθείτε;",
      "here-you-will-find": "<0>Εδώ</0> θα βρείτε λύσεις για <2>συχνές ερωτήσεις.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "μικρό γράμμα",
      "uppercase-letter": "κεφαλαίο γράμμα",
      "the-new-password-requires": "Προδιαγραφές κωδικού πρόσβασης:",
      "characters": "Στοιχεία",
      "number": "Ψηφία"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Προθεσμία υπαναχώρησης"
    },
    "settings": {
      "user-information-saved": "Οι πληροφορίες χρήστη αποθηκεύτηκαν.",
      "update-user-information": "Προφίλ χρήστη",
      "new-password": "Νέος κωδικός πρόσβασης",
      "resend-verification": "Εκ νέου αποστολή επαλήθευσης",
      "save": "Αποθήκευση",
      "language-preference-saved": "Η ρύθμιση γλώσσας αποθηκεύτηκε.",
      "email-has-been-sent": "Θα σας σταλεί ένα e-mail επιβεβαίωσης.",
      "firstname": "Όνομα",
      "repeat-password": "Επανάληψη κωδικού πρόσβασης",
      "your-user-data": "Τα στοιχεία χρήστη σας",
      "set-new-password": "Ορισμός νέου κωδικού πρόσβασης",
      "email-is-not-verified-yet": "Το e-mail δεν έχει επαληθευτεί ακόμα",
      "old-password": "Παλιός κωδικός πρόσβασης",
      "new-login-info": "Λάβετε υπόψη ότι θα χρησιμοποιείτε τη νέα διεύθυνση e-mail σας για να συνδεθείτε.",
      "update-your-email": "Ενημερώστε τη διεύθυνση e-mail σας",
      "email": "Διεύθυνση e-mail",
      "incorrect-username-or-password": "Εσφαλμένος κωδικός πρόσβασης.",
      "back": "Επιστροφή",
      "resend": "Εκ νέου αποστολή",
      "update-your-language": "Γλώσσα προτίμησης",
      "surname": "Επώνυμο",
      "passwords-do-not-match": "Οι δύο κωδικοί πρόσβασης δεν συμφωνούν. Ελέγξτε την καταχώρισή σας.",
      "submit-new-email-info": "Όταν καταχωρίσετε μια νέα διεύθυνση e-mail, θα σας στείλουμε ένα e-mail επιβεβαίωσης. Κάντε κλικ στον σύνδεσμο σε αυτό το e-mail, για να επιβεβαιώσετε μια νέα διεύθυνση e-mail.",
      "this-language-will-be-used": "Αυτή η γλώσσα θα χρησιμοποιηθεί για τον προσωπικό λογαριασμό χρήστη σας και για τα e-mail σας. Τα e-mail τιμολόγησης δεν επηρεάζονται."
    },
    "signIn": {
      "sign-in": "Σύνδεση",
      "forgot-your-password": "Ξεχάσατε τον κωδικό πρόσβασής σας;",
      "your-login-V2": "Διεύθυνση e-mail",
      "your-password": "Ο κωδικός πρόσβασής σας",
      "sign-in-at-hella-gutmann": "Σύνδεση στη Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Οι κωδικοί πρόσβασης δεν συμφωνούν.",
      "noMatchedEmails": "Οι διευθύνσεις e-mail δεν συμφωνούν.",
      "lead": "Καταχωρίστε τις πληροφορίες σας, για να δημιουργήσετε έναν λογαριασμό Hella Gutmann.",
      "descriptionUserAccountV2": "Η Hella Gutmann μεταβαίνει σε προσωπικούς λογαριασμούς χρηστών. Καταχωρίστε εδώ ένα όνομα, ένα επώνυμο και έναν κωδικό πρόσβασης για τον προσωπικό σας λογαριασμό χρήστη.",
      "password": "Κωδικός πρόσβασης",
      "descriptionLogin": "Μετά τον έλεγχο, συνδεθείτε με τη διεύθυνση e-mail και τον κωδικό σας.",
      "passwordLead": "Επιλέξτε έναν ασφαλή κωδικό πρόσβασης και καταχωρίστε τον και στα δύο πεδία.",
      "familyName": "Επώνυμο",
      "repeatEmail": "Επανάληψη διεύθυνσης e-mail",
      "header": "Καταχώριση",
      "email": "Διεύθυνση e-mail",
      "signup": "Καταχώριση",
      "givenName": "Όνομα",
      "repeatPassword": "Επανάληψη κωδικού πρόσβασης",
      "descriptionUserAccount": "Η Hella Gutmann μεταβαίνει σε προσωπικούς λογαριασμούς χρηστών. Καταχωρίστε εδώ ένα όνομα, ένα επώνυμο, μια διεύθυνση e-mail και έναν κωδικό πρόσβασης για τον προσωπικό σας λογαριασμό χρήστη."
    },
    "signUpComplete": {
      "header": "Επιτυχής καταχώριση",
      "info": "Προσέξτε: Για να συνδεθείτε στον λογαριασμό Hella Gutmann, εκτός από τον εκχωρημένο κωδικό πρόσβασης, χρησιμοποιήστε τη διεύθυνση e-mail στην οποία σας στείλαμε το e-mail της εγγραφής.",
      "yourUserProfile": "Το προφίλ χρήστη σας"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Επιτυχής μετάδοση",
      "forSecurityReasons": "Ο σύνδεσμος καθίσταται ανενεργός μετά από 24 ώρες για λόγους ασφαλείας. Σε περίπτωση που συμβεί αυτό, συνδεθείτε ξανά με τα παλιά στοιχεία σύνδεσης και ξεκινήστε ξανά τη διαδικασία.",
      "weSentYouAnEmail": "<0>Σας στείλαμε ένα e-mail</0> στη διεύθυνση e-mail που καταχωρίστηκε. Για να επιβεβαιώσετε τη διεύθυνση e-mail, πηγαίνετε στα εισερχόμενά σας και <2>κάντε κλικ στην επιφάνεια επαλήθευσης στο e-mail</2>.",
      "for-security-reasons": "Ο σύνδεσμος καθίσταται ανενεργός μετά από 24 ώρες για λόγους ασφαλείας. Σε περίπτωση που συμβεί αυτό, ξεκινήστε ξανά τη διαδικασία."
    },
    "signUpVerify": {
      "description": "Κάντε κλικ στο κουμπί, για να επιβεβαιώσετε τη δημιουργία του προσωποποιημένου λογαριασμού χρήστη σας",
      "header": "Επιβεβαίωση του λογαριασμού χρήστη",
      "button": "Επιβεβαίωση"
    },
    "verify": {
      "verification-description": "Κάντε κλικ στο κουμπί, για να επιβεβαιώσετε μια νέα διεύθυνση e-mail",
      "verification-header": "Επιβεβαίωση διεύθυνσης e-mail",
      "verification-button": "ΕΠΙΒΕΒΑΙΩΣΗ"
    },
    "verifySuccess": {
      "your-user-profile": "Το προφίλ χρήστη σας",
      "from-now-on-we-will-send-you-messages": "Πλέον θα χρησιμοποιούμε τη νέα διεύθυνση e-mail σας για κάθε επικοινωνία σχετικά με το macs365.",
      "keep-in-mind-that-this-email": "Λάβετε υπόψη ότι η νέα διεύθυνση e-mail που καταχωρίστηκε χρησιμεύει και ως όνομα χρήστη για σύνδεση.",
      "change-of-email-address-successful": "Η αλλαγή της διεύθυνσης e-mail πραγματοποιήθηκε με επιτυχία."
    },
    "wizard": {
      "close": "Κλείσιμο macs365"
    }
  },
  "es": {
    "FAQModal": {
      "use-email-instead-of-customer": "Para restablecer la contraseña, indique su dirección de e-mail en lugar de su n.º de cliente.",
      "missing-verification-email": "No recibo el e-mail de confirmación.",
      "missing-forgot-password-email": "No recibo el e-mail \"¿Olvidó su contraseña?\".",
      "creating-your-personalized": "Está intentando crear su cuenta de usuario personal directamente con su dirección de correo electrónico. En primer lugar inicie sesión con su número de cliente y siga entonces los pasos indicados para crear su cuenta de usuario personal.",
      "use-email-instead-of-your-customer": "Para iniciar sesión, indique su dirección de e-mail en lugar de su n.º de cliente.",
      "frequently-asked-questions": "Preguntas frecuentes",
      "personalized-user-account": "¿Ha creado una cuenta de usuario personal?",
      "no": "No",
      "use-customer-without-de": "Utilice su n.º de cliente (sin el prefijo \"DE\") para restablecer su contraseña.",
      "yes": "Sí",
      "use-customer-without-de-prefix": "Para iniciar sesión, indique su número de cliente (sin el prefijo \"DE\") y siga entonces los pasos para crear su cuenta de usuario personal.",
      "i-cannot-sign-in-to-my-account": "No puedo conectarme."
    },
    "api": {
      "incorrect-username-or-password": "Nombre de usuario o contraseña incorrectos.",
      "invalid-code-provided": "Ha surgido un error. Inicie el procedimiento de modificación de contraseña desde el principio.",
      "user-does-not-exist": "El usuario indicado no existe",
      "password-validation-error": "La contraseña no cumple con el formato requerido.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "El usuario indicado no existe",
      "password-missing-number": "La contraseña no cumple con el formato requerido. Introduzca una contraseña con al menos 1 cifra.",
      "incorrect-old-password": "Contraseña anterior incorrecta",
      "user-is-already-registered": "Este usuario ya está registrado.",
      "your-password-has-been-changed": "Su contraseña ha sido modificada.",
      "password-missing-uppercase": "La contraseña no cumple con el formato requerido. Introduzca una contraseña con al menos 1 letra mayúscula.",
      "invalid-verification-provided": "Se ha utilizado un enlace expirado. Haga clic en el enlace disponible en el último e-mail \"Restablecer contraseña\".",
      "email-used-by-different-user": "La dirección de e-mail está siendo utilizada por otro usuario.",
      "password-not-long-enough": "La contraseña no cumple con el formato requerido. Introduzca una contraseña con al menos 8 cifras.",
      "an-error-occurred": "Ha surgido un error. Inténtelo de nuevo posteriormente.",
      "attempt-limit-exceeded": "Ha intentado modificar la contraseña con demasiada frecuencia. Espere un poco y reinicie el procedimiento de modificación de contraseña desde el principio.",
      "incorrect_old_password": "Contraseña anterior incorrecta",
      "password-missing-lowercase": "La contraseña no cumple con el formato requerido. Introduzca una contraseña con al menos 1 letra minúscula.",
      "generic-api-message": "Compruebe la entrada efectuada. Introdúzcala de nuevo manualmente. Si el error persiste, póngase en contacto con nuestro equipo de asistencia técnica."
    },
    "common": {
      "please-wait": "Espere unos momentos",
      "send-code": "Enviar el código",
      "your-account": "Su cuenta de usuario Hella Gutmann",
      "close": "Cerrar",
      "please-fill-in-this-field": "Rellene este campo.",
      "hgsKey": "Dirección de e-mail (si ha creado una cuenta de usuario personal) o n.º de cliente",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Gestione su perfil de usuario en el espacio Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Intente reactivar el proceso posteriormente.</0> Si vuelve a surgir el problema, póngase en contacto con nuestro servicio de asistencia al cliente.",
      "this-field-cannot-be-left-blank": "Este campo no puede quedarse en blanco.",
      "please-enter-your-login": "Introduzca sus datos de acceso. A continuación, le enviaremos un código de 6 dígitos a su dirección de e-mail. Introduzca ese código en la página a continuación. No cierre su navegador.",
      "password-validation-error": "La contraseña no cumple con el formato requerido.",
      "hide-password": "Ocultar la contraseña",
      "go-to-login": "Al inicio de sesión",
      "invalid-characters": "Ha introducido caracteres no permitidos. Modifique su entrada.",
      "first-name-and-last-name-too-short": "Introduzca sólo caracteres alfabéticos y al menos dos caracteres.",
      "an-error-occurred": "Ha surgido un error",
      "please-enter-a-valid-email-address": "Indique una dirección de e-mail válida. Los caracteres permitidos son caracteres alfanuméricos y los siguientes caracteres especiales: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "El usuario indicado no existe",
      "show-password": "Visualizar la contraseña",
      "no-number-and-email": "Indique una dirección de e-mail válida o bien su n.º de cliente que contiene únicamente cifras.",
      "passwords-does-not-match": "Las contraseñas no coinciden.",
      "user-does-not-exist": "El usuario indicado no existe",
      "your-user-profile": "Su perfil de usuario",
      "enter-code": "Indique el código"
    },
    "dashboard": {
      "logout": "Cerrar sesión",
      "lead": "Seleccione la aplicación a la que desea acceder con su cuenta Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Para poder utilizar mega macs S 20, es necesario instalar la aplicación mega macs S 20 en su dispositivo Android. La aplicación está disponible en Play Store.",
      "x20-please-sign-in-title": "\t\nInicio sesión CSC-Tool X 20",
      "x20-please-sign-in-content": "Conéctese en su CSC-Tool X 20 con su cuenta de Hella Gutmann.",
      "s20-please-start-device-title": "Inicio sesión mega macs S 20"
    },
    "errorMessage": {
      "error": "Error",
      "something-went-wrong": "Se ha producido un fallo."
    },
    "faq": {
      "howDoIChangePassword": "¿Cómo puedo modificar la contraseña utilizada para mi cuenta Hella Gutmann?",
      "howDoIGetAHellaGutmannAccount": "¿Cómo puedo obtener una cuenta Hella Gutmann?",
      "possibleToUseMultipleAccounts": "La solución permite a los clientes iniciar sesión de forma segura en varias aplicaciones y sitios web de Hella Gutmann con un solo acceso y un solo inicio de sesión.",
      "backToLogin": "VOLVER AL INICIO DE SESIÓN",
      "itIsASingleSignOnSolution": "La cuenta Hella Gutmann es la solución de inicio de sesión único (SSO) de Hella Gutmann. El acceso requiere una dirección de correo electrónico y una contraseña propia.",
      "title": "Preguntas frecuentes (FAQ)",
      "whatIsAHellaGutmannAccount": "¿Qué es la cuenta Hella Gutmann?",
      "supportedAppsConstantlyExpanded": "El número de aplicaciones compatibles se amplía constantemente. Actualmente, la cuenta Hella Gutmann soporta las siguientes aplicaciones",
      "alternativeContactSupport": "Como alternativa puede ponerse en contacto con nuestro servicio de asistencia técnica.",
      "howDoIResetPassword": "¿Cómo puedo resetear la contraseña utilizada para mi cuenta Hella Gutmann?",
      "asSoonAsYouGetAccessToProducts": "En cuanto haya adquirido uno de los productos compatibles o haya sido autorizado para acceder a macs365, recibirá un correo electrónico para configurar una cuenta de Hella Gutmann. El correo electrónico se envía a la dirección de correo electrónico que tenemos registrada mediante un proceso automatizado.",
      "whatToDoIfNoEMailReceived": "¿Qué puedo hacer si no he recibido el correo electrónico para configurar la cuenta de Hella Gutmann?",
      "clickOnForgotPassword": "Una opción es solicitar el correo electrónico requerido a través de <1>Contraseña olvidada</1>. Asegúrese de que la dirección de correo electrónico indicada coincida con la que tenemos registrada.",
      "changeEmailOnUserProfile": "Puede modificar la dirección de correo electrónico de su cuenta Hella Gutmann, que utiliza para iniciar sesión, a través de >Perfil del usuario< (actualmente, el perfil de usuario sólo está disponible para clientes con acceso a macs365).",
      "changePasswordOnUserProfile": "Puede modificar la contraseña a través de la página >Perfil del usuario< (actualmente, el perfil de usuario sólo está disponible para clientes con acceso a macs365).",
      "howDoIChangeEmailAddress": "¿Cómo puedo modificar la dirección de correo electrónico utilizada para mi cuenta Hella Gutmann?",
      "whichAppsAreSupported": "¿Qué aplicaciones son soportadas por la cuenta Hella Gutmann?"
    },
    "footer": {
      "imprint": "Pie de imprenta y aviso legal",
      "faq": "FAQ",
      "faq-heading": "Preguntas frecuentes (FAQ)",
      "data-privacy-policy": "Política de privacidad",
      "terms-and-conditions": "Condiciones de uso"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "El envío de un e-mail no ha sido posible debido a demasiados intentos fallidos. Inténtelo de nuevo dentro de unas horas.",
      "send-email": "Enviar",
      "reset-your-password": "Restablecer la contraseña",
      "forgot-password-button-clicked-alert": "El e-mail se ha enviado correctamente. La recepción del e-mail puede tardar unos minutos.",
      "back-to-login": "Volver al inicio de sesión",
      "enter-your-login-V2": "Dirección de e-mail",
      "please-enter-your-login": "Introduzca sus datos de acceso y le enviaremos un e-mail de confirmación. Haga clic en el botón de verificación que aparece en el e-mail.",
      "enter-your-login": "Sus datos de acceso"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Elija una contraseña segura e introdúzcala en ambos campos.",
      "reset-your-password": "Definir una nueva contraseña",
      "repeat-password": "Repetir la nueva contraseña",
      "a-verification-email-has-been-sent-to-you": "Un e-mail de confirmación ha sido enviado a su dirección.",
      "reset-password": "Definir una contraseña",
      "new-password": "Nueva contraseña",
      "passwords-do-not-match": "Las dos contraseñas no coinciden. Compruebe la entrada efectuada."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Ahora puede utilizar su nueva contraseña.",
      "setting-new-password-successful": "Nueva contraseña creada con éxito.",
      "go-to-login": "Al inicio de sesión"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen (Alemania) \n\nTel.: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nN.º de identificación fiscal: 07011/39801 \n\nUSt-IdNr: DE 14 220 8666 \n\nRegistro Mercantil: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Pie de imprenta y aviso legal",
      "back": "VOLVER AL INICIO DE SESIÓN"
    },
    "menu": {
      "digital-products": "Productos digitales"
    },
    "migration": {
      "helper-text-surname": "Indique un apellido",
      "description-submit": "Tras enviar el formulario, le enviaremos un mensaje a la dirección de correo electrónico que nos haya facilitado. Haga clic en el botón de verificación de este mensaje para confirmar su dirección de correo electrónico.",
      "firstname": "Nombre",
      "description-login": "A continuación, puede iniciar sesión con su dirección de e-mail y su contraseña actual. El inicio de sesión con su n.º de cliente ya no será posible.",
      "submit": "Enviar",
      "email": "Dirección de e-mail",
      "page-title": "Su cuenta de usuario Hella Gutmann",
      "helper-text-firstname": "Indique un nombre de pila",
      "surname": "Apellido/s",
      "title": "Modificación de sus datos de inicio de sesión",
      "helper-text-email": "Indique una dirección de correo electrónico",
      "description-user-account": "Hella Gutmann modifica los procedimientos de autentificación e introduce la cuenta de usuario personal. Indique un nombre, apellido/s y una dirección de e-mail para su cuenta de usuario personal."
    },
    "migrationError": {
      "go-to-login": "Al inicio de sesión",
      "your-email-address-could-not-get-confirmed": "No ha sido posible confirmar su nueva dirección de correo electrónico. Lo más probable es que el enlace de su correo electrónico ya haya caducado. Inicie sesión de nuevo y comience el proceso desde el principio.",
      "change-of-your-login-failed": "Modificación fallida de sus datos de inicio de sesión"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Le hemos enviado un e-mail</0> a la dirección de e-mail indicada. Para confirmar la dirección de e-mail, vaya a la bandeja de entrada de su correo electrónico y <2>haga clic en el botón de verificación contenido en el e-mail</2>.",
      "for-security-reasons": "Por motivos de seguridad, el enlace deja de ser válido transcurridas 24 horas. Si eso ocurre, repita de nuevo todo el procedimiento.",
      "sending-successful": "Transmisión realizada con éxito"
    },
    "migrationVerify": {
      "verification-button": "Confirmar",
      "verification-header": "Confirmación de su cuenta de usuario",
      "verification-description": "Haga clic en el botón para confirmar la creación de su cuenta de usuario personalizada"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Correo electrónico confirmado",
      "from-now-on-please-login-with-the-email": "A partir de ahora, iniciará sesión únicamente con esta dirección de correo electrónico y su contraseña.",
      "your-email-address-has-been-confirmed": "Su dirección de correo electrónico ha sido confirmada"
    },
    "needHelp": {
      "for-further-questions": "Para resolver cualquier otra pregunta o duda, nuestro Servicio de Asistencia Técnica<1/> estará a su disposición de lunes a viernes, de las 8:00 a las 17:00 horas.",
      "need-help-logging-in": "¿Necesita ayuda para iniciar sesión?",
      "here-you-will-find": "<0>Aquí</0> encontrará soluciones a <2>las preguntas frecuentes (FAQ).</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "Letra minúscula",
      "uppercase-letter": "Letra mayúscula",
      "the-new-password-requires": "Requisitos de la contraseña:",
      "characters": "Caracteres",
      "number": "Cifras"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Plazo de rescisión"
    },
    "settings": {
      "user-information-saved": "Los datos del usuario han sido memorizados.",
      "update-user-information": "Perfil de usuario",
      "new-password": "Nueva contraseña",
      "resend-verification": "Enviar de nuevo la verificación",
      "save": "Guardar",
      "language-preference-saved": "La configuración de idioma se ha guardado.",
      "email-has-been-sent": "Un e-mail de confirmación ha sido enviado a su dirección.",
      "firstname": "Nombre",
      "repeat-password": "Repetir contraseña",
      "your-user-data": "Sus datos de usuario",
      "set-new-password": "Crear una nueva contraseña",
      "email-is-not-verified-yet": "El e-mail todavía no ha sido verificado",
      "old-password": "Contraseña antigua",
      "new-login-info": "Recuerde que su nueva dirección de e-mail será también su nueva información de acceso o inicio de sesión.",
      "update-your-email": "Actualice su dirección de e-mail",
      "email": "Dirección de e-mail",
      "incorrect-username-or-password": "Contraseña incorrecta.",
      "back": "Atrás",
      "resend": "Enviar de nuevo",
      "update-your-language": "Idioma preferido",
      "surname": "Apellido/s",
      "passwords-do-not-match": "Las dos contraseñas no coinciden. Compruebe la entrada efectuada.",
      "submit-new-email-info": "Si indica una nueva dirección de e-mail, le enviaremos un e-mail de confirmación. Haga clic en el enlace contenido en este e-mail para confirmar su nueva dirección de e-mail.",
      "this-language-will-be-used": "Este idioma se utiliza para su cuenta de usuario y su dirección de e-mail. Los e-mails relativos a la facturación no se ven afectados por esta elección."
    },
    "signIn": {
      "sign-in": "Datos de acceso",
      "forgot-your-password": "¿Ha olvidado su contraseña?",
      "your-login-V2": "Dirección de e-mail",
      "your-password": "Su contraseña",
      "sign-in-at-hella-gutmann": "Iniciar sesión en Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Las contraseñas no coinciden.",
      "noMatchedEmails": "Las direcciones de e-mail no coinciden.",
      "lead": "Introduzca sus datos para crear una cuenta Hella Gutmann.",
      "descriptionUserAccountV2": "Hella Gutmann modifica los procedimientos de autentificación e introduce la cuenta de usuario personal. Indique un nombre, apellido/s y una contraseña para su cuenta de usuario personal.",
      "password": "Contraseña",
      "descriptionLogin": "Tras la verificación, puede iniciar sesión con su dirección de e-mail y su contraseña.",
      "passwordLead": "Elija una contraseña segura e introdúzcala en ambos campos.",
      "familyName": "Apellido/s",
      "repeatEmail": "Repetir la dirección de e-mail",
      "header": "Registro",
      "email": "Dirección de e-mail",
      "signup": "Registrar",
      "givenName": "Nombre",
      "repeatPassword": "Repetir contraseña",
      "descriptionUserAccount": "Hella Gutmann modifica los procedimientos de autentificación e introduce la cuenta de usuario personal. Indique un nombre, apellido/s, una dirección de e-mail y una contraseña para su cuenta de usuario personal."
    },
    "signUpComplete": {
      "header": "Registro realizado correctamente",
      "info": "Atención: Para acceder a su cuenta de Hella Gutmann, utilice la contraseña que le acabamos de enviar y la dirección de correo electrónico a la que hemos enviado el correo de registro.",
      "yourUserProfile": "Su perfil de usuario"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Transmisión realizada con éxito",
      "forSecurityReasons": "Por motivos de seguridad, el enlace deja de ser válido transcurridas 24 horas. Si eso ocurre, inicie sesión de nuevo con sus datos de acceso antiguos y repita todo el procedimiento.",
      "weSentYouAnEmail": "<0>Le hemos enviado un e-mail</0> a la dirección de e-mail indicada. Para confirmar la dirección de e-mail, vaya a la bandeja de entrada de su correo electrónico y <2>haga clic en el botón de verificación contenido en el e-mail</2>.",
      "for-security-reasons": "Por motivos de seguridad, el enlace deja de ser válido transcurridas 24 horas. Si eso ocurre, repita de nuevo todo el procedimiento."
    },
    "signUpVerify": {
      "description": "Haga clic en el botón para confirmar la creación de su cuenta de usuario personalizada",
      "header": "Confirmación de su cuenta de usuario",
      "button": "Confirmar"
    },
    "verify": {
      "verification-description": "Haga clic en el botón para confirmar su nueva dirección de e-mail",
      "verification-header": "Confirmación de la dirección de e-mail",
      "verification-button": "CONFIRMAR"
    },
    "verifySuccess": {
      "your-user-profile": "Su perfil de usuario",
      "from-now-on-we-will-send-you-messages": "A partir de ahora utilizaremos su nueva dirección de e-mail para cualquier comunicación con macs365.",
      "keep-in-mind-that-this-email": "Tenga en cuenta que su nueva dirección de e-mail sirve también como nombre de usuario para iniciar sesión.",
      "change-of-email-address-successful": "Modificación de la dirección de e-mail realizada con éxito."
    },
    "wizard": {
      "close": "Cerrar macs365"
    }
  },
  "fr": {
    "FAQModal": {
      "use-email-instead-of-customer": "Pour réinitialiser votre mot de passe, veuillez utiliser votre adresse d'E-Mail à la place du Nr client.",
      "missing-verification-email": "Je ne reçois pas l'E-Mail de conformation.",
      "missing-forgot-password-email": "Je ne reçois pas l'E-Mail « Mot de passe oublié ».",
      "creating-your-personalized": "Actuellement, vous essayez de créer un compte client personnel directement avec votre adresse d'E-Mail. Veuillez commencer par vous connecter avec votre Nr client puis suivez les étapes indiquées pour créer votre compte client personnel.",
      "use-email-instead-of-your-customer": "Pour vous connecter, veuillez utiliser votre adresse d'E-Mail à la place de votre Nr. client.",
      "frequently-asked-questions": "Foire aux questions",
      "personalized-user-account": "Avez-vous créé votre compte client personnel ?",
      "no": "Non",
      "use-customer-without-de": "Veuillez utiliser votre Nr. client (sans préfixe \"FR\") pour réinitialiser votre mot de passe.",
      "yes": "Oui",
      "use-customer-without-de-prefix": "Pour vous connecter, veuillez utiliser votre Nr. client (sans préfixe \"FR\") puis suivez les instructions pour créer votre compte client personnel.",
      "i-cannot-sign-in-to-my-account": "Je ne peux pas me connecter."
    },
    "api": {
      "incorrect-username-or-password": "Nom d'utilisateur ou mot de passe incorrect.",
      "invalid-code-provided": "Une erreur s'est produite. Veuillez reprendre la procédure de changement de mot de passe depuis le début.",
      "user-does-not-exist": "Utilisateur inconnu",
      "password-validation-error": "Le mot de passe ne correspond pas au format admis.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Utilisateur inconnu",
      "password-missing-number": "Le mot de passe ne correspond pas au format admis. Veuillez saisir un mot de passe avec au moins 1 chiffre.",
      "incorrect-old-password": "Ancien mot de passe incorrect",
      "user-is-already-registered": "Cet utilisateur est déjà enregistré.",
      "your-password-has-been-changed": "Votre mot de passe a été modifié.",
      "password-missing-uppercase": "Le mot de passe ne correspond pas au format admis. Veuillez saisir un mot de passe avec au moins 1 majuscule.",
      "invalid-verification-provided": "La durée de validité du lien utilisé est dépassée. Veuillez cliquer sur le lien disponible dans le dernier E-Mail « Réinitialiser le mot de passe ».",
      "email-used-by-different-user": "Cette adresse d'E-Mail est utilisée par un autre utilisateur.",
      "password-not-long-enough": "Le mot de passe ne correspond pas au format admis. Veuillez saisir un mot de passe avec au moins 8 caractères.",
      "an-error-occurred": "Une erreur s'est produite. Veuillez réessayer ultérieurement SVP.",
      "attempt-limit-exceeded": "Vous avez essayé de changer le mot de passe trop souvent. Veuillez patienter un certain temps puis reprendre la procédure de changement de mot de passe depuis le début.",
      "incorrect_old_password": "Ancien mot de passe incorrect",
      "password-missing-lowercase": "Le mot de passe ne correspond pas au format admis. Veuillez saisir un mot de passe avec au moins 1 minuscule.",
      "generic-api-message": "Veuillez vérifier les informations saisies. Veuillez saisir à nouveau ces informations manuellement. Si le problème persiste, merci de contacter notre support."
    },
    "common": {
      "please-wait": "Veuillez patienter SVP...",
      "send-code": "Envoyer le code",
      "your-account": "Votre compte client Hella Gutmann",
      "close": "Fermer",
      "please-fill-in-this-field": "Veuillez compléter ce champ SVP.",
      "hgsKey": "Adresse d'E-Mail (si vous avez créé un compte client personnel) ou Nr. client",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Gérez votre Profil utilisateur dans l'espace Hella Gutmann de gestion des profils utilisateurs.",
      "please-start-the-process-again-later": "<0>Veuillez essayer de refaire cette opération ultérieurement.</0> Si le problème persiste, merci de contacter notre Support client.",
      "this-field-cannot-be-left-blank": "Ce champ doit être complété.",
      "please-enter-your-login": "Veuillez saisir vos données de connexion. Nous vous enverrons ensuite un code à 6 chiffres à votre adresse d'E-Mail. Saisissez ce code dans la page web. Ne fermez pas votre navigateur.",
      "password-validation-error": "Le mot de passe ne correspond pas au format admis.",
      "hide-password": "Cacher le mot de passe",
      "go-to-login": "Vers la connexion",
      "invalid-characters": "Vous avez utilisé des caractères invalides. Veuillez modifier votre saisie.",
      "first-name-and-last-name-too-short": "Utilisez uniquement des signes alphabétiques et au moins 2 chiffres.",
      "an-error-occurred": "Une erreur s'est produite.",
      "please-enter-a-valid-email-address": "Veuillez saisir une adresse d'E-Mail valide. Les caractères spéciaux suivants sont autorisés : ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Utilisateur inconnu",
      "show-password": "Montrer le mot de passe",
      "no-number-and-email": "Veuillez saisir une adresse d'E-Mail valide ou votre Nr. client (uniquement les chiffres).",
      "passwords-does-not-match": "Les mots de passe ne correspondent pas.",
      "user-does-not-exist": "Utilisateur inconnu",
      "your-user-profile": "Votre profile-utilisateur",
      "enter-code": "Veuillez saisir le code"
    },
    "dashboard": {
      "logout": "Déconnexion",
      "lead": "Veuillez sélectionner l'application sur laquelle vous souhaitez accéder à partir de votre compte Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Pour utiliser mega macs S 20, veuillez installer l'App mega macs S 20 sur votre appareil Android. Vous trouvez l'App dans le Play Store.",
      "x20-please-sign-in-title": "Connexion CSC-Tool X 20",
      "x20-please-sign-in-content": "Veuillez vous connecter dans votre CSC-Tool X 20 avec votre compte Hella Gutmann.",
      "s20-please-start-device-title": "Connexion mega macs S 20"
    },
    "errorMessage": {
      "error": "Erreur",
      "something-went-wrong": "Une erreur s'est produite."
    },
    "faq": {
      "howDoIChangePassword": "Comment faire pour modifier le mot de passe de mon compte Hella Gutmann ?",
      "howDoIGetAHellaGutmannAccount": "Comment obtenir un compte Hella Gutmann ?",
      "possibleToUseMultipleAccounts": "Cette solution vous permet de vous connecter à plusieurs applications et services internet Hella Gutmann à partir d'un seul et même accès. Vous n'avez besoin de vous identifier qu'une seule fois.",
      "backToLogin": "RETOUR VERS LA CONNEXION",
      "itIsASingleSignOnSolution": "Grâce au compte Hella Gutmann, vous disposez d'une solution SSO d'accès à différents systèmes et produits à partir d'une seule et même connexion. L'accès nécessite une adresse d'E-Mail et un mot de passe.",
      "title": "Foire Aux Questions (FAQ)",
      "whatIsAHellaGutmannAccount": "Qu'est-ce que le compte Hella Gutmann ?",
      "supportedAppsConstantlyExpanded": "Nous intégrons régulièrement de plus en plus de produits et d'applications. Actuellement, l'utilisation du compte Hella Gutmann permet d'utiliser les produits et applications suivantes",
      "alternativeContactSupport": "Vous pouvez également contacter notre support technique.",
      "howDoIResetPassword": "Comment faire pour réinitialiser le mot de passe de mon compte Hella Gutmann ?",
      "asSoonAsYouGetAccessToProducts": "Après achat de l'un des produits intégrés ou dès que votre accès sur macs365 a été créé, vous recevrez un E-Mail grâce auquel vous pourrez créer votre compte Hella Gutmann. Cet E-Mail est envoyer automatiquement à l'adresse d'E-Mail que vous nous avez communiquée initialement.",
      "whatToDoIfNoEMailReceived": "Quoi faire si je n'ai pas reçu d'E-Mail pour créer mon compte Hella Gutmann ?",
      "clickOnForgotPassword": "Vous pouvez, par exemple, utiliser le lien suivant pour demander l'E-Mail nécessaire : <1>Mot de passe oublié</1>. Lors de cette action, veillez à ce que l'E-Mail utilisé correspond bien à l'adresse d'E-Mail que vous nous avez indiquée initialement.",
      "changeEmailOnUserProfile": "Vous pouvez modifier l'adresse d'E-Mail utilisée pour vous connecter à votre compte Hella Gutmann à partir de la page Profil utilisateur (la page Profil utilisateur n'est actuellement disponible que si vous disposez d'un compte macs365).",
      "changePasswordOnUserProfile": "Vous pouvez modifier le mot de passe de votre compte Hella Gutmann à partir de la page Profil utilisateur (l'accès à la page Profil utilisateur n'est actuellement disponible que si vous avez un compte macs365).",
      "howDoIChangeEmailAddress": "Comment faire pour modifier l'adresse d'E-Mail utilisée pour mon compte Hella Gutmann ?",
      "whichAppsAreSupported": "Quelles sont les applications intégrées dans mon compte Hella Gutmann ?"
    },
    "footer": {
      "imprint": "Mentions légales",
      "faq": "FAQ",
      "faq-heading": "Foire Aux Questions (FAQ)",
      "data-privacy-policy": "Déclaration de protection des données",
      "terms-and-conditions": "Conditions d’utilisation"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "L'envoi d'un E-Mail a échoué à cause d'un trop grand nombre de tentatives. Veuillez réessayer ultérieurement SVP (après quelques heures d'attente).",
      "send-email": "Envoyer",
      "reset-your-password": "Réinitialiser votre mot de passe",
      "forgot-password-button-clicked-alert": "L'E-Mail a été expédié avec succès. La réception peut éventuellement nécessiter un peu de temps.",
      "back-to-login": "Retour vers la connexion",
      "enter-your-login-V2": "Adresse d'E-Mail",
      "please-enter-your-login": "Veuillez saisir vos informations de connexion et nous vous enverrons un E-Mail de confirmation. Merci de cliquer sur le lien de vérification contenu dans l'E-Mail.",
      "enter-your-login": "Votre connexion"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Veuillez choisir un mot de passe robuste et le saisir dans les 2 champs.",
      "reset-your-password": "Définir un nouveau mot de passe",
      "repeat-password": "Répéter le nouveau mot de passe",
      "a-verification-email-has-been-sent-to-you": "Un E-Mail de confirmation vous a été envoyé.",
      "reset-password": "Mémoriser le mot de passe",
      "new-password": "Nouveau mot de passe",
      "passwords-do-not-match": "Les mots de passe ne correspondent pas. Veuillez vérifier les informations saisies."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "A présent, votre nouveau mot de passe est actif.",
      "setting-new-password-successful": "Nouveau mot de passe enregistré avec succès.",
      "go-to-login": "Vers la connexion"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2\n\nD-79241 Ihringen, Allemagne\n\nTel : +49 7668 9900 888 \n\nFax : +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nN° d'identification fiscale : 07011/39801\n\nN° TVA intracommunautaire: DE 14 220 8666 \n\nRegistre des commerces : HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Mentions légales",
      "back": "RETOUR VERS LA CONNEXION"
    },
    "menu": {
      "digital-products": "Produits numériques"
    },
    "migration": {
      "helper-text-surname": "Veuillez indiquer un prénom",
      "description-submit": "Une fois le formulaire complété et envoyé, vous recevrez un E-Mail à l'adresse d'E-Mail que vous aurez indiqué. Cliquez sur le bouton de vérification pour confirmer l'adresse d'E-Mail.",
      "firstname": "Prénom",
      "description-login": "Ensuite, authentifiez-vous à l'aide de votre adresse d'E-Mail et de votre mot de passe actuel. L'authentification avec votre Nr. client ne fonctionnera plus.",
      "submit": "Envoyer",
      "email": "Adresse d'E-Mail",
      "page-title": "Votre compte client Hella Gutmann",
      "helper-text-firstname": "Veuillez indiquer un prénom",
      "surname": "Nom",
      "title": "Modification de vos données de connexion",
      "helper-text-email": "Veuillez saisir une adresse d'E-Mail",
      "description-user-account": "Hella Gutmann modifie les procédures d'autentification et introduit le compte utilisateur personnel. Veuillez indiquer un prénom, un nom, une adresse d'E-Mail et un mot de passe pour votre compte client personnel."
    },
    "migrationError": {
      "go-to-login": "Vers la connexion",
      "your-email-address-could-not-get-confirmed": "Votre nouvelle adresse d'E-Mail n'a malheureusement pas pu être validée. Il se peut que le lien que vous avez utilisé n'était plus valable. Veuillez vous authentifier à nouveau et refaire la même action.",
      "change-of-your-login-failed": "La modification de vos données de connexion a échoué."
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Nous vous avons envoyé un E-Mail</0> à l'adresse d'E-Mail indiquée. Pour confirmer votre E-Mail, veuillez consulter vos E-Mails et <2>cliquer sur le lien de vérification intégré dans l'E-Mail envoyé</2>.",
      "for-security-reasons": "Pour des raisons de sécurité, le lien fourni expire après 24 heures. Si tel est le cas, veuillez reprendre la procédure depuis le début.",
      "sending-successful": "Envoi effectuée avec succès"
    },
    "migrationVerify": {
      "verification-button": "Confirmer",
      "verification-header": "Confirmation du compte utilisateur",
      "verification-description": "Veuillez cliquer sur le bouton pour confirmer la configuration de votre compte utilisateur personnel"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Adresse e-mail confirmée",
      "from-now-on-please-login-with-the-email": "Dès à présent, veuillez utiliser cette adresse d'E-Mail et votre mot de passe pour vous connecter.",
      "your-email-address-has-been-confirmed": "Votre adresse d'E-Mail a été validée"
    },
    "needHelp": {
      "for-further-questions": "Pour toute autre question, notre Hotline Technique est à votre disposition <1/> du lundi au vendredi, de 8 h à 17 h.",
      "need-help-logging-in": "Vous avez besoin d'aide pour vous connectez ?",
      "here-you-will-find": "Vous trouvez <0>ici</0> des réponses aux <2>questions les plus fréquentes.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "minuscule",
      "uppercase-letter": "majuscule",
      "the-new-password-requires": "Consignes pour mot de passe :",
      "characters": "Caractères",
      "number": "Chiffres"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Délai de résiliation"
    },
    "settings": {
      "user-information-saved": "Les informations de l'utilisateur ont été mémorisées.",
      "update-user-information": "Profil utilisateur",
      "new-password": "Nouveau mot de passe",
      "resend-verification": "Envoyer à nouveau l'authentification",
      "save": "Sauvegarder",
      "language-preference-saved": "La configuration de la langue a été sauvegardée.",
      "email-has-been-sent": "Un E-Mail de confirmation vous a été envoyé.",
      "firstname": "Prénom",
      "repeat-password": "Répéter le mot de passe",
      "your-user-data": "Vos informations utilisateur",
      "set-new-password": "Définir un nouveau mot de passe",
      "email-is-not-verified-yet": "L'E-Mail n'a pas encore été authentifié",
      "old-password": "Ancien mot de passe",
      "new-login-info": "Veuillez noter que votre nouvelle adresse d'E-Mail deviendra également votre nouveau nom d'utilisateur pour vous connecter.",
      "update-your-email": "Veuillez actualiser votre adresse d'E-Mail",
      "email": "Adresse d'E-Mail",
      "incorrect-username-or-password": "Mot de passe incorrect.",
      "back": "Retour",
      "resend": "Envoyer à nouveau",
      "update-your-language": "Langue favorite",
      "surname": "Nom",
      "passwords-do-not-match": "Les mots de passe ne correspondent pas. Veuillez vérifier les informations saisies.",
      "submit-new-email-info": "Après avoir choisi une nouvelle adresse d'E-Mail, nous vous enverrons une confirmation pour cette nouvelle adresse d'E-Mail. Dans cet E-Mail de confirmation, merci de cliquer sur le lien fourni pour valider votre adresse d'E-Mail.",
      "this-language-will-be-used": "Cette langue sera utilisée dans votre compte client et l'adresse d'E-Mail indiquée. Les E-Mails relatifs à la facturation ne sont pas concernées par ce choix."
    },
    "signIn": {
      "sign-in": "Connexion",
      "forgot-your-password": "Mot de passe oublié ?",
      "your-login-V2": "Adresse d'E-Mail",
      "your-password": "Votre mot de passe",
      "sign-in-at-hella-gutmann": "Se connecter sur Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Les mots de passe ne correspondent pas.",
      "noMatchedEmails": "Les E-Mails ne correspondent pas.",
      "lead": "Pour créer un compte Hella Gutmann, veuillez renseigner les informations demandées.",
      "descriptionUserAccountV2": "Hella Gutmann modifie les procédures d'authentification et introduit le compte utilisateur personnel. Veuillez indiquer un prénom, un nom et un mot de passe pour votre compte client personnel.",
      "password": "Mot de passe",
      "descriptionLogin": "Après authentification, veuillez vous connecter avec votre adresse d'E-Mail et votre mot de passe.",
      "passwordLead": "Veuillez choisir un mot de passe robuste et le saisir dans les 2 champs.",
      "familyName": "Nom",
      "repeatEmail": "Répéter l'adresse d'E-Mail",
      "header": "Enregistrement",
      "email": "Adresse d'E-Mail",
      "signup": "Enregistrer",
      "givenName": "Prénom",
      "repeatPassword": "Répéter le mot de passe",
      "descriptionUserAccount": "Hella Gutmann modifie les procédures d'autentification et introduit le compte utilisateur personnel. Veuillez indiquer une prénom, un nom, une adresse d'E-Mail et un mot de passe pour votre compte client personnel."
    },
    "signUpComplete": {
      "header": "Enregistrement effectué avec succès",
      "info": "Attention : pour vous connecter à votre compte Hella Gutmann, veuillez utiliser le mot de passe que nous venons de vous envoyer et l'Adresse d'E-Mail à laquelle nous avons adressé l'E-Mail d'enregistrement.",
      "yourUserProfile": "Votre profile-utilisateur"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Transmission effectuée avec succès",
      "forSecurityReasons": "Pour des raisons de sécurité, le lien fourni expire après 24 heures. Si tel est le cas, veuillez reprendre la procédure depuis le début en vous connectant avec vos anciennes données de connexion.",
      "weSentYouAnEmail": "<0>Nous vous avons envoyé un E-Mail</0> à l'adresse d'E-Mail indiquée. Pour confirmer votre E-Mail, veuillez consulter vos E-Mails et <2>cliquer sur le lien de vérification intégré dans l'E-Mail envoyé</2>.",
      "for-security-reasons": "Pour des raisons de sécurité, le lien fourni expire après 24 heures. Si tel est le cas, veuillez reprendre la procédure depuis le début."
    },
    "signUpVerify": {
      "description": "Veuillez cliquer sur le bouton pour confirmer la configuration de votre compte utilisateur personnel",
      "header": "Confirmation du compte utilisateur",
      "button": "Confirmer"
    },
    "verify": {
      "verification-description": "Veuillez cliquer sur le bouton pour confirmer votre adresse d'E-Mail",
      "verification-header": "Confirmer l'adresse d'E-Mail",
      "verification-button": "CONFIRMER"
    },
    "verifySuccess": {
      "your-user-profile": "Votre profile-utilisateur",
      "from-now-on-we-will-send-you-messages": "Dès à présent, nous utiliserons cette nouvelle adresse d'E-Mail pour toute communication avec macs365.",
      "keep-in-mind-that-this-email": "Veuillez noter que votre nouvelle adresse d'E-Mail sert également de « Nom d'utilisateur » lorsque vous vous connecter.",
      "change-of-email-address-successful": "Il est nécessaire de modifier l'adresse d'E-Mail."
    },
    "wizard": {
      "close": "Fermer macs365"
    }
  },
  "hu": {
    "FAQModal": {
      "use-email-instead-of-customer": "Az ügyfélszám helyett használja az e-mail-címét a jelszó visszaállításához.",
      "missing-verification-email": "Nem érkezik meg a visszaigazoló e-mail.",
      "missing-forgot-password-email": "Nem érkezik meg az „Elfelejtett jelszó?” című e-mail.",
      "creating-your-personalized": "Ön a személyes felhasználói fiókját közvetlenül az e-mail-címével próbálja meg létrehozni. Először jelentkezzen be az ügyfélszámával, és kövesse a személyes felhasználói fiók létrehozásához szükséges lépéseket.",
      "use-email-instead-of-your-customer": "Az ügyfélszám helyett használja az e-mail-címét a bejelentkezéshez.",
      "frequently-asked-questions": "Gyakran ismételt kérdések",
      "personalized-user-account": "Létrehozta a személyes felhasználói fiókját?",
      "no": "Nem",
      "use-customer-without-de": "Jelszavának visszaállításához használja az ügyfélszámát (a „DE” előtag nélkül).",
      "yes": "Igen",
      "use-customer-without-de-prefix": "Használja az ügyfélszámát (a „DE” előtag nélkül) a bejelentkezéshez, és kövesse a személyes felhasználói fiók létrehozásához szükséges lépéseket.",
      "i-cannot-sign-in-to-my-account": "Nem tudok bejelentkezni."
    },
    "api": {
      "incorrect-username-or-password": "Helytelen felhasználó vagy jelszó.",
      "invalid-code-provided": "Hiba történt. Kezdje elölről a jelszó-módosítási folyamatot.",
      "user-does-not-exist": "A felhasználó nem létezik",
      "password-validation-error": "A jelszó nem felel meg a követelményeknek.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "A felhasználó nem létezik",
      "password-missing-number": "A jelszó nem felel meg a követelményeknek. A jelszónak legalább 1 számot kell tartalmaznia.",
      "incorrect-old-password": "Helytelen régi jelszó",
      "user-is-already-registered": "A felhasználó már regisztrálva van.",
      "your-password-has-been-changed": "A jelszavát módosítottuk.",
      "password-missing-uppercase": "A jelszó nem felel meg a követelményeknek. A jelszónak legalább 1 nagybetűt kell tartalmaznia.",
      "invalid-verification-provided": "Lejárt hivatkozást használt. Kattintson a legutóbbi „Jelszó visszaállítása” e-mailben lévő hivatkozásra.",
      "email-used-by-different-user": "Az e-mail-címet egy másik felhasználó használja.",
      "password-not-long-enough": "A jelszó nem felel meg a követelményeknek. A jelszónak legalább 8 karaktert kell tartalmaznia.",
      "an-error-occurred": "Hiba történt. Próbálja meg később újból.",
      "attempt-limit-exceeded": "Túl gyakran próbálta módosítani a jelszót. Várjon egy kicsit, és indítsa el újra a jelszó-módosítási folyamatot.",
      "incorrect_old_password": "Helytelen régi jelszó",
      "password-missing-lowercase": "A jelszó nem felel meg a követelményeknek. A jelszónak legalább 1 kisbetűt kell tartalmaznia.",
      "generic-api-message": "Ellenőrizze, amit beírt. Írja be újból kézzel. Ha a hiba továbbra is fennáll, lépjen kapcsolatba az ügyfélszolgálattal."
    },
    "common": {
      "please-wait": "Várjon",
      "send-code": "Kód küldése",
      "your-account": "Az Ön Hella Gutmann felhasználói fiókja",
      "close": "Bezárás",
      "please-fill-in-this-field": "Töltse ki ezt a mezőt.",
      "hgsKey": "E-mail-cím (ha létrehozta a személyes felhasználói fiókját) vagy ügyfélszám",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Kezelje felhasználói profilját a Hella Gutmann Accounts segítségével.",
      "please-start-the-process-again-later": "<0>Később indítsa újra a folyamatot.</0> Ha a probléma ismét jelentkezik, forduljon az ügyfélközponthoz.",
      "this-field-cannot-be-left-blank": "Ez a mező nem lehet üres.",
      "please-enter-your-login": "Adja meg a bejelentkezési adatait. Ezt követően egy 6 számjegyű kódot küldünk az e-mail-címére. Írja be ezt a kódot a következő oldalon. Ne zárja be a böngészőt.",
      "password-validation-error": "A jelszó nem felel meg a követelményeknek.",
      "hide-password": "Jelszó elrejtése",
      "go-to-login": "Ugrás a bejelentkezésre",
      "invalid-characters": "Érvénytelen karaktereket írt be. Módosítsa a bevitelt.",
      "first-name-and-last-name-too-short": "Csak betűket és legalább két karaktert írjon be.",
      "an-error-occurred": "Hiba történt",
      "please-enter-a-valid-email-address": "Érvényes e-mail-címet adjon meg. A megengedett karakterek az alfanumerikus karakterek és a következő speciális karakterek: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "A felhasználó nem létezik",
      "show-password": "Jelszó megjelenítése",
      "no-number-and-email": "Adjon meg egy érvényes e-mail-címet vagy egy kizárólag számokból álló ügyfélszámot.",
      "passwords-does-not-match": "A jelszavak nem egyeznek meg egymással.",
      "user-does-not-exist": "A felhasználó nem létezik",
      "your-user-profile": "Az Ön felhasználói profilja",
      "enter-code": "Írja be a kódot"
    },
    "dashboard": {
      "logout": "Kijelentkezés",
      "lead": "Kérjük, válassza ki azt az alkalmazást, amelyet a Hella Gutmann-fiókjával szeretne elérni."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Ahhoz, hogy a mega macs S 20-at használni lehessen, a mega macs S 20 appnak telepítve kell lennie az Ön androidos készülékén. Az app a Play Store-ból beszerezhető.",
      "x20-please-sign-in-title": "Bejelentkezés a CSC-Tool X 20",
      "x20-please-sign-in-content": "Jelentkezzen be a CSC-Tool X 20 rendszerébe a Hella Gutmann-fiókjával.",
      "s20-please-start-device-title": "\t\nBejelentkezés a mega macs S 20-ba"
    },
    "errorMessage": {
      "error": "Hiba",
      "something-went-wrong": "Valami hiba történt."
    },
    "faq": {
      "howDoIChangePassword": "Hogyan tudom megváltoztatni a jelszót a Hella Gutmann-fiók számára?",
      "howDoIGetAHellaGutmannAccount": "Hogyan szerezhetek Hella Gutmann-fiókot?",
      "possibleToUseMultipleAccounts": "A megoldás lehetővé teszi a vevők számára, hogy egyetlen hozzáféréssel és egyszeri bejelentkezéssel biztonságosan bejelentkezhessenek több Hella Gutmann-alkalmazásba és weboldalra.",
      "backToLogin": "VISSZA A BEJELENTKEZÉSHEZ",
      "itIsASingleSignOnSolution": "A Hella Gutmann-fiók a Hella Gutmann egyszeri bejelentkezési megoldása (SSO, Single Sign-on). A hozzáféréshez egy e-mail-cím és egy választott jelszó szükséges.",
      "title": "Gyakran ismételt kérdések (GYIK)",
      "whatIsAHellaGutmannAccount": "Mi az a Hella Gutmann-fiók?",
      "supportedAppsConstantlyExpanded": "A támogatott alkalmazások száma folyamatosan bővül. A Hella Gutmann-fiók jelenleg a következő alkalmazásokat támogatja",
      "alternativeContactSupport": "Alternatív megoldásként forduljon ügyfélszolgálatunkhoz.",
      "howDoIResetPassword": "Hogyan állíthatom vissza a jelszót a Hella Gutmann-fiók számára?",
      "asSoonAsYouGetAccessToProducts": "Amint megvásárolta a támogatott termékek egyikét, vagy feljogosult a macs365 elérésére, kap egy e-mailt a Hella Gutmann-fiók beállításához. Az e-mailt automatizált eljárással küldjük el a nálunk tárolt e-mail-címre.",
      "whatToDoIfNoEMailReceived": "Mit tehetek, ha nem kaptam meg a Hella Gutmann-fiók beállításához szükséges e-mailt?",
      "clickOnForgotPassword": "Az egyik lehetőség az, hogy lekéri a szükséges e-mailt a <1>Passwort vergessen</1> címen. Ügyeljen arra, hogy a beírt e-mail-cím megegyezzen a nálunk tárolt e-mail-címmel.",
      "changeEmailOnUserProfile": "A bejelentkezéshez használt Hella Gutmann-fiókjának e-mail-címét a Felhasználói profil oldalon keresztül módosíthatja (a felhasználói profil jelenleg csak macs365-hozzáféréssel rendelkező ügyfelek számára érhető el).",
      "changePasswordOnUserProfile": "A Hella Gutmann-fiókhoz tartozó jelszót megváltoztathatja a Felhasználói profil oldalon (a felhasználói profil jelenleg csak macs365-hozzáféréssel rendelkező ügyfelek számára érhető el).",
      "howDoIChangeEmailAddress": "Hogyan változtathatom meg az e-mail-címet a Hella Gutmann-fiók számára?",
      "whichAppsAreSupported": "Mely alkalmazásokat támogatja a Hella Gutmann-fiók?"
    },
    "footer": {
      "imprint": "Impresszum",
      "faq": "GYIK",
      "faq-heading": "Gyakran ismételt kérdések (GYIK)",
      "data-privacy-policy": "Adatvédelmi nyilatkozat",
      "terms-and-conditions": "Felhasználási feltételek"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Az e-mail küldése nem volt lehetséges a túl sok sikertelen próbálkozás miatt. Néhány óra múlva próbálja meg újra.",
      "send-email": "Küldés",
      "reset-your-password": "Jelszó visszaállítása",
      "forgot-password-button-clicked-alert": "Az e-mail küldése sikeres volt. A kézbesítés néhány percet vehet igénybe.",
      "back-to-login": "Vissza a bejelentkezéshez",
      "enter-your-login-V2": "E-mail-cím",
      "please-enter-your-login": "Adja meg bejelentkezési adatait, és küldünk Önnek egy megerősítő e-mailt. Kattintson az e-mailben található Megerősítés gombra.",
      "enter-your-login": "Bejelentkezés"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Válasszon egy biztonságos jelszót, és írja be mindkét mezőbe.",
      "reset-your-password": "Új jelszó beállítása",
      "repeat-password": "Új jelszó megismétlése",
      "a-verification-email-has-been-sent-to-you": "Megerősítő e-mailt küldtünk Önnek.",
      "reset-password": "Jelszó beállítása",
      "new-password": "Új jelszó",
      "passwords-do-not-match": "A jelszavak nem egyeznek meg egymással. Ellenőrizze, amit beírt."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Az új jelszó be van állítva.",
      "setting-new-password-successful": "Az új jelszó beállítása sikeres!",
      "go-to-login": "Ugrás a bejelentkezésre"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTel.: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nAdószám: 07011/39801 \n\nKözösségi adószám: DE 14 220 8666 \n\nCégjegyzék: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Impresszum",
      "back": "VISSZA A BEJELENTKEZÉSHEZ"
    },
    "menu": {
      "digital-products": "Digitális termékek"
    },
    "migration": {
      "helper-text-surname": "Adjon meg egy vezetéknevet",
      "description-submit": "Miután elküldte az űrlapot, üzenetet küldünk az Ön által megadott e-mail-címre. E-mail-címének megerősítéséhez kattintson az üzenetben található ellenőrző gombra.",
      "firstname": "Utónév",
      "description-login": "Ezután jelentkezzen be az e-mail-címével és az aktuális jelszavával. A továbbiakban már nem tud bejelentkezni a vevőszámával.",
      "submit": "Küldés",
      "email": "E-mail-cím",
      "page-title": "Az Ön Hella Gutmann felhasználói fiókja",
      "helper-text-firstname": "Adjon meg egy utónevet",
      "surname": "Vezetéknév",
      "title": "Bejelentkezési adatainak módosítása",
      "helper-text-email": "Adjon meg egy e-mail-címet",
      "description-user-account": "A Hella Gutmann személyes felhasználói fiókokra vált. Itt adjon meg egy utónevet, egy vezetéknevet és egy e-mail-címet a személyes felhasználói fiókjához."
    },
    "migrationError": {
      "go-to-login": "Ugrás a bejelentkezésre",
      "your-email-address-could-not-get-confirmed": "Új e-mail-címét nem sikerült megerősíteni. Az a legvalószínűbb, hogy az e-mailben található link már lejárt. Kérjük, jelentkezzen be újra, és kezdje elölről a folyamatot.",
      "change-of-your-login-failed": "Bejelentkezési adatainak módosítása nem sikerült"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>E-mailt küldtünk Önnek</0> az Ön által megadott e-mail-címre. Az e-mail-cím megerősítéséhez menjen a postafiókjába, és <2>kattintson az e-mailben található Megerősítés gombra</2>.",
      "for-security-reasons": "Biztonsági okokból a hivatkozás 24 óra elteltével érvénytelenné válik. Ha ez megtörténik, kezdje újra a folyamatot.",
      "sending-successful": "Az átvitel sikeres volt"
    },
    "migrationVerify": {
      "verification-button": "Megerősítés",
      "verification-header": "Felhasználói fiók megerősítése",
      "verification-description": "Kattintson a gombra a személyre szabott felhasználói fiók létrehozásának megerősítéséhez"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "E-mail-cím megerősítése megtörtént",
      "from-now-on-please-login-with-the-email": "Mostantól ezzel az e-mail-címmel és a jelszavával jelentkezzen be.",
      "your-email-address-has-been-confirmed": "E-mail-címének megerősítése megtörtént"
    },
    "needHelp": {
      "for-further-questions": "Ha további kérdése van, forródrótunk<1/> hétfőtől péntekig 8:00 és 17:00 óra között áll rendelkezésére.",
      "need-help-logging-in": "Segítségre van szüksége a bejelentkezés során?",
      "here-you-will-find": "<0>Itt</0> megoldást talál a <2>gyakran ismételt kérdésekre.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "kisbetű",
      "uppercase-letter": "nagybetű",
      "the-new-password-requires": "Jelszóval kapcsolatos feltételek:",
      "characters": "karakter",
      "number": "szám"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Felmondási idő"
    },
    "settings": {
      "user-information-saved": "A felhasználói adatok mentése megtörtént.",
      "update-user-information": "Felhasználói profil",
      "new-password": "Új jelszó",
      "resend-verification": "Ellenőrzés ismételt küldése",
      "save": "Mentés",
      "language-preference-saved": "A nyelvbeállítás mentése megtörtént.",
      "email-has-been-sent": "Megerősítő e-mailt küldtünk Önnek.",
      "firstname": "Utónév",
      "repeat-password": "Jelszó megismétlése",
      "your-user-data": "Az Ön felhasználói adatai",
      "set-new-password": "Új jelszó létrehozása",
      "email-is-not-verified-yet": "Az e-mail-cím még nincs ellenőrizve",
      "old-password": "Régi jelszó",
      "new-login-info": "Ne feledje, hogy az új e-mail-címe lesz a bejelentkezési azonosítója is.",
      "update-your-email": "Frissítse az e-mail-címét",
      "email": "E-mail-cím",
      "incorrect-username-or-password": "Helytelen jelszó.",
      "back": "Vissza",
      "resend": "Ismételt küldés",
      "update-your-language": "Előnyben részesített nyelv",
      "surname": "Vezetéknév",
      "passwords-do-not-match": "A jelszavak nem egyeznek meg egymással. Ellenőrizze, amit beírt.",
      "submit-new-email-info": "Ha új e-mail-címet ad meg, küldünk Önnek egy megerősítő e-mailt. Kattintson az e-mailben található hivatkozásra az új e-mail-cím megerősítéséhez.",
      "this-language-will-be-used": "Ez a nyelv a személyes felhasználói fiókjához és az e-mailjeihez használatos. A számlákat tartalmazó e-maileket ez nem érinti."
    },
    "signIn": {
      "sign-in": "Bejelentkezés",
      "forgot-your-password": "Elfelejtette a jelszavát?",
      "your-login-V2": "E-mail-cím",
      "your-password": "Az Ön jelszava",
      "sign-in-at-hella-gutmann": "Bejelentkezés a Hella Gutmann weboldalon"
    },
    "signUp": {
      "noMatchedPasswords": "A jelszavak nem egyeznek meg egymással.",
      "noMatchedEmails": "Az e-mail-címek nem egyeznek meg egymással.",
      "lead": "Adja meg adatait a Hella Gutmann-fiókja létrehozásához.",
      "descriptionUserAccountV2": "A Hella Gutmann személyes felhasználói fiókokra vált. Itt adjon meg egy utónevet, egy vezetéknevet és egy jelszót a személyes felhasználói fiókjához.",
      "password": "Jelszó",
      "descriptionLogin": "Az ellenőrzést követően jelentkezzen be az e-mail-címével és jelszavával.",
      "passwordLead": "Válasszon egy biztonságos jelszót, és írja be mindkét mezőbe.",
      "familyName": "Vezetéknév",
      "repeatEmail": "E-mail-cím megismétlése",
      "header": "Regisztráció",
      "email": "E-mail-cím",
      "signup": "Regisztráció",
      "givenName": "Utónév",
      "repeatPassword": "Jelszó megismétlése",
      "descriptionUserAccount": "A Hella Gutmann személyes felhasználói fiókokra vált. Adjon meg egy utónevet, egy vezetéknevet, egy e-mail-címet és egy jelszót a személyes felhasználói fiókjához itt."
    },
    "signUpComplete": {
      "header": "Sikeres regisztráció",
      "info": "Vegye figyelembe: A Hella Gutmann-fiókjába való bejelentkezéshez használja az éppen megadott jelszó mellett használja azt az e-mail-címet, ahová a regisztrációs e-mailt küldtük.",
      "yourUserProfile": "Az Ön felhasználói profilja"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Az átvitel sikeres volt",
      "forSecurityReasons": "Biztonsági okokból a hivatkozás 24 óra elteltével érvénytelenné válik. Ha ez megtörténik, jelentkezzen be újra a régi hozzáférési adatokkal, és kezdje újra a folyamatot.",
      "weSentYouAnEmail": "<0>E-mailt küldtünk Önnek</0> az Ön által megadott e-mail-címre. Az e-mail-cím megerősítéséhez menjen a postafiókjába, és <2>kattintson az e-mailben található Megerősítés gombra</2>.",
      "for-security-reasons": "Biztonsági okokból a hivatkozás 24 óra elteltével érvénytelenné válik. Ha ez megtörténik, kezdje újra a folyamatot."
    },
    "signUpVerify": {
      "description": "Kattintson a gombra a személyre szabott felhasználói fiók létrehozásának megerősítéséhez",
      "header": "Felhasználói fiók megerősítése",
      "button": "Megerősítés"
    },
    "verify": {
      "verification-description": "Kattintson a gombra az e-mail-címe megerősítéséhez",
      "verification-header": "E-mail-cím megerősítése",
      "verification-button": "MEGERŐSÍTÉS"
    },
    "verifySuccess": {
      "your-user-profile": "Az Ön felhasználói profilja",
      "from-now-on-we-will-send-you-messages": "Mostantól kezdve az új e-mail-címét fogjuk használni a macs365-tel való kommunikációhoz.",
      "keep-in-mind-that-this-email": "Felhívjuk figyelmét, hogy az új e-mail-címe egyúttal a bejelentkezéshez használt felhasználónév is.",
      "change-of-email-address-successful": "E-mail-cím módosítása sikeres."
    },
    "wizard": {
      "close": "macs365 bezárása"
    }
  },
  "it": {
    "FAQModal": {
      "use-email-instead-of-customer": "Invece del codice cliente, ti preghiamo di utilizzare il tuo indirizzo e-mail per reimpostare la tua password.",
      "missing-verification-email": "Non ricevo l'e-mail di conferma.",
      "missing-forgot-password-email": "Non ricevo l'e-mail “password dimenticata”.",
      "creating-your-personalized": "Stai cercando di creare un account utente personale direttamente con il tuo indirizzo e-mail. Ti preghiamo di effettuare il login con il tuo codice cliente e di seguire la procedura indicata per creare il tuo account utente personale.",
      "use-email-instead-of-your-customer": "Al posto del codice cliente, ti preghiamo di utilizzare il tuo indirizzo e-mail per il login.",
      "frequently-asked-questions": "FAQ",
      "personalized-user-account": "Hai creato il tuo account utente personale?",
      "no": "No",
      "use-customer-without-de": "Per reimpostare la password, ti preghiamo di utilizzare il tuo codice cliente (senza il prefisso >DE<).",
      "yes": "Sì",
      "use-customer-without-de-prefix": "Utilizza il tuo codice cliente (senza il prefisso >DE<) per effettuare il login e segui la procedura indicata per creare il tuo account utente personale.",
      "i-cannot-sign-in-to-my-account": "Non riesco a effettuare il login."
    },
    "api": {
      "incorrect-username-or-password": "Nome utente sbagliato o password errata.",
      "invalid-code-provided": "Si è verificato un errore. Riavvia la procedura di modifica della password.",
      "user-does-not-exist": "Utente inesistente",
      "password-validation-error": "La password non corrisponde ai requisiti richiesti.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Utente inesistente",
      "password-missing-number": "La password non corrisponde ai requisiti richiesti. Inserire una password con almeno una cifra.",
      "incorrect-old-password": "Vecchia password errata",
      "user-is-already-registered": "Questo utente è già registrato.",
      "your-password-has-been-changed": "La password è stata modificata.",
      "password-missing-uppercase": "La password non corrisponde ai requisiti richiesti. Inserire una password con almeno una lettera maiuscola.",
      "invalid-verification-provided": "La durata di validità del link utilizzato è scaduta. Clicca sul link contenuto nell'ultima e-mail “Reset password”.",
      "email-used-by-different-user": "Questo indirizzo e-mail viene utilizzato da un altro utente.",
      "password-not-long-enough": "La password non corrisponde ai requisiti richiesti. Inserire una password con almeno otto caratteri.",
      "an-error-occurred": "Si è verificato un errore. Ti preghiamo di riprovare più tardi.",
      "attempt-limit-exceeded": "Hai cercato di cambiare la password troppo spesso. Aspetta un po' e ricomincia il processo di modifica della password.",
      "incorrect_old_password": "Vecchia password errata",
      "password-missing-lowercase": "La password non corrisponde ai requisiti richiesti. Inserire una password con almeno una lettera minuscola.",
      "generic-api-message": "Ti preghiamo di controllare il tuo inserimento dati. Digita nuovamente a mano. Se l'errore persiste, contatta il nostro team di assistenza."
    },
    "common": {
      "please-wait": "Ti preghiamo di attendere...",
      "send-code": "Invia il codice",
      "your-account": "Il tuo account utente Hella Gutmann",
      "close": "Chiudi",
      "please-fill-in-this-field": "Compila questo campo.",
      "hgsKey": "Indirizzo e-mail (se hai creato un account utente personale) o il tuo codice cliente",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Gestisci il tuo profilo utente con Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Ripeti il processo più tardi.</0> Se il problema persiste, contatta il l'assistenza clienti.",
      "this-field-cannot-be-left-blank": "Questo campo non deve essere lasciato vuoto.",
      "please-enter-your-login": "Effettua qui il tuo login. Ti invieremo un codice di sei cifre al tuo indirizzo e-mail. Inserisci questo codice nella pagina seguente. Non chiudere il browser.",
      "password-validation-error": "La password non corrisponde ai requisiti richiesti.",
      "hide-password": "Nascondi la password",
      "go-to-login": "Vai al login",
      "invalid-characters": "Sono stati inseriti caratteri non validi. Ti preghiamo di modificare l'inserimento.",
      "first-name-and-last-name-too-short": "Inserire solo caratteri alfabetici e almeno due cifre.",
      "an-error-occurred": "Si è verificato un errore.",
      "please-enter-a-valid-email-address": "Inserire un indirizzo e-mail valido. I caratteri consentiti sono quelli alfanumerici e i seguenti caratteri speciali: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Utente inesistente",
      "show-password": "Mostra la password",
      "no-number-and-email": "Ti preghiamo di inserire un indirizzo e-mail valido o il tuo codice cliente composto esclusivamente da numeri.",
      "passwords-does-not-match": "Le password non corrispondono.",
      "user-does-not-exist": "Utente inesistente",
      "your-user-profile": "Il tuo profilo utente",
      "enter-code": "Inserire il codice"
    },
    "dashboard": {
      "logout": "Scollegarsi",
      "lead": "Seleziona l'applicazione a cui vuoi accedere con il tuo account Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "\t\nPer poter utilizzare mega macs S 20, l'app mega macs S 20 deve essere installata sul dispositivo Android. L'app è disponibile su Play Store.",
      "x20-please-sign-in-title": "\t\nLogin CSC-Tool X 20",
      "x20-please-sign-in-content": "Accedere al CSC-Tool X 20 con il proprio account Hella Gutmann.",
      "s20-please-start-device-title": "Login mega macs S 20"
    },
    "errorMessage": {
      "error": "Errore",
      "something-went-wrong": "Qualcosa non quadra."
    },
    "faq": {
      "howDoIChangePassword": "Come faccio a modificare la password dell'account Hella Gutmann?",
      "howDoIGetAHellaGutmannAccount": "Come ottenere un account Hella Gutmann?",
      "possibleToUseMultipleAccounts": "Questa soluzione consente ai clienti di accedere in modo sicuro a diverse applicazioni e siti web Hella Gutmann con un solo accesso e un solo login.",
      "backToLogin": "TORNA AL LOGIN",
      "itIsASingleSignOnSolution": "L'account Hella Gutmann è la soluzione di single sign-on (SSO) di Hella Gutmann. Per l'accesso sono necessari un indirizzo e-mail e una password a scelta.",
      "title": "Domande frequenti (FAQ)",
      "whatIsAHellaGutmannAccount": "Che cos'è l'account Hella Gutmann?",
      "supportedAppsConstantlyExpanded": "Il numero di applicazioni supportate viene costantemente ampliato. L'account Hella Gutmann supporta attualmente le seguenti applicazioni",
      "alternativeContactSupport": "In alternativa, contatta il nostro team di assistenza.",
      "howDoIResetPassword": "Come faccio a resettare la password dell'account Hella Gutmann?",
      "asSoonAsYouGetAccessToProducts": "Non appena hai acquistato uno dei prodotti supportati o sei stato autorizzato ad accedere a macs365, riceverai un'e-mail per configurare un account Hella Gutmann. L'e-mail verrà inviata all'indirizzo e-mail che abbiamo in archivio tramite un processo automatico.",
      "whatToDoIfNoEMailReceived": "Cosa posso fare se non ho ricevuto l'e-mail per la creazione dell'account Hella Gutmann?",
      "clickOnForgotPassword": "Un'opzione è quella di richiedere l'e-mail richiesta tramite <1>Password dimenticata</1>. Assicurati che l'indirizzo e-mail inserito corrisponda a quello specificato al momento della registrazione.",
      "changeEmailOnUserProfile": "È possibile modificare l'indirizzo e-mail dell'account Hella Gutmann utilizzato per il login tramite >Profilo utente< (il profilo utente è attualmente disponibile solo per i clienti con accesso a macs365).",
      "changePasswordOnUserProfile": "È possibile modificare la password dell'account Hella Gutmann tramite >Profilo utente< (il profilo utente è attualmente disponibile solo per i clienti con accesso a macs365).",
      "howDoIChangeEmailAddress": "Come posso modificare l'indirizzo e-mail dell'account Hella Gutmann?",
      "whichAppsAreSupported": "Quali applicazioni sono supportate dall'account Hella Gutmann?"
    },
    "footer": {
      "imprint": "Liberatoria legale",
      "faq": "FAQ",
      "faq-heading": "Domande frequenti (FAQ)",
      "data-privacy-policy": "Informativa sulla privacy",
      "terms-and-conditions": "Condizioni di utilizzo"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "L'invio di una e-mail non è stato possibile a causa di troppi tentativi falliti. Riprova tra qualche ora.",
      "send-email": "Invia",
      "reset-your-password": "Resetta la password",
      "forgot-password-button-clicked-alert": "L'e-mail è stata inviata con successo. La consegna può richiedere alcuni minuti.",
      "back-to-login": "Torna al login",
      "enter-your-login-V2": "Indirizzo e-mail",
      "please-enter-your-login": "Effettua il tuo login e riceverai una e-mail di conferma. Fai clic sul pulsante di verifica contenuto nella e-mail.",
      "enter-your-login": "Il tuo login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Scegli una password sicura e inseriscila in entrambi i campi.",
      "reset-your-password": "Imposta una nuova password",
      "repeat-password": "Ripeti la nuova password",
      "a-verification-email-has-been-sent-to-you": "Ti è stata inviata una e-mail di conferma.",
      "reset-password": "Imposta una password",
      "new-password": "Nuova password",
      "passwords-do-not-match": "Le password non corrispondono! Ti preghiamo di controllare il tuo inserimento."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Ora puoi utilizzare la tua nuova password.",
      "setting-new-password-successful": "La nuova password è stata impostata con successo!",
      "go-to-login": "Vai al login"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTel.: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nCodice fiscale: 07011/39801 \n\nCodice IVA: DE 14 220 8666 \n\nRegistro delle imprese: HRB 290194, Friburgo \n\nCEO: Adnan Cemal",
      "header": "Liberatoria legale",
      "back": "TORNA AL LOGIN"
    },
    "menu": {
      "digital-products": "Prodotti digitali"
    },
    "migration": {
      "helper-text-surname": "Inserisci un cognome",
      "description-submit": "Dopo aver inviato il modulo, ti invieremo un messaggio all'indirizzo e-mail indicato. Clicca sul pulsante di verifica per confermare il tuo indirizzo e-mail.",
      "firstname": "Nome",
      "description-login": "Effettua quindi il login con il tuo indirizzo e-mail e la tua password attuale. Non sarà più possibile accedere con il tuo codice cliente.",
      "submit": "Invia",
      "email": "Indirizzo e-mail",
      "page-title": "Il tuo account utente Hella Gutmann",
      "helper-text-firstname": "Inserisci un nome",
      "surname": "Cognome",
      "title": "Modifica del tuo login",
      "helper-text-email": "Inserisci un indirizzo e-mail",
      "description-user-account": "Hella Gutmann sta modificando la procedura di autenticazione e introduce l'account utente personale. Inserisci qui un nome, un cognome e un indirizzo e-mail per il tuo account utente personale."
    },
    "migrationError": {
      "go-to-login": "Vai al login",
      "your-email-address-could-not-get-confirmed": "Non è stato possibile confermare il tuo nuovo indirizzo e-mail. Molto probabilmente il link nella tua e-mail è già scaduto. Effettua nuovamente il login e ricomincia la procedura dall'inizio.",
      "change-of-your-login-failed": "Modifica del tuo login fallita"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Ti abbiamo inviato un'e-mail</0> all'indirizzo e-mail inserito. Per confermare l'indirizzo e-mail, accedi alla tua casella di posta elettronica e <2>clicca sul pulsante di verifica contenuto nella e-mail</2>.",
      "for-security-reasons": "Per motivi di sicurezza, il link fornito non è più valido dopo 24 ore. In tal caso, avvia nuovamente la procedura.",
      "sending-successful": "Trasmissione dati riuscita"
    },
    "migrationVerify": {
      "verification-button": "Conferma",
      "verification-header": "Conferma dell'account utente",
      "verification-description": "Clicca sul pulsante per confermare la creazione del tuo account utente personalizzato."
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Indirizzo e-mail confermato",
      "from-now-on-please-login-with-the-email": "D'ora in poi, effettua il login con questo indirizzo e-mail e la tua password.",
      "your-email-address-has-been-confirmed": "Il tuo indirizzo e-mail è stato confermato."
    },
    "needHelp": {
      "for-further-questions": "In caso di ulteriori domande, la nostra hotline<1/> è disponibile dal lunedì al venerdì dalle ore 8:00 alle ore 17:00.",
      "need-help-logging-in": "Hai bisogno di aiuto per effettuare il login?",
      "here-you-will-find": "<0>Qui</0> trovi le soluzioni alle <2>FAQ.</2\r"
    },
    "passwordPolicy": {
      "lowercase-letter": "lettera minuscola",
      "uppercase-letter": "lettera maiuscola",
      "the-new-password-requires": "Requisiti della password:",
      "characters": "caratteri",
      "number": "cifre"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Termine della disdetta"
    },
    "settings": {
      "user-information-saved": "Le informazioni utente sono state salvate.",
      "update-user-information": "Il tuo profilo utente",
      "new-password": "Nuova password",
      "resend-verification": "Inviare nuovamente la verifica",
      "save": "Salva",
      "language-preference-saved": "L'impostazione della lingua è stata salvata.",
      "email-has-been-sent": "Ti è stata inviata una e-mail di conferma.",
      "firstname": "Nome",
      "repeat-password": "Ripeti la password",
      "your-user-data": "I tuoi dati utente",
      "set-new-password": "Imposta una nuova password",
      "email-is-not-verified-yet": "L'e-mail non è ancora stata verificata",
      "old-password": "Vecchia password",
      "new-login-info": "Ricordati che il tuo nuovo indirizzo e-mail sarà anche il tuo login.",
      "update-your-email": "Aggiorna il tuo indirizzo e-mail",
      "email": "Indirizzo e-mail",
      "incorrect-username-or-password": "Password non corretta!",
      "back": "Indietro",
      "resend": "Invia un'altra volta",
      "update-your-language": "Lingua preferita",
      "surname": "Cognome",
      "passwords-do-not-match": "Le password non corrispondono! Ti preghiamo di controllare il tuo inserimento.",
      "submit-new-email-info": "Se inserisci un nuovo indirizzo e-mail, riceverai una e-mail di conferma. Fai clic sul link contenuto in questa e-mail per confermare il nuovo indirizzo e-mail.",
      "this-language-will-be-used": "Questa lingua viene utilizzata per il tuo account utente personale e per le tue e-mail. Le e-mail di fatturazione non sono interessate."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Hai dimenticato la password?",
      "your-login-V2": "Indirizzo e-mail",
      "your-password": "La tua password",
      "sign-in-at-hella-gutmann": "Effettua il login a Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Le password non corrispondono.",
      "noMatchedEmails": "Gli indirizzi e-mail non corrispondono.",
      "lead": "Ti preghiamo di inserire i tuoi dati per creare un account Hella Gutmann.",
      "descriptionUserAccountV2": "Hella Gutmann sta modificando la procedura di autenticazione e introduce l'account utente personale. Inserisci qui un nome, un cognome e una password per il tuo account utente personale.",
      "password": "Password",
      "descriptionLogin": "Dopo la verifica, puoi effettuare il login con il tuo indirizzo e-mail e la tua password.",
      "passwordLead": "Scegli una password sicura e inseriscila in entrambi i campi.",
      "familyName": "Cognome",
      "repeatEmail": "Ripeti l'indirizzo e-mail",
      "header": "Registrazione",
      "email": "Indirizzo e-mail",
      "signup": "Registrati",
      "givenName": "Nome",
      "repeatPassword": "Ripeti la password",
      "descriptionUserAccount": "Hella Gutmann sta modificando la procedura di autenticazione e introduce l'account utente personale. Inserisci qui un nome, un cognome, un indirizzo e-mail e una password per il tuo account utente personale."
    },
    "signUpComplete": {
      "header": "Registrazione riuscita",
      "info": "Attenzione: per accedere al proprio account Hella Gutmann, oltre alla password appena assegnata, utilizzare l'indirizzo e-mail a cui è stato inviato l'e-mail di registrazione.",
      "yourUserProfile": "Il tuo profilo utente"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Trasmissione dati riuscita",
      "forSecurityReasons": "Per motivi di sicurezza, il link fornito non è più valido dopo 24 ore. In tal caso, effettua nuovamente il login con i vecchi dati di accesso e ripeti la procedura.",
      "weSentYouAnEmail": "<0>Ti abbiamo inviato un'e-mail</0> all'indirizzo e-mail inserito. Per confermare l'indirizzo e-mail, accedi alla tua casella di posta elettronica e <2>clicca sul pulsante di verifica contenuto nella e-mail</2>.",
      "for-security-reasons": "Per motivi di sicurezza, il link fornito non è più valido dopo 24 ore. In tal caso, avvia nuovamente la procedura."
    },
    "signUpVerify": {
      "description": "Clicca sul pulsante per confermare la creazione del tuo account utente personalizzato.",
      "header": "Conferma dell'account utente",
      "button": "Conferma"
    },
    "verify": {
      "verification-description": "Fai clic sul link sul pulsante per confermare il tuo indirizzo e-mail.",
      "verification-header": "Conferma dell'indirizzo e-mail",
      "verification-button": "CONFERMA"
    },
    "verifySuccess": {
      "your-user-profile": "Il tuo profilo utente",
      "from-now-on-we-will-send-you-messages": "Da ora in poi utilizzeremo il tuo nuovo indirizzo e-mail per tutte le comunicazioni con macs365.",
      "keep-in-mind-that-this-email": "Il nuovo indirizzo e-mail sarà utilizzato come nome utente per l'accesso.",
      "change-of-email-address-successful": "Modifica dell'indirizzo e-mail riuscita."
    },
    "wizard": {
      "close": "Chiudi macs365"
    }
  },
  "nl": {
    "FAQModal": {
      "use-email-instead-of-customer": "Gebruik voor het resetten van uw wachtwoord niet uw klantnummer maar uw e-mailadres.",
      "missing-verification-email": "Ik ontvang geen bevestigings-e-mail.",
      "missing-forgot-password-email": "Ik ontvang geen e-mail \"Wachtwoord vergeten\".",
      "creating-your-personalized": "U probeert uw persoonlijk gebruikersaccount direct met uw e-mailadres aan te maken. Log eerst in met uw klantnummer en volg de stappen voor het aanmaken van uw persoonlijk gebruikersaccount.",
      "use-email-instead-of-your-customer": "Gebruik voor het inloggen niet uw klantnummer maar uw e-mailadres.",
      "frequently-asked-questions": "Veelgestelde vragen",
      "personalized-user-account": "Heeft u een persoonlijk gebruikersaccount aangemaakt?",
      "no": "Nee",
      "use-customer-without-de": "Gebruik voor het resetten van uw wachtwoord uw klantnummer (zonder prefix, zoals \"DE\").",
      "yes": "Ja",
      "use-customer-without-de-prefix": "Gebruik uw klantnummer (zonder prefix zoals \"DE\") om in te loggen en volg de stappen voor het aanmaken van uw persoonlijk gebruikersaccount.",
      "i-cannot-sign-in-to-my-account": "Ik kan mij niet aanmelden."
    },
    "api": {
      "incorrect-username-or-password": "Verkeerde gebruikersnaam of verkeerd wachtwoord.",
      "invalid-code-provided": "Er is een fout opgetreden. Start opnieuw de wijziging van het wachtwoord.",
      "user-does-not-exist": "Gebruiker bestaat niet",
      "password-validation-error": "Het wachtwoord voldoet niet aan de vereisten.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Gebruiker bestaat niet",
      "password-missing-number": "Het wachtwoord voldoet niet aan de vereisten. Voer een wachtwoord in met minimaal één cijfer.",
      "incorrect-old-password": "Onjuist oud wachtwoord",
      "user-is-already-registered": "De gebruiker is al geregistreerd.",
      "your-password-has-been-changed": "Uw wachtwoord is gewijzigd.",
      "password-missing-uppercase": "Het wachtwoord voldoet niet aan de vereisten. Voer een wachtwoord in met minimaal één hoofdletter.",
      "invalid-verification-provided": "Er is een verlopen link gebruikt. Gebruik de link in de laatste e-mail \"Wachtwoord resetten\".",
      "email-used-by-different-user": "Dit e-mailadres wordt al door een andere gebruiker toegepast.",
      "password-not-long-enough": "Het wachtwoord voldoet niet aan de vereisten. Voer een wachtwoord in met minimaal 8 karakters.",
      "an-error-occurred": "Er is een fout opgetreden. Probeer het later nog een keer.",
      "attempt-limit-exceeded": "U heeft te vaak geprobeerd het wachtwoord te wijzigen. Wacht een poosje en start opnieuw met de wijziging van het wachtwoord.",
      "incorrect_old_password": "Onjuist oud wachtwoord",
      "password-missing-lowercase": "Het wachtwoord voldoet niet aan de vereisten. Voer een wachtwoord in met minimaal één kleine letter.",
      "generic-api-message": "Controleer uw invoer. Herhaal de invoer met handmatig typen. Blijft de fout bestaan, neem dan contact op met onze support."
    },
    "common": {
      "please-wait": "Even geduld graag",
      "send-code": "Code verzenden",
      "your-account": "Uw Hella Gutmann gebruikersaccount",
      "close": "Sluiten",
      "please-fill-in-this-field": "Vul dit veld in.",
      "hgsKey": "E-mailadres (wanneer u een persoonlijk gebruikersaccount heeft aangemaakt) of klantnummer",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Beheer uw gebruikersprofiel met Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Start de procedure later opnieuw.</0> Doet het probleem zich nogmaals voor, neem dan contact op met het Customer Center.",
      "this-field-cannot-be-left-blank": "Dit veld mag niet leeg blijven.",
      "please-enter-your-login": "Voer hier uw login-gegevens in. Wij sturen vervolgens een uit 6 posities bestaande code naar uw e-mailadres. Voer deze code in op de volgende pagina. Sluit de browser niet.",
      "password-validation-error": "Het wachtwoord voldoet niet aan de vereisten.",
      "hide-password": "Wachtwoord verbergen",
      "go-to-login": "Naar inloggen",
      "invalid-characters": "U heeft een niet-toegestaan teken ingevoerd. Wijzig uw invoer.",
      "first-name-and-last-name-too-short": "Gebruik uitsluitend alfabetische tekens en ten minste twee cijfers.",
      "an-error-occurred": "Er is een fout opgetreden",
      "please-enter-a-valid-email-address": "Voer een geldig e-mailadres in. Toegestane tekens zijn alfanumerieke tekens en de volgende speciale tekens: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Gebruiker bestaat niet",
      "show-password": "Wachtwoord weergeven",
      "no-number-and-email": "Voer een geldig e-mailadres in of uw klantnummer (uitsluitend de cijfers van het klantnummer).",
      "passwords-does-not-match": "De wachtwoorden komen niet overeen.",
      "user-does-not-exist": "Gebruiker bestaat niet",
      "your-user-profile": "Uw gebruikersprofiel",
      "enter-code": "Voer de code in"
    },
    "dashboard": {
      "logout": "Afmelden",
      "lead": "Selecteer de applicatie die u met uw Hella Gutmann-account wilt gebruiken."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Om mega macs S 20 te kunnen gebruiken, moet de mega macs S 20 app op je Android-apparaat zijn geïnstalleerd. De app is verkrijgbaar in de Play Store.",
      "x20-please-sign-in-title": "Login voor CSC-Tool X 20",
      "x20-please-sign-in-content": "Log in met je Hella Gutmann-account op je CSC-Tool X 20.",
      "s20-please-start-device-title": "Login voor mega macs S 20"
    },
    "errorMessage": {
      "error": "Fout",
      "something-went-wrong": "Er verliep iets niet correct."
    },
    "faq": {
      "howDoIChangePassword": "Hoe kan ik het wachtwoord voor het Hella Gutmann-account wijzigen?",
      "howDoIGetAHellaGutmannAccount": "Hoe kom ik aan een Hella Gutmann-account?",
      "possibleToUseMultipleAccounts": "Met deze oplossing kunnen klanten meerdere applicaties en websites van Hella Gutmann veilig gebruiken met slechts één toegang en één eenmalige registratie.",
      "backToLogin": "TERUG NAAR LOGIN",
      "itIsASingleSignOnSolution": "Hella Gutmann-account is de single sign-on-oplossing (SSO) van Hella Gutmann.",
      "title": "Veelgestelde vragen (FAQ)",
      "whatIsAHellaGutmannAccount": "Wat is het Hella Gutmann-account?",
      "supportedAppsConstantlyExpanded": "Het aantal ondersteunde applicaties wordt voortdurend uitgebreid. Actueel ondersteunt het Hella Gutmann-account de volgende applicaties",
      "alternativeContactSupport": "Alternatief kunt u contact opnemen met onze support.",
      "howDoIResetPassword": "Hoe kan ik het wachtwoord voor het Hella Gutmann-account resetten?",
      "asSoonAsYouGetAccessToProducts": "Bezit u een of meer van de ondersteunde producten of toegang tot macs365 dan ontvangt u een e-mail voor het aanmaken van een Hella-Gutmann-account. Via een geautomatiseerde procedure wordt deze e-mail verzonden naar het bij ons geregistreerde e-mailadres.",
      "whatToDoIfNoEMailReceived": "Wat kan ik doen wanneer ik geen e-mail heb ontvangen voor het aanmaken van het Hella Gutmann-account?",
      "clickOnForgotPassword": "Een mogelijkheid is om de benodigde e-mail aan te vragen via <1>Wachtwoord vergeten</1>. Let er hierbij op dat het ingevoerde e-mailadres overeenkomt met het e-mailadres dat bij ons is geregistreerd.",
      "changeEmailOnUserProfile": "Het e-mailadres dat u gebruikt voor inloggen op uw Hella Gutmann-account kan worden gewijzigd via de pagina Gebruikersprofiel – (Gebruikersprofiel is momenteel alleen toegankelijk voor klanten met macs365).",
      "changePasswordOnUserProfile": "Het wachtwoord voor het Hella Gutmann-account kan worden gewijzigd via de pagina Gebruikersprofiel – (Gebruikersprofiel is momenteel alleen toegankelijk voor klanten met macs365).",
      "howDoIChangeEmailAddress": "Hoe kan ik het e-mailadres voor het Hella Gutmann-account wijzigen?",
      "whichAppsAreSupported": "Welke applicaties worden door Hella Gutmann-account ondersteund?"
    },
    "footer": {
      "imprint": "Colofon",
      "faq": "FAQ",
      "faq-heading": "Veelgestelde vragen (FAQ)",
      "data-privacy-policy": "Privacyverklaring",
      "terms-and-conditions": "Gebruiksvoorwaarden"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Het verzenden van een e-mail was ten gevolge van te vele mislukte pogingen niet mogelijk. Probeer het over enkele uren opnieuw.",
      "send-email": "Verzenden",
      "reset-your-password": "Uw wachtwoord resetten",
      "forgot-password-button-clicked-alert": "De e-mail is succesvol verzonden. Eventueel kan het enkele minuten duren tot de bezorging.",
      "back-to-login": "Terug naar inloggen",
      "enter-your-login-V2": "E-mailadres",
      "please-enter-your-login": "Voer uw login-gegevens in en wij sturen u een bevestigings-e-mail. Open de bevestigings-e-mail en gebruik hier de knop voor verificatie.",
      "enter-your-login": "Uw login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Kies een veilig wachtwoord en voer dit in beide velden in.",
      "reset-your-password": "Nieuw wachtwoord instellen",
      "repeat-password": "Nieuw wachtwoord herhalen",
      "a-verification-email-has-been-sent-to-you": "Een bevestigings-e-mail is naar u verzonden.",
      "reset-password": "Wachtwoord instellen",
      "new-password": "Nieuw wachtwoord",
      "passwords-do-not-match": "De beide wachtwoorden komen niet overeen. Controleer uw invoer."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Het nieuwe wachtwoord kan nu worden gebruikt.",
      "setting-new-password-successful": "Nieuw wachtwoord is succesvol vastgelegd!",
      "go-to-login": "Naar inloggen"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH\n\nAm Krebsbach 2\n\n79241 Ihringen Duitsland\n\nTel.: +49 7668 9900 888\n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nBelastingnummer: 07011/39801\n\nVAT/btw-nummer: DE 14 220 8666 \n\nHandelsregister: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Colofon",
      "back": "TERUG NAAR LOGIN"
    },
    "menu": {
      "digital-products": "Digitale producten"
    },
    "migration": {
      "helper-text-surname": "Voer een achternaam in",
      "description-submit": "Na verzending van het formulier sturen wij u een bericht naar het aangegeven e-mailadres. Gebruik de verificatieknop in deze e-mail voor het bevestigen van uw e-mailadres.",
      "firstname": "Voornaam",
      "description-login": "Vervolgens logt u in met uw e-mailadres en uw actuele wachtwoord. Het inloggen met klantnummer is niet meer mogelijk.",
      "submit": "Verzenden",
      "email": "E-mailadres",
      "page-title": "Uw Hella Gutmann gebruikersaccount",
      "helper-text-firstname": "Voer een voornaam in",
      "surname": "Naam",
      "title": "Wijziging van uw login",
      "helper-text-email": "Voer een e-mailadres in",
      "description-user-account": "Hella Gutmann stapt over op persoonlijke gebruikersaccounts. Voer hier een voornaam, een achternaam en een e-mailadres voor uw persoonlijk gebruikersaccount in."
    },
    "migrationError": {
      "go-to-login": "Naar inloggen",
      "your-email-address-could-not-get-confirmed": "Uw nieuwe e-mailadres kon niet worden bevestigd. Waarschijnlijk is de link in uw e-mail verlopen. Meld u zich alstublieft opnieuw aan en herstart de procedure.",
      "change-of-your-login-failed": "Wijziging van uw login is mislukt"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Wij hebben een e-mail</0> gezonden aan het ingevoerde e-mailadres. Ga om het e-mailadres te bevestigen naar uw inbox en <2>gebruik de verificatieknop in de e-mail</2>.",
      "for-security-reasons": "Uit veiligheidsoverwegingen vervalt de link na 24 uur. Indien dit gebeurt, start dan de procedure opnieuw.",
      "sending-successful": "Overdracht succesvol"
    },
    "migrationVerify": {
      "verification-button": "Bevestigen",
      "verification-header": "Bevestiging van het gebruikersaccount",
      "verification-description": "Gebruik de knop om het aanmaken van uw gepersonaliseerd gebruikersaccount te bevestigen"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "E-mailadres bevestigd",
      "from-now-on-please-login-with-the-email": "Meld u zich vanaf nu aan met dit e-mailadres en uw wachtwoord.",
      "your-email-address-has-been-confirmed": "E-mailadres is bevestigd"
    },
    "needHelp": {
      "for-further-questions": "Voor verdere vragen is onze helpdesk<1/> ma. t/m vr. van 8:00-17:00 uur bereikbaar.",
      "need-help-logging-in": "Wenst u ondersteuning bij de aanmelding?",
      "here-you-will-find": "<0>Hier</0> bevinden zich oplossingen voor <2>veelgestelde vragen.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "Kleine letter",
      "uppercase-letter": "Hoofdletter",
      "the-new-password-requires": "Vereisten voor wachtwoord:",
      "characters": "Posities",
      "number": "Cijfer"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Opzegtermijn"
    },
    "settings": {
      "user-information-saved": "Gebruikersinformatie is opgeslagen.",
      "update-user-information": "Gebruikersprofiel",
      "new-password": "Nieuw wachtwoord",
      "resend-verification": "Verificatie opnieuw verzenden",
      "save": "Opslaan",
      "language-preference-saved": "Taalinstelling is opgeslagen.",
      "email-has-been-sent": "Een bevestigings-e-mail is naar u verzonden.",
      "firstname": "Voornaam",
      "repeat-password": "Wachtwoord herhalen",
      "your-user-data": "Uw gebruikersgegevens",
      "set-new-password": "Nieuw wachtwoord instellen",
      "email-is-not-verified-yet": "E-mail is nog niet geverifieerd",
      "old-password": "Oud wachtwoord",
      "new-login-info": "Let erop dat uw nieuwe e-mailadres ook uw login wordt.",
      "update-your-email": "Werk uw e-mailadres bij",
      "email": "E-mailadres",
      "incorrect-username-or-password": "Verkeerd wachtwoord.",
      "back": "Terug",
      "resend": "Opnieuw verzenden",
      "update-your-language": "Voorkeurstaal",
      "surname": "Naam",
      "passwords-do-not-match": "De beide wachtwoorden komen niet overeen. Controleer uw invoer.",
      "submit-new-email-info": "Wij sturen u een bevestigings-e-mail wanneer u een nieuw e-mailadres opgeeft. Gebruik de link van de e-mail om het nieuwe e-mailadres te bevestigen.",
      "this-language-will-be-used": "Deze taal wordt gebruikt voor uw persoonlijk gebruikersaccount en uw e-mails. Dit geldt niet voor e-mails die facturen bevatten."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Wachtwoord vergeten?",
      "your-login-V2": "E-mailadres",
      "your-password": "Uw wachtwoord",
      "sign-in-at-hella-gutmann": "Inloggen bij Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "De wachtwoorden komen niet overeen.",
      "noMatchedEmails": "De e-mailadressen komen niet overeen.",
      "lead": "Voer uw informatie in om een Hella Gutmann-account aan te maken.",
      "descriptionUserAccountV2": "Hella Gutmann stapt over op persoonlijke gebruikersaccounts. Voer hier een voornaam, een achternaam en een wachtwoord voor uw persoonlijk gebruikersaccount in.",
      "password": "Wachtwoord",
      "descriptionLogin": "Na de verificatie logt u in met uw e-mailadres en uw wachtwoord.",
      "passwordLead": "Kies een veilig wachtwoord en voer dit in beide velden in.",
      "familyName": "Naam",
      "repeatEmail": "E-mailadres herhalen",
      "header": "Registratie",
      "email": "E-mailadres",
      "signup": "Registreren",
      "givenName": "Voornaam",
      "repeatPassword": "Wachtwoord herhalen",
      "descriptionUserAccount": "Hella Gutmann stapt over op persoonlijke gebruikersaccounts. Voer hier een voornaam, een achternaam, een e-mailadres en een wachtwoord voor uw persoonlijk gebruikersaccount in."
    },
    "signUpComplete": {
      "header": "Registratie succesvol",
      "info": "Let op: voor aanmelding bij uw Hella Gutmann-account gebruikt u het zojuist aangemaakte wachtwoord en het e-mailadres waar naartoe wij de registratie-e-mail hebben gezonden.",
      "yourUserProfile": "Uw gebruikersprofiel"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Overdracht succesvol",
      "forSecurityReasons": "Uit veiligheidsoverwegingen vervalt de link na 24 uur. Indien dit gebeurt, log dan opnieuw in met uw oude toegangsgegevens en start de procedure opnieuw.",
      "weSentYouAnEmail": "<0>Wij hebben een e-mail</0> gezonden aan het ingevoerde e-mailadres. Ga om het e-mailadres te bevestigen naar uw inbox en <2>gebruik de verificatieknop in de e-mail</2>.",
      "for-security-reasons": "Uit veiligheidsoverwegingen vervalt de link na 24 uur. Indien dit gebeurt, start dan de procedure opnieuw."
    },
    "signUpVerify": {
      "description": "Gebruik de knop om het aanmaken van uw gepersonaliseerd gebruikersaccount te bevestigen",
      "header": "Bevestiging van het gebruikersaccount",
      "button": "Bevestigen"
    },
    "verify": {
      "verification-description": "Gebruik de knop om het nieuwe e-mailadres te bevestigen",
      "verification-header": "Bevestiging van het e-mailadres",
      "verification-button": "BEVESTIGEN"
    },
    "verifySuccess": {
      "your-user-profile": "Uw gebruikersprofiel",
      "from-now-on-we-will-send-you-messages": "Vanaf nu gebruiken wij uw nieuwe e-mailadres voor alle communicatie betreffende macs365.",
      "keep-in-mind-that-this-email": "Let erop dat uw nieuwe e-mailadres ook gebruikt wordt als gebruikersnaam bij het inloggen.",
      "change-of-email-address-successful": "Wijziging van het e-mailadres succesvol."
    },
    "wizard": {
      "close": "macs365 afsluiten"
    }
  },
  "pl": {
    "FAQModal": {
      "use-email-instead-of-customer": "Zamiast numeru klienta, do zresetowania hasła użyj adresu e-mail.",
      "missing-verification-email": "Nie otrzymuję e-maila z potwierdzeniem.",
      "missing-forgot-password-email": "Nie otrzymuję wiadomości e-mail z informacją o zapomnianym haśle.",
      "creating-your-personalized": "Próbujesz utworzyć osobiste konto użytkownika bezpośrednio przy użyciu adresu e-mail. Najpierw zaloguj się przy użyciu swojego numeru klienta i postępuj zgodnie z instrukcjami, aby utworzyć osobiste konto użytkownika.",
      "use-email-instead-of-your-customer": "Zamiast numeru klienta, podczas logowania podaj swój adres e-mail.",
      "frequently-asked-questions": "Często zadawane pytania",
      "personalized-user-account": "Czy utworzyłeś(-łaś) osobiste konto użytkownika?",
      "no": "Nie",
      "use-customer-without-de": "Aby zresetować hasło, należy użyć numeru klienta (bez prefiksu „PL”).",
      "yes": "Tak",
      "use-customer-without-de-prefix": "Aby się zalogować, użyj swojego numeru klienta (bez prefiksu „PL”) i postępuj zgodnie z instrukcjami, aby utworzyć osobiste konto użytkownika.",
      "i-cannot-sign-in-to-my-account": "Nie mogę się zalogować."
    },
    "api": {
      "incorrect-username-or-password": "Nieprawidłowa nazwa użytkownika lub hasło.",
      "invalid-code-provided": "Wystąpił błąd. Rozpocznij zmianę hasła od początku.",
      "user-does-not-exist": "Użytkownik nie istnieje",
      "password-validation-error": "Hasło nie spełnia wymagań.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Użytkownik nie istnieje",
      "password-missing-number": "Hasło nie spełnia wymagań. Wprowadź hasło składające się z co najmniej 1 cyfry.",
      "incorrect-old-password": "Nieprawidłowe stare hasło",
      "user-is-already-registered": "Użytkownik jest już zarejestrowany.",
      "your-password-has-been-changed": "Twoje hasło zostało zmienione.",
      "password-missing-uppercase": "Hasło nie spełnia wymagań. Wprowadź hasło składające się z co najmniej 1 dużej litery.",
      "invalid-verification-provided": "Użyto wygasłego linku. Kliknij na link zawarty w ostatniej wiadomości e-mail o treści „Zresetuj hasło”.",
      "email-used-by-different-user": "Adres e-mail jest używany przez innego użytkownika.",
      "password-not-long-enough": "Hasło nie spełnia wymagań. Wprowadź hasło składające się z co najmniej 8 pozycji.",
      "an-error-occurred": "Wystąpił błąd. Spróbuj ponownie później.",
      "attempt-limit-exceeded": "Hasło było zmieniane zbyt często. Odczekaj chwilę i ponownie rozpocznij proces zmiany hasła.",
      "incorrect_old_password": "Nieprawidłowe stare hasło",
      "password-missing-lowercase": "Hasło nie spełnia wymagań. Wprowadź hasło składające się z co najmniej 1 małej litery.",
      "generic-api-message": "Skontroluj swój wpis. Wpisz ponownie. Jeśli błąd nadal występuje, skontaktuj się z naszym zespołem pomocy technicznej."
    },
    "common": {
      "please-wait": "Proszę czekać",
      "send-code": "Wysyłanie kodu",
      "your-account": "Twoje konto użytkownika Hella Gutmann",
      "close": "Zamknij",
      "please-fill-in-this-field": "Wypełnij to pole.",
      "hgsKey": "Adres e-mail (jeśli utworzyłeś osobiste konto użytkownika) lub numer klienta",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Zarządzaj swoim profilem użytkownika za pomocą kont Hella Gutmann.",
      "please-start-the-process-again-later": "<0>Rozpocznij proces ponownie później.</0> Jeśli problem wystąpi ponownie, skontaktuj się z Centrum Obsługi Klienta.",
      "this-field-cannot-be-left-blank": "To pole to nie może pozostać puste.",
      "please-enter-your-login": "Wprowadź tutaj swój login. Następnie wyślemy Ci 6-cyfrowy kod na Twój adres e-mail. Wpisz ten kod na następnej stronie. Nie zamykaj przeglądarki.",
      "password-validation-error": "Hasło nie spełnia wymagań.",
      "hide-password": "Ukryj hasło",
      "go-to-login": "Logowanie",
      "invalid-characters": "Wprowadzono nieprawidłowe znaki. Zmień swój wpis.",
      "first-name-and-last-name-too-short": "Proszę wprowadzić tylko litery alfabetu i co najmniej dwa znaki.",
      "an-error-occurred": "Wystąpił błąd",
      "please-enter-a-valid-email-address": "Wprowadź prawidłowy adres e-mail. Dozwolone znaki to znaki alfanumeryczne i następujące znaki specjalne: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Użytkownik nie istnieje",
      "show-password": "Wyświetl hasło",
      "no-number-and-email": "Wprowadź prawidłowy adres e-mail lub numer klienta składający się wyłącznie z cyfr.",
      "passwords-does-not-match": "Hasła nie są zgodne.",
      "user-does-not-exist": "Użytkownik nie istnieje",
      "your-user-profile": "Twój profil użytkownika",
      "enter-code": "Wprowadź kod"
    },
    "dashboard": {
      "logout": "Wyloguj",
      "lead": "Wybierz aplikację, do której chcesz uzyskać dostęp za pomocą konta Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Aby korzystać z mega macs S 20, na urządzeniu z systemem Android musi być zainstalowana aplikacja mega macs S 20. Aplikacja jest dostępna poprzez Sklep Play.",
      "x20-please-sign-in-title": "Logowanie do CSC-Tool X 20",
      "x20-please-sign-in-content": "Proszę zalogować się do swojego CSC-Tool X 20 za pomocą konta Hella Gutmann.",
      "s20-please-start-device-title": "Logowanie do mega macs S 20"
    },
    "errorMessage": {
      "error": "Błąd",
      "something-went-wrong": "Coś nie było w porządku."
    },
    "faq": {
      "howDoIChangePassword": "Jak mogę zmienić hasło do konta Hella Gutmann?",
      "howDoIGetAHellaGutmannAccount": "Jak mogę założyć konto Hella Gutmann?",
      "possibleToUseMultipleAccounts": "Rozwiązanie to umożliwia klientom bezpieczne logowanie się do kilku aplikacji i stron internetowych Hella Gutmann za pomocą jednego dostępu i jednorazowego loginu.",
      "backToLogin": "POWRÓT DO LOGOWANIA",
      "itIsASingleSignOnSolution": "Konto Hella Gutmann to rozwiązanie pojedynczego logowania (SSO) firmy Hella Gutmann. Do uzyskania dostępu wymagany jest adres e-mail i wybrane hasło.",
      "title": "Często zadawane pytania (FAQ)",
      "whatIsAHellaGutmannAccount": "Czym jest konto Hella Gutmann?",
      "supportedAppsConstantlyExpanded": "Liczba obsługiwanych aplikacji stale rośnie. Konto Hella Gutmann obsługuje obecnie następujące aplikacje",
      "alternativeContactSupport": "Alternatywnie, prosimy o kontakt z naszym zespołem wsparcia.",
      "howDoIResetPassword": "Jak zresetować hasło do konta Hella Gutmann?",
      "asSoonAsYouGetAccessToProducts": "Po zakupie jednego z obsługiwanych produktów lub uzyskaniu dostępu do macs365 otrzymasz wiadomość e-mail umożliwiającą założenie konta Hella Gutmann. Wiadomość e-mail jest wysyłana w sposób zautomatyzowany na adres e-mail zapisany w naszej bazie danych.",
      "whatToDoIfNoEMailReceived": "Co mogę zrobić, jeśli nie otrzymałem e-maila z prośbą o założenie konta Hella Gutmann?",
      "clickOnForgotPassword": "Jedną z opcji jest zażądanie wymaganej wiadomości e-mail za pośrednictwem <1>Passwort vergessen</1>. Upewnij się, że wprowadzony adres e-mail jest zgodny z adresem e-mail, który mamy zapisany w systemie.",
      "changeEmailOnUserProfile": "Możesz zmienić adres e-mail swojego konta Hella Gutmann, którego używasz do logowania, na stronie Profil użytkownika (Profil użytkownika jest obecnie dostępny tylko dla klientów mających dostęp do macs365).",
      "changePasswordOnUserProfile": "Hasło do konta Hella Gutmann można zmienić na stronie Profil użytkownika (Profil użytkownika jest obecnie dostępny tylko dla klientów z dostępem do macs365).",
      "howDoIChangeEmailAddress": "Jak mogę zmienić adres e-mail dla konta Hella Gutmann?",
      "whichAppsAreSupported": "Jakie aplikacje są obsługiwane przez konto Hella Gutmann?"
    },
    "footer": {
      "imprint": "Impressum",
      "faq": "FAQ",
      "faq-heading": "Często zadawane pytania (FAQ)",
      "data-privacy-policy": "Ochrona danych",
      "terms-and-conditions": "Warunki użytkowania"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Wysłanie wiadomości e-mail nie było możliwe z powodu zbyt wielu nieudanych prób. Spróbuj ponownie za kilka godzin.",
      "send-email": "Wyślij",
      "reset-your-password": "Zresetuj hasło",
      "forgot-password-button-clicked-alert": "Wiadomość e-mail została wysłana pomyślnie. Dostarczenie może potrwać kilka minut.",
      "back-to-login": "Powrót do logowania",
      "enter-your-login-V2": "Adres e-mail",
      "please-enter-your-login": "Podaj swój login, a my wyślemy Ci e-mail z potwierdzeniem. Kliknij przycisk weryfikacji znajdujący się w wiadomości e-mail.",
      "enter-your-login": "Twój login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Wybierz silne hasło i wprowadź je w obu polach.",
      "reset-your-password": "Ustaw nowe hasło",
      "repeat-password": "Powtórz nowe hasło",
      "a-verification-email-has-been-sent-to-you": "Została wysłana wiadomość e-mail z potwierdzeniem.",
      "reset-password": "Ustaw hasło",
      "new-password": "Nowe hasło",
      "passwords-do-not-match": "Oba hasła nie pasują do siebie. Sprawdź wprowadzone dane."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Twoje nowe hasło jest teraz gotowe do użycia.",
      "setting-new-password-successful": "Nowe hasło zostało ustawione pomyślnie!",
      "go-to-login": "Logowanie"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTelefon: +49 7668 9900 888 \n\nFaks: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nNumer podatkowy: 07011/39801 \n\nNumer identyfikacyjny VAT: DE 14 220 8666 \n\nRejestr handlowy: HRB 290194, Freiburg \n\nDyrektor generalny: Adnan Cemal",
      "header": "Impressum",
      "back": "POWRÓT DO LOGOWANIA"
    },
    "menu": {
      "digital-products": "Produkty cyfrowe"
    },
    "migration": {
      "helper-text-surname": "Proszę wpisać nazwisko",
      "description-submit": "Po przesłaniu formularza wyślemy wiadomość na podany adres e-mail. Kliknij przycisk weryfikacji w tej wiadomości, aby potwierdzić swój adres e-mail.",
      "firstname": "Imię",
      "description-login": "Następnie zaloguj się przy użyciu adresu e-mail i aktualnego hasła. Logowanie przy użyciu numeru klienta nie będzie już możliwe.",
      "submit": "Wyślij",
      "email": "Adres e-mail",
      "page-title": "Twoje konto użytkownika Hella Gutmann",
      "helper-text-firstname": "Wpisz imię",
      "surname": "Nazwisko",
      "title": "Zmiana loginu",
      "helper-text-email": "Wpisz adres e-mail",
      "description-user-account": "Hella Gutmann przechodzi na osobiste konta użytkowników. Wpisz tutaj imię, nazwisko i adres e-mail do swojego osobistego konta użytkownika."
    },
    "migrationError": {
      "go-to-login": "Logowanie",
      "your-email-address-could-not-get-confirmed": "Nie udało się potwierdzić nowego adresu e-mail. Najprawdopodobniej link w wiadomości e-mail już wygasł. Zaloguj się ponownie i rozpocznij proces od początku.",
      "change-of-your-login-failed": "Zmiana loginu nie powiodła się"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Wysłaliśmy wiadomość e-mail</0> na podany adres e-mail. Aby potwierdzić adres e-mail, przejdź do skrzynki pocztowej i <2>kliknij przycisk weryfikacji w wiadomości e-mail</2>.",
      "for-security-reasons": "Ze względów bezpieczeństwa link wygaśnie po 24 godzinach. Jeśli tak się stanie, rozpocznij proces ponownie.",
      "sending-successful": "Transmisja powiodła się"
    },
    "migrationVerify": {
      "verification-button": "Potwierdź",
      "verification-header": "Potwierdzenie konta użytkownika",
      "verification-description": "Kliknij na przycisk, aby potwierdzić utworzenie spersonalizowanego konta użytkownika"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Potwierdzony adres e-mail",
      "from-now-on-please-login-with-the-email": "Od tej chwili loguj się przy użyciu tego adresu e-mail i hasła.",
      "your-email-address-has-been-confirmed": "Twój adres e-mail został potwierdzony"
    },
    "needHelp": {
      "for-further-questions": "Jeśli masz dodatkowe pytania, możesz skontaktować się z naszą infolinią<1/> od poniedziałku do piątku w godzinach 8:00–17:00.",
      "need-help-logging-in": "Potrzebujesz pomocy przy logowaniu?",
      "here-you-will-find": "<0>Tutaj</0> znajdziesz odpowiedzi na <2>najczęściej zadawane pytania.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "mała litera",
      "uppercase-letter": "duża litera",
      "the-new-password-requires": "Wymagania dotyczące hasła:",
      "characters": "pozycje",
      "number": "cyfry"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Okres wypowiedzenia"
    },
    "settings": {
      "user-information-saved": "Dane użytkownika zostały zapisane.",
      "update-user-information": "Profil użytkownika",
      "new-password": "Nowe hasło",
      "resend-verification": "Wyślij ponownie weryfikację",
      "save": "Zapisz",
      "language-preference-saved": "Ustawienie języka zostało zapisane.",
      "email-has-been-sent": "Została wysłana wiadomość e-mail z potwierdzeniem.",
      "firstname": "Imię",
      "repeat-password": "Powtórz hasło",
      "your-user-data": "Twoje dane użytkownika",
      "set-new-password": "Ustaw nowe hasło",
      "email-is-not-verified-yet": "Adres e-mail nie został jeszcze zweryfikowany",
      "old-password": "Stare hasło",
      "new-login-info": "Pamiętaj, że Twój nowy adres e-mail będzie również Twoim loginem.",
      "update-your-email": "Zaktualizuj swój adres e-mail",
      "email": "Adres e-mail",
      "incorrect-username-or-password": "Nieprawidłowe hasło.",
      "back": "Powrót",
      "resend": "Wyślij ponownie",
      "update-your-language": "Preferowany język",
      "surname": "Nazwisko",
      "passwords-do-not-match": "Oba hasła nie pasują do siebie. Sprawdź wprowadzone dane.",
      "submit-new-email-info": "Jeśli podasz nowy adres e-mail, wyślemy Ci wiadomość e-mail z potwierdzeniem. Kliknij na link w tej wiadomości e-mail, aby potwierdzić nowy adres e-mail.",
      "this-language-will-be-used": "Ten język jest używany w Twoim osobistym koncie użytkownika i wiadomościach e-mail. Nie ma to wpływu na e-maile z fakturami."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Zapominałeś hasła?",
      "your-login-V2": "Adres e-mail",
      "your-password": "Twoje hasło",
      "sign-in-at-hella-gutmann": "Zaloguj się w Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Hasła nie są zgodne.",
      "noMatchedEmails": "Adresy e-mail nie są zgodne.",
      "lead": "Wprowadź swoje dane, aby utworzyć konto Hella Gutmann.",
      "descriptionUserAccountV2": "Hella Gutmann przechodzi na osobiste konta użytkowników. Wpisz tutaj imię, nazwisko i hasło do swojego osobistego konta użytkownika.",
      "password": "Hasło",
      "descriptionLogin": "Po weryfikacji zaloguj się przy użyciu swojego adresu e-mail i hasła.",
      "passwordLead": "Wybierz silne hasło i wprowadź je w obu polach.",
      "familyName": "Nazwisko",
      "repeatEmail": "Powtórz adres email",
      "header": "Rejestracja",
      "email": "Adres e-mail",
      "signup": "Rejestracja",
      "givenName": "Imię",
      "repeatPassword": "Powtórz hasło",
      "descriptionUserAccount": "Hella Gutmann przechodzi na osobiste konta użytkowników. Wpisz tutaj imię, nazwisko, adres e-mail i hasło do swojego osobistego konta użytkownika."
    },
    "signUpComplete": {
      "header": "Rejestracja powiodła się",
      "info": "Uwaga: Aby zalogować się na swoje konto Hella Gutmann, oprócz nadanego właśnie hasła, użyj adresu e-mail, na który wysłaliśmy e-mail rejestracyjny.",
      "yourUserProfile": "Twój profil użytkownika"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Transmisja powiodła się",
      "forSecurityReasons": "Ze względów bezpieczeństwa link wygaśnie po 24 godzinach. Jeśli tak się stanie, zaloguj się ponownie przy użyciu starych danych dostępowych i rozpocznij proces od nowa.",
      "weSentYouAnEmail": "<0>Wysłaliśmy wiadomość e-mail</0> na podany adres e-mail. Aby potwierdzić adres e-mail, przejdź do skrzynki pocztowej i <2>kliknij przycisk weryfikacji w wiadomości e-mail</2>.",
      "for-security-reasons": "Ze względów bezpieczeństwa link wygaśnie po 24 godzinach. Jeśli tak się stanie, rozpocznij proces ponownie."
    },
    "signUpVerify": {
      "description": "Kliknij na przycisk, aby potwierdzić utworzenie spersonalizowanego konta użytkownika",
      "header": "Potwierdzenie konta użytkownika",
      "button": "Potwierdź"
    },
    "verify": {
      "verification-description": "Kliknij na przycisk, aby potwierdzić swój adres e-mail",
      "verification-header": "Potwierdzenie adresu e-mail",
      "verification-button": "POTWIERDŹ"
    },
    "verifySuccess": {
      "your-user-profile": "Twój profil użytkownika",
      "from-now-on-we-will-send-you-messages": "Od tej chwili będziemy używać Twojego nowego adresu e-mail do komunikacji z macs365.",
      "keep-in-mind-that-this-email": "Należy pamiętać, że nowy adres e-mail będzie używany jako nazwa użytkownika do logowania.",
      "change-of-email-address-successful": "Zmiana adresu e-mail powiodła się."
    },
    "wizard": {
      "close": "Zamknij macs365"
    }
  },
  "pt": {
    "FAQModal": {
      "use-email-instead-of-customer": "Para repor a sua palavra-passe, utilize o seu endereço de e-mail em vez do número de cliente.",
      "missing-verification-email": "Não recebi o e-mail de confirmação.",
      "missing-forgot-password-email": "Não recebi o e-mail \"Palavra-passe esquecida\".",
      "creating-your-personalized": "Está a tentar criar a sua conta de utilizador pessoal diretamente com o seu endereço de e-mail. Primeiro, registe-se com o seu número de cliente e siga os passos indicados para criar a sua conta de utilizador pessoal.",
      "use-email-instead-of-your-customer": "Para iniciar sessão, utilize o seu endereço de e-mail em vez do número de cliente.",
      "frequently-asked-questions": "Perguntas frequentes",
      "personalized-user-account": "Já criou a sua conta de utilizador pessoal?",
      "no": "Não",
      "use-customer-without-de": "Para repor a sua palavra-passe, utilize o seu número de cliente (sem o prefixo \"DE\").",
      "yes": "Sim",
      "use-customer-without-de-prefix": "Para iniciar sessão, utilize o seu número de cliente (sem o prefixo \"DE\") e siga os passos indicados para criar a sua conta de utilizador pessoal.",
      "i-cannot-sign-in-to-my-account": "Não consigo registar-me."
    },
    "api": {
      "incorrect-username-or-password": "Nome de utilizador errado ou palavra-passe errada.",
      "invalid-code-provided": "Ocorreu um erro. Inicie novamente a alteração da palavra-passe.",
      "user-does-not-exist": "O utilizador não existe",
      "password-validation-error": "A palavra-passe não cumpre os requisitos.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "O utilizador não existe",
      "password-missing-number": "A palavra-passe não cumpre os requisitos. Introduza uma palavra-passe com, no mínimo, 1 algarismo.",
      "incorrect-old-password": "Palavra-passe antiga errada",
      "user-is-already-registered": "O utilizador já está registado.",
      "your-password-has-been-changed": "A sua palavra-passe foi alterada.",
      "password-missing-uppercase": "A palavra-passe não cumpre os requisitos. Introduza uma palavra-passe com, no mínimo, 1 maiúscula.",
      "invalid-verification-provided": "Utilizou um link que já expirou. Clique no link enviado no último e-mail \"Repor a palavra-passe\".",
      "email-used-by-different-user": "O endereço de e-mail já está a ser utilizado por outro utilizador.",
      "password-not-long-enough": "A palavra-passe não cumpre os requisitos. Introduza uma palavra-passe com, no mínimo, 8 dígitos.",
      "an-error-occurred": "Ocorreu um erro. Tente novamente mais tarde.",
      "attempt-limit-exceeded": "Demasiadas tentativas para alterar a palavra-passe. Aguarde um momento e inicie novamente a alteração da palavra-passe.",
      "incorrect_old_password": "Palavra-passe antiga errada",
      "password-missing-lowercase": "A palavra-passe não cumpre os requisitos. Introduza uma palavra-passe com, no mínimo, 1 minúscula.",
      "generic-api-message": "Verifique os dados introduzidos. Introduza tudo novamente à mão. Se o erro persistir, entre em contacto com a nossa assistência."
    },
    "common": {
      "please-wait": "Aguardar",
      "send-code": "Enviar código",
      "your-account": "A sua conta de utilizador Hella Gutmann",
      "close": "Fechar",
      "please-fill-in-this-field": "Preencha este campo.",
      "hgsKey": "Endereço de e-mail (se já criou a sua conta de utilizador pessoal) ou número de cliente",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Gira o seu perfil do utilizador com contas Hella Gutmann.",
      "please-start-the-process-again-later": "<0>Inicie o processo novamente mais tarde.</0> Se o erro ocorrer novamente, entre em contacto com o Customer Center.",
      "this-field-cannot-be-left-blank": "Este campo é de preenchimento obrigatório.",
      "please-enter-your-login": "Introduza aqui o seu login. Em seguida, enviaremos um código com 6 dígitos para o seu endereço de e-mail. Introduza este código na página seguinte. Não feche o seu browser.",
      "password-validation-error": "A palavra-passe não cumpre os requisitos.",
      "hide-password": "Ocultar palavra-passe",
      "go-to-login": "Para o início de sessão",
      "invalid-characters": "Introduziu símbolos inválidos. Altere os dados introduzidos.",
      "first-name-and-last-name-too-short": "Introduza apenas símbolos alfabéticos e pelo menos dois símbolos.",
      "an-error-occurred": "Ocorreu um erro",
      "please-enter-a-valid-email-address": "Introduza um endereço de e-mail válido. São permitidos símbolos alfanuméricos e os seguintes símbolos especiais: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "O utilizador não existe",
      "show-password": "Exibir palavra-passe",
      "no-number-and-email": "Introduza um endereço de e-mail válido ou o seu número de cliente composto exclusivamente por algarismos.",
      "passwords-does-not-match": "As palavras-passe não coincidem.",
      "user-does-not-exist": "O utilizador não existe",
      "your-user-profile": "O seu perfil de utilizador",
      "enter-code": "Introduza o código"
    },
    "dashboard": {
      "logout": "Terminar sessão",
      "lead": "Selecione a aplicação à qual pretende aceder com a sua conta Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Para poder utilizar o mega macs S 20, a aplicação mega macs S 20 tem de estar instalada no seu aparelho Android. A aplicação está disponível na Play Store.",
      "x20-please-sign-in-title": "Login no CSC-Tool X 20",
      "x20-please-sign-in-content": "Faça login no seu CSC-Tool X 20 com a sua conta Hella Gutmann.",
      "s20-please-start-device-title": "Login no mega macs S 20"
    },
    "errorMessage": {
      "error": "Erro",
      "something-went-wrong": "Algo correu mal."
    },
    "faq": {
      "howDoIChangePassword": "O que devo fazer para alterar a palavra-passe associada à conta Hella Gutmann?",
      "howDoIGetAHellaGutmannAccount": "O que devo fazer para ter uma conta Hella Gutmann?",
      "possibleToUseMultipleAccounts": "Esta solução permite aos clientes iniciar sessão em várias aplicações e sites da Hella Gutmann com um único acesso e um único início de sessão.",
      "backToLogin": "VOLTAR AO INÍCIO DE SESSÃO",
      "itIsASingleSignOnSolution": "A conta Hella Gutmann Account é a solução Single Sign-on (SSO, acesso único) da Hella Gutmann. Para aceder a esta solução, precisa de um endereço de e-mail e de uma palavra-passe escolhida por si.",
      "title": "Perguntas mais frequentes (FAQ)",
      "whatIsAHellaGutmannAccount": "O que é a conta Hella Gutmann?",
      "supportedAppsConstantlyExpanded": "O número de aplicações compatíveis está em permanente atualização. Atualmente, a conta Hella Gutmann é compatível com as seguintes aplicações",
      "alternativeContactSupport": "Em alternativa, entre em contacto com a nossa assistência.",
      "howDoIResetPassword": "O que devo fazer para repor a palavra-passe associada à conta Hella Gutmann?",
      "asSoonAsYouGetAccessToProducts": "Assim que tiver adquirido um dos produtos compatíveis ou tiver recebido autorização para aceder ao macs365, receberá um e-mail para criar uma conta Hella Gutmann. Um processo automático enviará este e-mail para o endereço de e-mail guardado no nosso sistema.",
      "whatToDoIfNoEMailReceived": "O que posso fazer se não tiver recebido o e-mail de criação da conta Hella Gutmann?",
      "clickOnForgotPassword": "Pode solicitar o e-mail necessário em <1>Passwort vergessen</1>. Tenha em atenção que o endereço de e-mail indicado deve coincidir com o endereço de e-mail guardado no nosso sistema.",
      "changeEmailOnUserProfile": "Pode alterar o endereço de e-mail da sua conta Hella Gutmann, o mesmo que utiliza para fazer login, na página Perfil do utilizador (atualmente, o perfil do utilizador está disponível apenas para clientes com acesso macs365).",
      "changePasswordOnUserProfile": "Pode alterar a palavra-passe da conta Hella Gutmann na página Perfil do utilizador (atualmente, o perfil do utilizador está disponível apenas para clientes com acesso macs365).",
      "howDoIChangeEmailAddress": "O que devo fazer para alterar o endereço de e-mail associado à conta Hella Gutmann?",
      "whichAppsAreSupported": "A conta Hella Gutmann é compatível com que aplicações?"
    },
    "footer": {
      "imprint": "Nota legal",
      "faq": "FAQ",
      "faq-heading": "Perguntas mais frequentes (FAQ)",
      "data-privacy-policy": "Política de Privacidade",
      "terms-and-conditions": "Condições de utilização"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Não foi possível enviar um e-mail devido a demasiadas tentativas falhadas. Tente de novo dentro de algumas horas.",
      "send-email": "Enviar",
      "reset-your-password": "Repor a sua palavra-passe",
      "forgot-password-button-clicked-alert": "O e-mail foi enviado com sucesso. Em determinadas circunstâncias, a entrega pode demorar alguns minutos.",
      "back-to-login": "Voltar ao início de sessão",
      "enter-your-login-V2": "Endereço de e-mail",
      "please-enter-your-login": "Introduza o seu login para lhe enviarmos um e-mail de confirmação. Clique no botão de confirmação incluído no e-mail.",
      "enter-your-login": "O seu login"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Escolha uma palavra-passe segura e introduza-a nos dois campos.",
      "reset-your-password": "Definir a nova palavra-passe",
      "repeat-password": "Repetir a nova palavra-passe",
      "a-verification-email-has-been-sent-to-you": "Foi-lhe enviado um e-mail de confirmação.",
      "reset-password": "Definir a palavra-passe",
      "new-password": "Nova palavra-passe",
      "passwords-do-not-match": "As duas palavras-passe não coincidem. Verifique os dados introduzidos."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Agora já pode utilizar a sua nova palavra-passe.",
      "setting-new-password-successful": "Nova palavra-passe definida com sucesso!",
      "go-to-login": "Para o início de sessão"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTel.: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nNúmero fiscal: 07011/39801 \n\nN.º IVA: DE 14 220 8666 \n\nRegisto comercial: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Nota legal",
      "back": "VOLTAR AO INÍCIO DE SESSÃO"
    },
    "menu": {
      "digital-products": "Produtos digitais"
    },
    "migration": {
      "helper-text-surname": "Introduza um apelido",
      "description-submit": "Depois de enviar o formulário, nós enviaremos uma mensagem para o endereço de e-mail indicado. Para confirmar o endereço de e-mail, clique no botão de verificação incluído na mensagem.",
      "firstname": "Nome",
      "description-login": "Em seguida, inicie sessão com o seu endereço de e-mail e a sua palavra-passe atual. Deixará de ser possível iniciar sessão com o seu número de cliente.",
      "submit": "Enviar",
      "email": "Endereço de e-mail",
      "page-title": "A sua conta de utilizador Hella Gutmann",
      "helper-text-firstname": "Introduza um nome",
      "surname": "Apelido",
      "title": "Alteração do seu início de sessão",
      "helper-text-email": "Introduza um endereço de e-mail",
      "description-user-account": "A Hella Gutmann vai passar a utilizar contas de utilizador pessoais. Introduza aqui um nome, um apelido e um endereço de e-mail para a sua conta de utilizador pessoal."
    },
    "migrationError": {
      "go-to-login": "Para o início de sessão",
      "your-email-address-could-not-get-confirmed": "Não foi possível confirmar o seu novo endereço de e-mail. Provavelmente, o link no seu e-mail já estava caducado. Inicie novamente a sua sessão e comece o processo do início.",
      "change-of-your-login-failed": "Alteração do seu início de sessão falhou"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Enviamos-lhe um e-mail</0> para o endereço de e-mail introduzido. Para confirmar o endereço de e-mail, entre na sua caixa de correio e <2>clique no botão de verificação incluído no e-mail</2>.",
      "for-security-reasons": "Por razões de segurança, o link perde a validade passadas 24 horas. Se isto acontecer, reinicie o processo.",
      "sending-successful": "Transmissão bem-sucedida"
    },
    "migrationVerify": {
      "verification-button": "Confirmar",
      "verification-header": "Confirmação da conta de utilizador",
      "verification-description": "Clique no botão para confirmar a criação da sua conta de utilizador personalizada"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Endereço de e-mail confirmado",
      "from-now-on-please-login-with-the-email": "A partir de agora, inicie sessão com este endereço de e-mail e com a sua palavra-passe.",
      "your-email-address-has-been-confirmed": "O seu endereço de e-mail foi confirmado"
    },
    "needHelp": {
      "for-further-questions": "Se tiver outras dúvidas, o nosso callcenter técnico<1/> está disponível de segunda a sexta-feira, das 8:00 às 17:00 horas.",
      "need-help-logging-in": "Precisa de ajuda para iniciar a sua sessão?",
      "here-you-will-find": "<0>Aqui</0> encontra soluções para <2>perguntas frequentes.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "minúscula",
      "uppercase-letter": "maiúscula",
      "the-new-password-requires": "Requisitos da palavra-passe:",
      "characters": "dígitos",
      "number": "algarismos"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Prazo de pré-aviso"
    },
    "settings": {
      "user-information-saved": "As informações do utilizador foram guardadas.",
      "update-user-information": "Perfil de utilizador",
      "new-password": "Nova palavra-passe",
      "resend-verification": "Enviar novamente a verificação",
      "save": "Guardar",
      "language-preference-saved": "O idioma foi guardado.",
      "email-has-been-sent": "Foi-lhe enviado um e-mail de confirmação.",
      "firstname": "Nome",
      "repeat-password": "Repetir a palavra-passe",
      "your-user-data": "Os seus dados de utilizador",
      "set-new-password": "Definir uma nova palavra-passe",
      "email-is-not-verified-yet": "O e-mail ainda não foi verificado",
      "old-password": "Palavra-passe antiga",
      "new-login-info": "Note que o seu novo endereço de e-mail também será o seu login.",
      "update-your-email": "Atualize o seu endereço de e-mail",
      "email": "Endereço de e-mail",
      "incorrect-username-or-password": "Palavra-passe errada.",
      "back": "Voltar",
      "resend": "Enviar novamente",
      "update-your-language": "Idioma preferido",
      "surname": "Apelido",
      "passwords-do-not-match": "As duas palavras-passe não coincidem. Verifique os dados introduzidos.",
      "submit-new-email-info": "Se introduzir um novo endereço de e-mail, enviar-lhe-emos um e-mail de confirmação. Clique no link incluído neste e-mail para confirmar o seu novo endereço de e-mail.",
      "this-language-will-be-used": "Este idioma será utilizado para a sua conta de utilizador pessoal e para os seus e-mails. Os e-mails de faturação não são afetados por esta definição."
    },
    "signIn": {
      "sign-in": "Login",
      "forgot-your-password": "Esqueceu a palavra-passe?",
      "your-login-V2": "Endereço de e-mail",
      "your-password": "A sua palavra-passe",
      "sign-in-at-hella-gutmann": "Iniciar sessão em Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "As palavras-passe não coincidem.",
      "noMatchedEmails": "Os endereços de e-mail não coincidem.",
      "lead": "Introduza os seus dados para criar uma conta Hella Gutmann.",
      "descriptionUserAccountV2": "A Hella Gutmann vai passar a utilizar contas de utilizador pessoais. Introduza aqui um nome, um apelido e uma palavra-passe para a sua conta de utilizador pessoal.",
      "password": "Palavra-passe",
      "descriptionLogin": "Depois da verificação, inicie sessão com o seu endereço de e-mail e a sua palavra-passe.",
      "passwordLead": "Escolha uma palavra-passe segura e introduza-a nos dois campos.",
      "familyName": "Apelido",
      "repeatEmail": "Repetir o endereço de e-mail",
      "header": "Registo",
      "email": "Endereço de e-mail",
      "signup": "Registar",
      "givenName": "Nome",
      "repeatPassword": "Repetir a palavra-passe",
      "descriptionUserAccount": "A Hella Gutmann vai passar a utilizar contas de utilizador pessoais. Introduza aqui um nome, um apelido, um endereço de e-mail e uma palavra-passe para a sua conta de utilizador pessoal."
    },
    "signUpComplete": {
      "header": "Registo bem-sucedido",
      "info": "Atenção: Para fazer login na sua conta Hella Gutmann, deve utilizar, para além da palavra-passe atribuída, o endereço de e-mail para o qual enviámos o e-mail de registo.",
      "yourUserProfile": "O seu perfil de utilizador"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Transmissão bem-sucedida",
      "forSecurityReasons": "Por razões de segurança, o link perde a validade passadas 24 horas. Se isto acontecer, inicie sessão novamente com os seus dados de acesso antigos e reinicie o processo.",
      "weSentYouAnEmail": "<0>Enviamos-lhe um e-mail</0> para o endereço de e-mail introduzido. Para confirmar o endereço de e-mail, entre na sua caixa de correio e <2>clique no botão de verificação incluído no e-mail</2>.",
      "for-security-reasons": "Por razões de segurança, o link perde a validade passadas 24 horas. Se isto acontecer, reinicie o processo."
    },
    "signUpVerify": {
      "description": "Clique no botão para confirmar a criação da sua conta de utilizador personalizada",
      "header": "Confirmação da conta de utilizador",
      "button": "Confirmar"
    },
    "verify": {
      "verification-description": "Clique no botão para confirmar o seu endereço de e-mail",
      "verification-header": "Confirmação do endereço de e-mail",
      "verification-button": "CONFIRMAR"
    },
    "verifySuccess": {
      "your-user-profile": "O seu perfil de utilizador",
      "from-now-on-we-will-send-you-messages": "A partir de agora, utilizaremos o seu novo endereço de e-mail para todas as comunicações relativas ao macs365.",
      "keep-in-mind-that-this-email": "Tenha em atenção que o seu novo endereço de e-mail serve de nome de utilizador para iniciar sessão.",
      "change-of-email-address-successful": "Alteração do endereço de e-mail bem-sucedida."
    },
    "wizard": {
      "close": "Fechar o macs365"
    }
  },
  "ro": {
    "FAQModal": {
      "use-email-instead-of-customer": "Pentru resetarea parolei, în loc de numărul de client, vă rugăm să utilizați adresa de e-mail.",
      "missing-verification-email": "Nu primesc e-mailul de confirmare.",
      "missing-forgot-password-email": "Nu primesc e-mailul pentru „V-ați uitat parola?”.",
      "creating-your-personalized": "Încercați să vă creați contul personal de utilizator direct cu adresa dvs. de e-mail. Vă rugăm să vă conectați mai întâi cu numărul dvs. de client și să urmați pașii pentru a vă crea contul personal de utilizator.",
      "use-email-instead-of-your-customer": "Atunci când vă conectați, vă rugăm să folosiți adresa dvs. de e-mail în locul numărului de client.",
      "frequently-asked-questions": "Întrebări frecvente",
      "personalized-user-account": "V-ați creat contul personal de utilizator?",
      "no": "Nu",
      "use-customer-without-de": "Vă rugăm să utilizați numărul de client (fără prefixul „DE”) pentru a vă reseta parola.",
      "yes": "Da",
      "use-customer-without-de-prefix": "Vă rugăm să utilizați numărul de client (fără prefixul „DE”) pentru a intra în cont și să urmați pașii pentru a vă crea contul personal de utilizator.",
      "i-cannot-sign-in-to-my-account": "NU reușesc să mă autentific."
    },
    "api": {
      "incorrect-username-or-password": "Nume utilizator sau parolă incorectă.",
      "invalid-code-provided": "A apărut o eroare. Reluați procesul de schimbare a parolei de la început.",
      "user-does-not-exist": "Utilizatorul nu există",
      "password-validation-error": "Parola nu îndeplinește condițiile.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Utilizatorul nu există",
      "password-missing-number": "Parola nu îndeplinește condițiile. Introduceți o parolă care să conțină cel puțin o cifră.",
      "incorrect-old-password": "Parolă veche incorectă",
      "user-is-already-registered": "Utilizatorul este deja înregistrat.",
      "your-password-has-been-changed": "Parola dumneavoastră a fost modificată.",
      "password-missing-uppercase": "Parola nu îndeplinește condițiile. Introduceți o parolă care să conțină cel puțin o majusculă.",
      "invalid-verification-provided": "A fost utilizat un link expirat. Vă rugăm să faceți clic pe link-ul din ultimul e-mail „Resetarea parolei”.",
      "email-used-by-different-user": "Adresa de e-mail este utilizată de un alt utilizator.",
      "password-not-long-enough": "Parola nu îndeplinește condițiile. Introduceți o parolă cu cel puțin 8 caractere.",
      "an-error-occurred": "A apărut o eroare. Vă rugăm să încercați din nou mai târziu.",
      "attempt-limit-exceeded": "Ați încercat să schimbați parola de prea multe ori. Așteptați un timp și reluați procesul de schimbare a parolei.",
      "incorrect_old_password": "Parolă veche incorectă",
      "password-missing-lowercase": "Parola nu îndeplinește condițiile. Introduceți o parolă care să conțină cel puțin o literă mică.",
      "generic-api-message": "Vă rugăm să vă verificați intrarea. Tastați-o din nou. Dacă eroarea persistă, vă rugăm să contactați serviciul nostru de asistență pentru clienți."
    },
    "common": {
      "please-wait": "Vă rugăm așteptați",
      "send-code": "Trimitere cod",
      "your-account": "Contul dvs. de utilizator Hella Gutmann",
      "close": "Închidere",
      "please-fill-in-this-field": "Vă rugăm să completați acest câmp.",
      "hgsKey": "Adresa de e-mail (dacă v-ați creat un cont personal de utilizator) sau numărul de client",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Gestionați-vă profilul utilizatorului cu Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0> Reluați procesul mai târziu.</0> Dacă problema persistă, vă rugăm să contactați Serviciul de asistență pentru clienți.",
      "this-field-cannot-be-left-blank": "Acest câmp nu poate fi lăsat gol.",
      "please-enter-your-login": "Vă rugăm să introduceți aici datele dvs. de autentificare. Vă vom trimite apoi un cod de 6 cifre pe adresa dvs. de e-mail. Introduceți acest cod pe pagina următoare. Nu închideți browserul.",
      "password-validation-error": "Parola nu îndeplinește condițiile.",
      "hide-password": "Ascundeți parola",
      "go-to-login": "Către Autentificare",
      "invalid-characters": "Ați introdus caractere nevalide. Vă rugăm să vă modificați intrarea.",
      "first-name-and-last-name-too-short": "Vă rugăm să introduceți numai caractere alfabetice și cel puțin două cifre.",
      "an-error-occurred": "A apărut o eroare",
      "please-enter-a-valid-email-address": "Vă rugăm să introduceți o adresă de e-mail validă. Caracterele permise sunt caracterele alfanumerice și următoarele caractere speciale: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Utilizatorul nu există",
      "show-password": "Afișează parola",
      "no-number-and-email": "Vă rugăm să introduceți o adresă de e-mail validă sau numărul dvs. de client format numai din cifre.",
      "passwords-does-not-match": "Parolele nu corespund.",
      "user-does-not-exist": "Utilizatorul nu există",
      "your-user-profile": "Profilul dvs. de utilizator",
      "enter-code": "Introduceți codul"
    },
    "dashboard": {
      "logout": "Deconectare",
      "lead": "Vă rugăm să selectați aplicația pe care doriți să o accesați cu contul dumneavoastră Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Pentru a putea utiliza mega macs S 20, trebuie să fie instalată aplicația mega macs S 20 pe dispozitivul dvs. Android. Aplicația poate fi obținută din Play Store.",
      "x20-please-sign-in-title": "Autentificare în CSC-Tool X 20",
      "x20-please-sign-in-content": "\t\nVă rugăm să vă conectați la CSC-Tool X 20 cu contul dumneavoastră Hella Gutmann.",
      "s20-please-start-device-title": "Autentificare în mega macs S 20"
    },
    "errorMessage": {
      "error": "Eroare",
      "something-went-wrong": "Ceva nu a fost în regulă."
    },
    "faq": {
      "howDoIChangePassword": "Cum pot schimba parola contului Hella Gutmann?",
      "howDoIGetAHellaGutmannAccount": "Cum pot obține un cont Hella Gutmann?",
      "possibleToUseMultipleAccounts": "Soluția permite clienților să se conecteze în siguranță la mai multe aplicații și site-uri web Hella Gutmann printr-un singur acces și o singură autentificare.",
      "backToLogin": "ÎNAPOI LA AUTENTIFICARE",
      "itIsASingleSignOnSolution": "Contul Hella Gutmann este soluția de conectare unică (SSO) de la Hella Gutmann. Pentru acces sunt necesare o adresă de e-mail și o parolă la alegere.",
      "title": "Întrebări frecvente (FAQ)",
      "whatIsAHellaGutmannAccount": "Ce reprezintă contul Hella Gutmann?",
      "supportedAppsConstantlyExpanded": "Numărul de aplicații acceptate este în continuă creștere. În prezent, contul Hella Gutmann acceptă următoarele aplicații",
      "alternativeContactSupport": "Alternativ, vă rugăm să contactați serviciul nostru de asistență pentru clienți.",
      "howDoIResetPassword": "Cum se resetează parola contului Hella Gutmann?",
      "asSoonAsYouGetAccessToProducts": "Imediat ce ați achiziționat unul dintre produsele acceptate sau ați fost autorizat să accesați macs365, veți primi un e-mail pentru a configura un cont Hella Gutmann. E-mailul va fi trimis la adresa de e-mail pe care o avem în evidență prin intermediul unui proces automat.",
      "whatToDoIfNoEMailReceived": "Ce pot face dacă nu am primit e-mailul de configurare a contului Hella Gutmann?",
      "clickOnForgotPassword": "O opțiune este să solicitați e-mailul necesar la <1>Passwort vergessen</1> Vă rugăm să vă asigurați că adresa de e-mail pe care o introduceți coincide cu adresa de e-mail pe care o avem în evidență.",
      "changeEmailOnUserProfile": "Puteți modifica adresa de e-mail a contului dvs. Hella Gutmann pe care o utilizați pentru conectare prin intermediul paginii Profilul utilizatorului (profilul utilizatorului este disponibil în prezent numai pentru clienții cu acces la macs365).",
      "changePasswordOnUserProfile": "Puteți modifica parola pentru contul Hella Gutmann accesând Profilul utilizatorului (profilul utilizatorului este disponibil în prezent numai pentru clienții cu acces la macs365).",
      "howDoIChangeEmailAddress": "Cum pot schimba adresa de e-mail pentru contul Hella Gutmann?",
      "whichAppsAreSupported": "Ce aplicații sunt compatibile cu contul Hella Gutmann?"
    },
    "footer": {
      "imprint": "Caseta redacției",
      "faq": "Întrebări frecvente",
      "faq-heading": "Întrebări frecvente (FAQ)",
      "data-privacy-policy": "Declarație privind protecția datelor",
      "terms-and-conditions": "Condiții de utilizare"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Trimiterea unui e-mail nu a fost posibilă din cauza numărului prea mare de încercări eșuate. Vă rugăm să reîncercați în câteva ore.",
      "send-email": "Trimitere",
      "reset-your-password": "Resetați parola",
      "forgot-password-button-clicked-alert": "E-mailul a fost trimis cu succes. Livrarea poate dura câteva minute.",
      "back-to-login": "Înapoi la Autentificare",
      "enter-your-login-V2": "Adresă de e-mail",
      "please-enter-your-login": "Vă rugăm să introduceți datele dvs. de autentificare și vă vom trimite un e-mail de confirmare. Vă rugăm să faceți clic pe butonul de verificare din e-mail.",
      "enter-your-login": "Datele dvs. de autentificare"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Alegeți o parolă sigură și introduceți-o în ambele câmpuri.",
      "reset-your-password": "Setați o parolă nouă",
      "repeat-password": "Reintroduceți parola nouă",
      "a-verification-email-has-been-sent-to-you": "Un e-mail de confirmare v-a fost trimis.",
      "reset-password": "Setarea parolei",
      "new-password": "Parola nouă",
      "passwords-do-not-match": "Parolele nu corespund. Verificați intrarea."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Noua dvs. parolă este acum gata de utilizare.",
      "setting-new-password-successful": "Parolă nouă setată cu succes!",
      "go-to-login": "Către Autentificare"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTelefon: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nNumăr de identificare fiscală: 07011/39801 \n\nNr. de identificare TVA: DE 14 220 8666 \n\nRegistrul comerțului: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Caseta redacției",
      "back": "ÎNAPOI LA AUTENTIFICARE"
    },
    "menu": {
      "digital-products": "Produse digitale"
    },
    "migration": {
      "helper-text-surname": "Introduceți un nume de familie",
      "description-submit": "După ce ați trimis formularul, vă vom trimite un mesaj la adresa de e-mail furnizată. Faceți clic pe butonul de verificare din acest mesaj pentru a confirma adresa dvs. de e-mail.",
      "firstname": "Prenumele",
      "description-login": "Apoi autentificați-vă cu adresa dumneavoastră de e-mail și parola curentă. Conectarea cu numărul dumneavoastră de client nu va mai fi posibilă.",
      "submit": "Trimitere",
      "email": "Adresă de e-mail",
      "page-title": "Contul dvs. de utilizator Hella Gutmann",
      "helper-text-firstname": "Introduceți un prenume",
      "surname": "Numele",
      "title": "Modificarea datelor de autentificare",
      "helper-text-email": "Vă rugăm să introduceți o adresă de e-mail",
      "description-user-account": "Hella Gutmann trece la conturi personale de utilizator. Introduceți un prenume, un nume de familie și o adresă de e-mail pentru contul dumneavoastră personal de utilizator."
    },
    "migrationError": {
      "go-to-login": "Către Autentificare",
      "your-email-address-could-not-get-confirmed": "Noua dumneavoastră adresă de e-mail nu a putut fi confirmată. Probabil că link-ul din e-mailul dumneavoastră a expirat deja. Vă rugăm să vă autentificați din nou și să începeți procesul de la început.",
      "change-of-your-login-failed": "Nu ați reușit să vă schimbați datele de autentificare"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>V-am trimis un e-mail</0> la adresa specificată. Pentru a confirma adresa de e-mail, mergeți la căsuța poștală și <2>faceți clic pe butonul de verificare din e-mail</2>.",
      "for-security-reasons": "Din motive de securitate, link-ul devine nevalid după 24 de ore. În acest caz, reluați procesul.",
      "sending-successful": "Transmitere efectuată cu succes"
    },
    "migrationVerify": {
      "verification-button": "Confirmare",
      "verification-header": "Confirmare cont de utilizator",
      "verification-description": "Vă rugăm să faceți clic pe buton pentru a confirma crearea contului dvs. de utilizator personalizat"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "Adresă de e-mail confirmată",
      "from-now-on-please-login-with-the-email": "De acum înainte, autentificați-vă cu această adresă de e-mail și cu parola dumneavoastră.",
      "your-email-address-has-been-confirmed": "Adresa dumneavoastră de e-mail a fost confirmată"
    },
    "needHelp": {
      "for-further-questions": "Pentru întrebări suplimentare, Serviciul de Asistență Tehnică<1/> este disponibil de luni până vineri, de la 8:00 la 17:00.",
      "need-help-logging-in": "Aveți nevoie de ajutor pentru autentificare?",
      "here-you-will-find": "<0>Aici</0> găsiți răspunsurile la cele <2>mai frecvente întrebări.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "literă mică",
      "uppercase-letter": "literă mare",
      "the-new-password-requires": "Setări parolă:",
      "characters": "Poziții",
      "number": "Cifră"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Perioadă de anulare"
    },
    "settings": {
      "user-information-saved": "Informațiile utilizatorului au fost memorate.",
      "update-user-information": "Profil utilizator",
      "new-password": "Parola nouă",
      "resend-verification": "Retrimitere verificare",
      "save": "Memorare",
      "language-preference-saved": "Limba setată a fost memorată.",
      "email-has-been-sent": "Un e-mail de confirmare v-a fost trimis.",
      "firstname": "Prenumele",
      "repeat-password": "Repetarea parolei",
      "your-user-data": "Datele dvs. de utilizator",
      "set-new-password": "Setarea unei parole noi",
      "email-is-not-verified-yet": "E-mailul nu este încă verificat",
      "old-password": "Parola veche",
      "new-login-info": "Rețineți că noua dvs. adresă de e-mail va fi și adresa dvs. de autentificare.",
      "update-your-email": "Actualizați-vă adresa de e-mail",
      "email": "Adresă de e-mail",
      "incorrect-username-or-password": "Parolă incorectă.",
      "back": "Înapoi",
      "resend": "Trimiteți din nou",
      "update-your-language": "Limba preferată",
      "surname": "Numele",
      "passwords-do-not-match": "Parolele nu corespund. Verificați intrarea.",
      "submit-new-email-info": "Dacă introduceți o adresă de e-mail nouă, vă vom trimite un e-mail de confirmare. Faceți clic pe link-ul din acest e-mail pentru a confirma noua adresă de e-mail.",
      "this-language-will-be-used": "Această limbă este utilizată pentru contul dvs. personal de utilizator și pentru e-mailurile dvs. E-mailurile cu facturi nu sunt afectate de acest lucru."
    },
    "signIn": {
      "sign-in": "Autentificare",
      "forgot-your-password": "V-ați uitat parola?",
      "your-login-V2": "Adresă de e-mail",
      "your-password": "Parola dvs.",
      "sign-in-at-hella-gutmann": "Autentificare la Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Parolele nu corespund.",
      "noMatchedEmails": "Adresele de e-mail nu corespund.",
      "lead": "Introduceți informațiile dvs. pentru a crea un cont Hella Gutmann.",
      "descriptionUserAccountV2": "Hella Gutmann trece la conturi personale de utilizator. Introduceți aici un prenume, un nume de familie și o parolă pentru contul dumneavoastră personal de utilizator.",
      "password": "Parolă",
      "descriptionLogin": "După verificare, autentificați-vă cu adresa dvs. de e-mail și parola.",
      "passwordLead": "Alegeți o parolă sigură și introduceți-o în ambele câmpuri.",
      "familyName": "Numele",
      "repeatEmail": "Repetați adresa de e-mail",
      "header": "Registration",
      "email": "Adresă de e-mail",
      "signup": "Înregistrare",
      "givenName": "Prenumele",
      "repeatPassword": "Repetați parola",
      "descriptionUserAccount": "Hella Gutmann trece la conturi personale de utilizator. Introduceți aici un nume, un prenume, o adresă de e-mail și o parolă pentru contul dvs. personal de utilizator."
    },
    "signUpComplete": {
      "header": "Înregistrare efectuată cu succes",
      "info": "Vă rugăm să rețineți: Pentru a vă conecta la contul dvs. Hella Gutmann, utilizați adresa de e-mail la care am trimis e-mailul de înregistrare, în plus față de parola pe care tocmai ați atribuit-o.",
      "yourUserProfile": "Profilul dvs. de utilizator"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Transmitere efectuată cu succes",
      "forSecurityReasons": "Din motive de securitate, link-ul devine nevalid după 24 de ore. În acest caz, autentificați-vă din nou cu vechile date de acces și reluați procesul.",
      "weSentYouAnEmail": "<0>V-am trimis un e-mail</0> la adresa specificată. Pentru a confirma adresa de e-mail, mergeți la căsuța poștală și <2>faceți clic pe butonul de verificare din e-mail</2>.",
      "for-security-reasons": "Din motive de securitate, link-ul devine nevalid după 24 de ore. În acest caz, reluați procesul."
    },
    "signUpVerify": {
      "description": "Vă rugăm să faceți clic pe buton pentru a confirma crearea contului dvs. de utilizator personalizat",
      "header": "Confirmare cont de utilizator",
      "button": "Confirmare"
    },
    "verify": {
      "verification-description": "Vă rugăm să faceți clic pe buton pentru a vă confirma adresa de e-mail",
      "verification-header": "Confirmarea adresei de e-mail",
      "verification-button": "CONFIRMARE"
    },
    "verifySuccess": {
      "your-user-profile": "Profilul dvs. de utilizator",
      "from-now-on-we-will-send-you-messages": "De acum înainte vom folosi noua dvs. adresă de e-mail pentru orice comunicare cu macs365.",
      "keep-in-mind-that-this-email": "Vă rugăm să rețineți că noua dvs. adresă de e-mail servește și ca nume de utilizator pentru autentificare.",
      "change-of-email-address-successful": "Schimbarea adresei de e-mail s-a efectuat cu succes."
    },
    "wizard": {
      "close": "închidere macs365"
    }
  },
  "sk": {
    "FAQModal": {
      "use-email-instead-of-customer": "Namiesto vášho zákazníckeho čísla použite na obnovenie hesla vašu e-mailovú adresu.",
      "missing-verification-email": "Nedostanem potvrdzujúci e-mail.",
      "missing-forgot-password-email": "Nedostanem e-mail \"zabudnuté heslo\".",
      "creating-your-personalized": "Pokúšate sa vytvoriť vaše osobné používateľské konto priamo pomocou vašej e-mailovej adresy. Najprv sa prihláste pomocou vášho zákazníckeho čísla a postupujte podľa krokov na vytvorenie vášho osobného používateľského konta.",
      "use-email-instead-of-your-customer": "Namiesto vášho zákazníckeho čísla použite pri prihlasovaní vašu e-mailovú adresu.",
      "frequently-asked-questions": "Často kladené otázky",
      "personalized-user-account": "Vytvorili ste si vaše osobné používateľské konto?",
      "no": "Nie",
      "use-customer-without-de": "Na obnovenie hesla použite vaše zákaznícke číslo (bez predpony \"DE\").",
      "yes": "Áno",
      "use-customer-without-de-prefix": "Na prihlásenie použite vaše zákaznícke číslo (bez predpony \"DE\") a postupujte podľa krokov na vytvorenie vášho osobného používateľského konta.",
      "i-cannot-sign-in-to-my-account": "Nemôžem sa prihlásiť."
    },
    "api": {
      "incorrect-username-or-password": "Nesprávne používateľské meno alebo heslo.",
      "invalid-code-provided": "Nastala chyba. Začnite zmenu hesla od začiatku.",
      "user-does-not-exist": "Používateľ neexistuje",
      "password-validation-error": "Heslo nezodpovedá požiadavkám.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Používateľ neexistuje",
      "password-missing-number": "Heslo nezodpovedá požiadavkám.  Zadajte heslo s minimálne 1 znakmi.",
      "incorrect-old-password": "Nesprávne staré heslo",
      "user-is-already-registered": "Používateľ je už registrovaný.",
      "your-password-has-been-changed": "Vaše heslo bolo zmenené.",
      "password-missing-uppercase": "Heslo nezodpovedá požiadavkám. Zadajte heslo s minimálne 1 veľkým písmenom.",
      "invalid-verification-provided": "Bol použitý odkaz, ktorého platnosť vypršala. Kliknite na odkaz v poslednom e-maile \"Obnoviť heslo\".",
      "email-used-by-different-user": "Túto e-mailovú adresu používa iný používateľ.",
      "password-not-long-enough": "Heslo nezodpovedá požiadavkám.  Zadajte heslo s minimálne 8 znakmi.",
      "an-error-occurred": "Nastala chyba. Vyskúšajte to prosím neskôr ešte raz.",
      "attempt-limit-exceeded": "Príliš často ste sa pokúšali zmeniť heslo. Chvíľu počkajte a znovu začnite proces zmeny hesla.",
      "incorrect_old_password": "Nesprávne staré heslo",
      "password-missing-lowercase": "Heslo nezodpovedá požiadavkám. Zadajte heslo s minimálne 1 malým písmenom.",
      "generic-api-message": "Skontrolujte vaše zadanie. Zadajte ho ešte raz ručne. Ak chyba pretrváva, kontaktujte náš tím podpory."
    },
    "common": {
      "please-wait": "Počkajte prosím",
      "send-code": "Pošlite kód",
      "your-account": "Vaše používateľské konto Hella Gutmann",
      "close": "Zatvoriť",
      "please-fill-in-this-field": "Vyplňte prosím toto pole.",
      "hgsKey": "E-mailová adresa (ak ste si vytvorili vaše osobné používateľské konto) alebo zákaznícke číslo",
      "manage-your-user-profile-with-hella-gutmann-accounts": "Spravujte váš používateľský profil pomocou Hella Gutmann Accounts.",
      "please-start-the-process-again-later": "<0>Začnite proces znova neskôr.</0> Ak sa problém opakuje, kontaktujte zákaznícke centrum.",
      "this-field-cannot-be-left-blank": "Toto pole nesmie zostať prázdne.",
      "please-enter-your-login": "Tu zadajte vaše prihlasovacie meno. Potom vám na vašu e-mailovú adresu zašleme 6-miestny kód. Tento kód zadajte na nasledujúcej stránke. Nezatvárajte prehliadač.",
      "password-validation-error": "Heslo nezodpovedá požiadavkám.",
      "hide-password": "Skryť heslo",
      "go-to-login": "Prihlásiť sa",
      "invalid-characters": "Zadali ste neplatné znaky. Zmeňte prosím vaše zadanie.",
      "first-name-and-last-name-too-short": "Zadajte len abecedné znaky a minimálne dva znaky.",
      "an-error-occurred": "Nastala chyba.",
      "please-enter-a-valid-email-address": "Zadajte prosím platnú e-mailovú adresu. Povolené znaky sú alfanumerické znaky a tieto špeciálne znaky: ( . ), ( _ ), ( - ), ( + ).",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Používateľ neexistuje",
      "show-password": "Zobraziť heslo",
      "no-number-and-email": "Zadajte prosím platnú e-mailovú adresu alebo vaše zákaznícke číslo pozostávajúce výlučne z číslic.",
      "passwords-does-not-match": "Heslá navzájom nesúhlasia.",
      "user-does-not-exist": "Používateľ neexistuje",
      "your-user-profile": "Váš používateľský profil",
      "enter-code": "Zadajte kód"
    },
    "dashboard": {
      "logout": "Odhlásiť",
      "lead": "Zvoľte aplikáciu, ku ktorej chcete pristupovať pomocou vášho konta Hella Gutmann."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "Ak chcete používať mega macs S 20, musíte mať v zariadení so systémom Android nainštalovanú aplikáciu mega macs S 20. Aplikácia je k dispozícii v Play Store.",
      "x20-please-sign-in-title": "Login do CSC-Tool X 20",
      "x20-please-sign-in-content": "Prihláste sa do svojho CSC-Tool X 20 pomocou vášho účtu Hella Gutmann.",
      "s20-please-start-device-title": "Login do mega macs S 20"
    },
    "errorMessage": {
      "error": "Chyba",
      "something-went-wrong": "Niečo nebolo v poriadku."
    },
    "faq": {
      "howDoIChangePassword": "Ako môžem zmeniť heslo pre konto Hella Gutmann?",
      "howDoIGetAHellaGutmannAccount": "Ako získam konto Hella Gutmann?",
      "possibleToUseMultipleAccounts": "Toto riešenie umožňuje zákazníkom bezpečne sa prihlásiť do viacerých aplikácií a webových stránok Hella Gutmann jediným prístupom a jediným prihlásením.",
      "backToLogin": "NASPÄŤ K PRIHLÁSENIU",
      "itIsASingleSignOnSolution": "Konto Hella Gutmann je riešenie Single Sign-on (SSO) od spoločnosti Hella Gutmann. Pre prístup je potrebná e-mailová adresa a heslo podľa vlastnej voľby.",
      "title": "Často kladené otázky (FAQ)",
      "whatIsAHellaGutmannAccount": "Čo je konto Hella Gutmann?",
      "supportedAppsConstantlyExpanded": "Počet podporovaných aplikácií sa neustále rozširuje. Konto Hella Gutmann v súčasnosti podporuje nasledujúce aplikácie",
      "alternativeContactSupport": "Prípadne kontaktujte náš tím podpory.",
      "howDoIResetPassword": "Ako obnovím heslo ku kontu Hella Gutmann?",
      "asSoonAsYouGetAccessToProducts": "Keď si zakúpite jeden z podporovaných produktov alebo budete mať oprávnenie na prístup k macs365, dostanete e-mail na zriadenie konta Hella Gutmann. E-mail je odoslaný prostredníctvom automatizovaného procesu na e-mailovú adresu, ktorú máme uloženú v záznamoch.",
      "whatToDoIfNoEMailReceived": "Čo môžem urobiť, ak som nedostal e-mail na zriadenie konta Hella Gutmann?",
      "clickOnForgotPassword": "Jednou z možností je vyžiadať si požadovaný e-mail cez <1>Passwort vergessen</1>. Uistite sa, že zadaná e-mailová adresa sa zhoduje s e-mailovou adresou, ktorú máme uloženú v záznamoch.",
      "changeEmailOnUserProfile": "E-mailovú adresu svojho účtu Hella Gutmann, ktorý používate na prihlásenie, môžete zmeniť prostredníctvom stránky profilu používateľa (profil používateľa je momentálne dostupný len pre zákazníkov s prístupom k macs365).",
      "changePasswordOnUserProfile": "Heslo k účtu Hella Gutmann si môžete zmeniť prostredníctvom stránky profilu používateľa (profil používateľa je momentálne dostupný len pre zákazníkov s prístupom k macs365).",
      "howDoIChangeEmailAddress": "Ako môžem zmeniť e-mailovú adresu pre konto Hella Gutmann?",
      "whichAppsAreSupported": "Ktoré aplikácie sú podporované kontom Hella Gutmann?"
    },
    "footer": {
      "imprint": "Impressum",
      "faq": "FAQ",
      "faq-heading": "Často kladené otázky (FAQ)",
      "data-privacy-policy": "Vyhlásenie o ochrane údajov",
      "terms-and-conditions": "Podmienky používania"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Odoslanie e-mailu nebolo možné z dôvodu príliš veľkého počtu neúspešných pokusov. Skúste to prosím znova o niekoľko hodín.",
      "send-email": "Odoslať",
      "reset-your-password": "Obnovte vaše heslo",
      "forgot-password-button-clicked-alert": "E-mail bol úspešne odoslaný. Doručenie môže trvať niekoľko minút.",
      "back-to-login": "Naspäť k prihláseniu",
      "enter-your-login-V2": "E-mailová adresa",
      "please-enter-your-login": "Zadajte vaše prihlasovacie meno a my vám pošleme potvrdzujúci e-mail. V e-maile kliknite na overovacie tlačidlo.",
      "enter-your-login": "Vaše prihlasovacie meno"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Zvoľte si bezpečné heslo a zadajte ho do oboch polí.",
      "reset-your-password": "Nastavte nové heslo",
      "repeat-password": "Opakujte nové heslo",
      "a-verification-email-has-been-sent-to-you": "Bol vám odoslaný potvrdzujúci e-mail.",
      "reset-password": "Nastavte heslo",
      "new-password": "Nové heslo",
      "passwords-do-not-match": "Obidve heslá navzájom nesúhlasia. Skontrolujte vaše zadanie."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Vaše nové heslo je teraz pripravené na použitie.",
      "setting-new-password-successful": "Nové heslo bolo úspešne nastavené!",
      "go-to-login": "Prihlásiť sa"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTel.: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nDIČ: 07011/39801 \n\nIČ DPH: DE 14 220 8666 \n\nObchodný register: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Impressum",
      "back": "NASPÄŤ K PRIHLÁSENIU"
    },
    "menu": {
      "digital-products": "Digitálne produkty"
    },
    "migration": {
      "helper-text-surname": "Zadajte priezvisko",
      "description-submit": "Po odoslaní formulára vám pošleme správu na zadanú e-mailovú adresu. Kliknutím na tlačidlo overenia v tejto správe potvrďte vašu e-mailovú adresu.",
      "firstname": "Krstné meno",
      "description-login": "Potom sa prihláste pomocou vašej e-mailovej adresy a aktuálneho hesla. Už sa nebudete môcť prihlásiť s vašim zákazníckym číslom.",
      "submit": "Odoslať",
      "email": "E-mailová adresa",
      "page-title": "Vaše používateľské konto Hella Gutmann",
      "helper-text-firstname": "Zadajte krstné meno",
      "surname": "Priezvisko",
      "title": "Zmena prihlasovacieho mena",
      "helper-text-email": "Zadajte e-mailovú adresu",
      "description-user-account": "Hella Gutmann prechádza na osobné používateľské kontá. Tu zadajte meno, priezvisko a e-mailovú adresu pre vaše osobné používateľské konto."
    },
    "migrationError": {
      "go-to-login": "Prihlásiť sa",
      "your-email-address-could-not-get-confirmed": "Vašu novú e-mailovú adresu nebolo možné potvrdiť. S najväčšou pravdepodobnosťou už platnosť odkazu vo vašom e-maile vypršala. Prihláste sa znova a začnite proces od začiatku.",
      "change-of-your-login-failed": "Zmena vášho prihlasovacieho mena zlyhala"
    },
    "migrationSuccess": {
      "we-sent-you-an-email": "<0>Na zadanú e-mailovú adresu sme vám poslali e-mail</0>. Ak chcete potvrdiť e-mailovú adresu, prejdite do svojej poštovej schránky a <2>kliknite na overovacie tlačidlo v e-maile</2>.",
      "for-security-reasons": "Z bezpečnostných dôvodov sa odkaz po 24 hodinách stane neplatným. Ak sa tak stane, začnite proces znova.",
      "sending-successful": "Úspešné odoslanie"
    },
    "migrationVerify": {
      "verification-button": "Potvrdiť",
      "verification-header": "Potvrdenie používateľského konta",
      "verification-description": "Kliknutím na tlačidlo potvrďte vytvorenie vášho osobného používateľského konta"
    },
    "migrationVerifySuccess": {
      "email-address-confirmed": "E-mailová adresa potvrdená",
      "from-now-on-please-login-with-the-email": "Odteraz sa prihlasujte pomocou tejto e-mailovej adresy a vášho hesla.",
      "your-email-address-has-been-confirmed": "Vaša e-mailová adresa potvrdená"
    },
    "needHelp": {
      "for-further-questions": "Ak máte ďalšie otázky, naša horúca linka<1/> je pre vás k dispozícii od pondelka do piatku od 8:00 do 17:00.",
      "need-help-logging-in": "Potrebujete pomoc s prihlásením?",
      "here-you-will-find": "<0>Tu</0> nájdete riešenia <2>často kladených otázok.</2"
    },
    "passwordPolicy": {
      "lowercase-letter": "malé písmeno",
      "uppercase-letter": "veľké písmeno",
      "the-new-password-requires": "Požiadavky na heslo:",
      "characters": "Miesta",
      "number": "Číslica"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "Výpovedná lehota"
    },
    "settings": {
      "user-information-saved": "Informácie o používateľovi boli uložené.",
      "update-user-information": "Používateľský profil",
      "new-password": "Nové heslo",
      "resend-verification": "Opätovne odošlite overenie",
      "save": " Uložiť",
      "language-preference-saved": "Nastavenie jazyka bolo uložené.",
      "email-has-been-sent": "Bol vám odoslaný potvrdzujúci e-mail.",
      "firstname": "Krstné meno",
      "repeat-password": "Zopakujte heslo",
      "your-user-data": "Vaše používateľské údaje",
      "set-new-password": "Nastavenie nového hesla",
      "email-is-not-verified-yet": "E-mail ešte nie je overený",
      "old-password": "Staré heslo",
      "new-login-info": "Nezabudnite, že vaša nová e-mailová adresa bude zároveň vaším prihlasovacím menom.",
      "update-your-email": "Aktualizujte vašu e-mailovú adresu",
      "email": "E-mailová adresa",
      "incorrect-username-or-password": "Nesprávne heslo.",
      "back": "Späť",
      "resend": "Opätovne odoslať",
      "update-your-language": "Preferovaný jazyk",
      "surname": "Priezvisko",
      "passwords-do-not-match": "Obidve heslá navzájom nesúhlasia. Skontrolujte vaše zadanie.",
      "submit-new-email-info": "Ak zadáte novú e-mailovú adresu, pošleme vám potvrdzujúci e-mail. Kliknutím na odkaz v tomto e-maile potvrdíte svoju novú e-mailovú adresu.",
      "this-language-will-be-used": "Tento jazyk sa používa pre vaše osobné používateľské konto a e-maily. E-mailov s faktúrami sa to netýka."
    },
    "signIn": {
      "sign-in": "Prihlasovacie meno",
      "forgot-your-password": "Zabudli ste heslo?",
      "your-login-V2": "E-mailová adresa",
      "your-password": "Vaše heslo",
      "sign-in-at-hella-gutmann": "Prihláste sa u Hella Gutmann"
    },
    "signUp": {
      "noMatchedPasswords": "Heslá navzájom nesúhlasia.",
      "noMatchedEmails": "E-mailové adresy navzájom nesúhlasia.",
      "lead": "Zadajte vaše údaje, aby ste si vytvorili konto Hella Gutmann.",
      "descriptionUserAccountV2": "Hella Gutmann prechádza na osobné používateľské kontá. Tu zadajte meno, priezvisko a heslo pre vaše osobné používateľské konto.",
      "password": "Heslo",
      "descriptionLogin": "Po overení sa prihláste pomocou vašej e-mailovej adresy a vášho hesla.",
      "passwordLead": "Zvoľte si bezpečné heslo a zadajte ho do oboch polí.",
      "familyName": "Priezvisko",
      "repeatEmail": "Zopakujte e-mailovú adresu",
      "header": "Registrácia",
      "email": "E-mailová adresa",
      "signup": "Registrovať",
      "givenName": "Krstné meno",
      "repeatPassword": "Zopakujte heslo",
      "descriptionUserAccount": "Hella Gutmann prechádza na osobné používateľské účty. Tu zadajte meno, priezvisko, e-mailovú adresu a heslo pre svoje osobné používateľské konto."
    },
    "signUpComplete": {
      "header": "Registrácia bola úspešná",
      "info": "Upozornenie: Na prihlásenie do svojho účtu Hella Gutmann použite okrem hesla, ktoré ste práve vytvorili, aj e-mailovú adresu, na ktorú sme vám poslali registračný e-mail.",
      "yourUserProfile": "Váš používateľský profil"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Úspešné odoslanie",
      "forSecurityReasons": "Z bezpečnostných dôvodov sa odkaz po 24 hodinách stane neplatným. Ak sa tak stane, prihláste sa znova so starými prístupovými údajmi a začnite proces znova.",
      "weSentYouAnEmail": "<0>Na zadanú e-mailovú adresu sme vám poslali e-mail</0>. Ak chcete potvrdiť e-mailovú adresu, prejdite do svojej poštovej schránky a <2>kliknite na overovacie tlačidlo v e-maile</2>.",
      "for-security-reasons": "Z bezpečnostných dôvodov sa odkaz po 24 hodinách stane neplatným. Ak sa tak stane, začnite proces znova."
    },
    "signUpVerify": {
      "description": "Kliknutím na tlačidlo potvrďte vytvorenie vášho osobného používateľského konta",
      "header": "Potvrdenie používateľského konta",
      "button": "Potvrdiť"
    },
    "verify": {
      "verification-description": "Kliknutím na tlačidlo potvrďte vašu e-mailovú adresu",
      "verification-header": "Potvrdenie e-mailovej adresy",
      "verification-button": "POTVRDIŤ"
    },
    "verifySuccess": {
      "your-user-profile": "Váš používateľský profil",
      "from-now-on-we-will-send-you-messages": "Odteraz budeme pre všetku komunikáciu s macs365 používať vašu novú e-mailovú adresu.",
      "keep-in-mind-that-this-email": "Upozorňujeme, že vaša nová e-mailová adresa slúži ako vaše používateľské meno na prihlásenie.",
      "change-of-email-address-successful": "Zmena e-mailovej adresy prebehla úspešne."
    },
    "wizard": {
      "close": "Zatvorte macs365"
    }
  },
  "tr": {
    "FAQModal": {
      "use-email-instead-of-customer": "Şifrenizi sıfırlamak için lütfen müşteri numaranız yerine e-posta adresinizi kullanın.",
      "missing-verification-email": "Onay e-postasını almıyorum.",
      "missing-forgot-password-email": "\"Şifremi unuttum\" e-postasını almıyorum.",
      "creating-your-personalized": "Şu anda doğrudan e-posta adresinizle kişisel bir kullanıcı hesabı oluşturmaya çalışıyorsunuz. Lütfen önce müşteri numaranızla giriş yapın ve kişisel kullanıcı hesabınızı oluşturmak için adımları izleyin.",
      "use-email-instead-of-your-customer": "Giriş yaparken müşteri numaranız yerine e-posta adresinizi kullanın lütfen.",
      "frequently-asked-questions": "Sıkça sorulan sorular",
      "personalized-user-account": "Kişisel kullanıcı hesabınızı oluşturdunuz mu?",
      "no": "Hayır",
      "use-customer-without-de": "Şifrenizi sıfırlamak için lütfen müşteri numaranızı (\"DE\" öneki olmadan) kullanın.",
      "yes": "Evet",
      "use-customer-without-de-prefix": "Oturum açmak için lütfen müşteri numaranızı (\"DE\" öneki olmadan) kullanın ve kişisel kullanıcı hesabınızı oluşturmak için belirtilen prosedürü izleyin.",
      "i-cannot-sign-in-to-my-account": "Oturum açamıyorum."
    },
    "api": {
      "incorrect-username-or-password": "Yanlış kullanıcı adı veya yanlış şifre.",
      "invalid-code-provided": "Bir hata oluştu. Şifre değiştirme prosedürünü yeniden başlatın.",
      "user-does-not-exist": "Kullanıcı yok",
      "password-validation-error": "Parola gerekli kriterlere uymuyor.",
      "user-migration-failed-with-error-unexpected-end-of-json-input": "Kullanıcı yok",
      "password-missing-number": "Şifre gereksinimleri karşılamıyor. En az 1 haneli bir şifre girin.",
      "incorrect-old-password": "Yanlış eski şifre",
      "user-is-already-registered": "Bu kullanıcı zaten kayıtlı.",
      "your-password-has-been-changed": "Şifreniz değiştirildi.",
      "password-missing-uppercase": "Şifre gereksinimleri karşılamıyor. En az 1 büyük harf içeren bir şifre girin.",
      "invalid-verification-provided": "Süresi dolmuş bağlantı kullanıldı. Lütfen son e-postadaki “Şifreyi Sıfırla” bağlantısına tıklayın.",
      "email-used-by-different-user": "E-posta adresi başka bir kullanıcı tarafından kullanılıyor.",
      "password-not-long-enough": "Şifre gereksinimleri karşılamıyor. En az 8 haneli bir şifre girin.",
      "an-error-occurred": "Bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
      "attempt-limit-exceeded": "Şifreyi çok sık değiştirmeyi denediniz. Bir süre bekleyin ve şifreyi değiştirme prosedürünü en baştan yeniden başlatın.",
      "password-missing-lowercase": "Şifre gereksinimleri karşılamıyor. En az 1 küçük harf içeren bir şifre girin.",
      "generic-api-message": "Lütfen girişinizi kontrol edin. Tekrar elle yazın. Hata devam ederse destek ekibimizle iletişime geçin."
    },
    "common": {
      "please-wait": "Lütfen bekleyin",
      "send-code": "Kod gönderme",
      "your-account": "Hella Gutmann kullanıcı hesabınız",
      "close": "Kapat",
      "please-fill-in-this-field": "Lütfen bu alanı doldurun.",
      "hgsKey": "E-posta adresi (kişisel kullanıcı hesabınızı oluşturduysanız) veya müşteri numarası",
      "manage-your-user-profile-with-hella-gutmann-accounts": "kullanıcı profilinizi Hella Gutmann Hesaplarıyla yönetin.",
      "please-start-the-process-again-later": "<0>Bu işlemi yapmayı daha sonra tekrar deneyin.</0> Sorun yeniden oluşursa lütfen müşteri desteğimizle iletişime geçin.",
      "this-field-cannot-be-left-blank": "Bu alan boş bırakılamaz.",
      "please-enter-your-login": "Buradan oturum açın. Sonra e-posta adresinize 6 haneli bir kod göndereceğiz. Sonraki sayfada bu kodu girin. Tarayıcınızı kapatmayın.",
      "password-validation-error": "Parola gerekli kriterlere uymuyor.",
      "hide-password": "Şifre gizleme",
      "go-to-login": "Oturum açmaya git",
      "invalid-characters": "Geçersiz karakterler girdiniz. Lütfen girişinizi değiştirin.",
      "first-name-and-last-name-too-short": "Sadece alfabetik karakterler ve en az iki karakter girin.",
      "an-error-occurred": "Bir hata oluştu",
      "please-enter-a-valid-email-address": "Lütfen geçerli bir e-posta adresi girin. Aşağıdaki özel karakterlere izin verilir: ( . ), ( _ ), ( - ), ( + ).",
      "show-password": "Şifre görüntüleme",
      "no-number-and-email": "Lütfen geçerli bir e-posta adresi veya sadece rakamlardan oluşan müşteri numaranızı girin.",
      "passwords-does-not-match": "Şifreler uyuşmuyor.",
      "user-does-not-exist": "Kullanıcı yok",
      "your-user-profile": "Kullanıcı profiliniz",
      "enter-code": "Kodu girin"
    },
    "dashboard": {
      "logout": "Oturum kapatma",
      "lead": "Hella Gutmann hesabınızla erişmek istediğiniz uygulamayı seçin."
    },
    "dashboardInfo": {
      "s20-please-start-device-content": "\t\nmega macs S 20'nin kullanılabilmesi için Android cihazınızda mega macs S 20 uygulamasının yüklü olması gerekir. Uygulamaya Play Store üzerinden ulaşılabilir.",
      "x20-please-sign-in-title": "CSC-Tool X 20 için oturum açma",
      "x20-please-sign-in-content": "Lütfen Hella Gutmann hesabınızla CSC-Tool X 20'nizde oturum açın.",
      "s20-please-start-device-title": "mega macs S 20 için oturum açma"
    },
    "errorMessage": {
      "error": "Hata",
      "something-went-wrong": "Bir sorun oluştu."
    },
    "faq": {
      "howDoIChangePassword": "Hella Gutmann hesabının şifresini nasıl değiştirebilirim?",
      "howDoIGetAHellaGutmannAccount": "Hella Gutmann hesabısı nasıl alınır?",
      "possibleToUseMultipleAccounts": "Bu çözüm, müşterilerin tek bir erişim ve oturum açma işlemiyle birden fazla Hella Gutmann uygulamasına ve web sayfasına güvenli bir şekilde oturum açma olanağı tanıyor.",
      "backToLogin": "OTURUM AÇMAYA GERİ DÖN",
      "itIsASingleSignOnSolution": "Hella Gutmann Hesabı, Hella Gutmann'ın tek oturum açma çözümüdür (SSO). Erişim için bir e-posta adresi ve sizin seçtiğiniz bir şifre gereklidir.",
      "title": "Sık sorulan sorular (FAQ)",
      "whatIsAHellaGutmannAccount": "Hella Gutmann hesabı nedir?",
      "supportedAppsConstantlyExpanded": "Desteklenen uygulamaların sayısı sürekli olarak artırılmaktadır. Şu anda Hella Gutmann hesabı aşağıdaki uygulamaları desteklemektedir",
      "alternativeContactSupport": "Ayrıca teknik desteğimizle iletişime geçebilirsiniz.",
      "howDoIResetPassword": "Hella Gutmann hesabının şifresini nasıl sıfırlayabilirim?",
      "asSoonAsYouGetAccessToProducts": "Desteklenen ürünlerden birini satın aldığınızda veya macs365'e erişim yetkisine sahip olduğunuzda, Hella Gutmann hesabı oluşturmanız için bir e-posta alacaksınız. E-posta, bizde kayıtlı olan e-posta adresine otomatik olarak gönderilir.",
      "whatToDoIfNoEMailReceived": "hella gutmann hesabını oluşturma e-postası alamadığım zaman ne yapabilirim?",
      "clickOnForgotPassword": "Seçeneklerden biri, istenen e-postayı <1>Şifremi unuttum</1> yoluyla istemektir. Lütfen girdiğiniz e-posta adresinin, bizde kayıtlı e-posta adresiyle aynı olduğundan emin olun.",
      "changeEmailOnUserProfile": "Giriş yapmak için kullandığınız Hella Gutmann hesabınızın e-posta adresini kullanıcı profili sayfasından değiştirebilirsiniz (kullanıcı profili şu anda sadece macs365 erişimi olan müşteriler tarafından kullanılabilir).",
      "changePasswordOnUserProfile": "Hella Gutmann hesabının şifresini Kullanıcı Profili sayfasından değiştirebilirsiniz (kullanıcı profili şu anda sadece macs365 erişimi olan müşteriler tarafından kullanılabilir).",
      "howDoIChangeEmailAddress": "Hella Gutmann hesabının e-posta adresini nasıl değiştirebilirim?",
      "whichAppsAreSupported": "Hella Gutmann hesabı hangi uygulamaları destekliyor?"
    },
    "footer": {
      "imprint": "Künye",
      "faq": "FAQ",
      "data-privacy-policy": "Gizlilik Politikası",
      "terms-and-conditions": "Kullanım koşulları"
    },
    "forgotPassword": {
      "attempt-limit-exceeded-please-try-after-some-time": "Çok fazla başarısız deneme nedeniyle e-posta gönderilemedi. Birkaç saat sonra tekrar deneyin.",
      "send-email": "Gönder",
      "reset-your-password": "Şifrenizi sıfırlayın",
      "forgot-password-button-clicked-alert": "E-posta başarıyla gönderildi. Bazı durumlarda teslimat birkaç dakika sürebilir.",
      "back-to-login": "Oturum açmaya geri dön",
      "enter-your-login-V2": "E-posta adresi",
      "please-enter-your-login": "Lütfen oturum açın, size bir onay e-postası göndereceğiz. Lütfen e-postadaki doğrulama butonuna tıklayın.",
      "enter-your-login": "Oturum açma bilgileriniz"
    },
    "forgotPasswordCode": {
      "think-about-a-new-password-and-enter-it": "Güvenli bir şifre seçin ve onu her iki alana da girin.",
      "reset-your-password": "Yeni bir şifre belirleyin",
      "repeat-password": "Yeni şifreyi tekrar girin",
      "a-verification-email-has-been-sent-to-you": "Size bir onay e-postası gönderildi.",
      "reset-password": "Bir şifre belirleyin",
      "new-password": "Yeni şifre",
      "passwords-do-not-match": "Girilen şifreler aynı değil. Girişinizi kontrol edin."
    },
    "forgotPasswordSuccess": {
      "your-new-password-is-now-ready-to-use": "Yeni şifreniz şimdi kullanıma hazır.",
      "setting-new-password-successful": "Yeni şifre başarıyla belirlendi!",
      "go-to-login": "Oturum açmaya git"
    },
    "imprint": {
      "content": "Hella Gutmann Solutions GmbH \n\nAm Krebsbach 2 \n\nD-79241 Ihringen \n\nTel.: +49 7668 9900 888 \n\nFax: +49 7668 9900 3999 \n\ninfo@hella-gutmann.com \n\nVergi numarası: 07011/39801 \n\nKDV ID numarası: DE 14 220 8666 \n\nTicaret sicil numarası: HRB 290194, Freiburg \n\nCEO: Adnan Cemal",
      "header": "Künye",
      "back": "OTURUM AÇMAYA GERİ DÖN"
    },
    "menu": {
      "digital-products": "Dijital ürünler"
    },
    "migration": {
      "helper-text-surname": "Bir soyadı girin",
      "description-submit": "Formu gönderdikten sonra belirttiğiniz e-posta adresine bir mesaj göndereceğiz. E-posta adresinizi onaylamak için bu mesajdaki doğrulama düğmesine tıklayın."
    },
    "needHelp": {
      "for-further-questions": "Başka sorularınız olduğunda yardım hattımız<1/> Pazartesi'den Cuma'ya sabah 8'den akşam 5'e kadar hizmetinizdedir.",
      "need-help-logging-in": "Giriş yapmak için yardıma mı ihtiyacınız var?",
      "here-you-will-find": "<0>Burada</0> sık sorulan soruların <2>çözümlerini bulacaksınız.</2>"
    },
    "passwordPolicy": {
      "lowercase-letter": "küçük harf",
      "uppercase-letter": "büyük harf",
      "the-new-password-requires": "Şifre gereksinimleri:",
      "characters": "Karakterler",
      "number": "Rakamlar"
    },
    "segv-license-options-descriptions": {
      "cancellation-period-title": "İptal süresi"
    },
    "settings": {
      "user-information-saved": "Kullanıcı bilgileri kaydedildi.",
      "update-user-information": "Kullanıcı profili",
      "new-password": "Yeni şifre",
      "resend-verification": "Onaylamayı tekrar gönderme",
      "save": "Kaydetme",
      "language-preference-saved": "Dil ayarı kaydedildi.",
      "email-has-been-sent": "Size bir onay e-postası gönderildi.",
      "firstname": "Ad",
      "repeat-password": "Şifreyi tekrar girin",
      "your-user-data": "Kullanıcı verileriniz",
      "set-new-password": "Yeni şifre belirleyin",
      "email-is-not-verified-yet": "E-posta henüz doğrulanmadı",
      "old-password": "Eski şifre",
      "new-login-info": "Yeni e-posta adresinizin aynı zamanda oturum açma bilgileriniz olacağını unutmayın.",
      "update-your-email": "E-posta adresinizi güncelleyin",
      "email": "E-posta adresi",
      "incorrect-username-or-password": "Yanlış şifre.",
      "back": "Geri",
      "resend": "Tekrar gönderin",
      "update-your-language": "Tercih edilen dil",
      "surname": "Soyadı",
      "passwords-do-not-match": "Girilen şifreler aynı değil. Girişinizi kontrol edin.",
      "submit-new-email-info": "Yeni bir e-posta adresi girerseniz size bir onay e-postası göndereceğiz. Yeni e-posta adresinizi onaylamak için bu e-postadaki bağlantıya tıklayın.",
      "this-language-will-be-used": "Bu dil kişisel kullanıcı hesabınız ve e-postalarınız için kullanılır. Fatura e-postaları  bu seçimden etkilenmez.."
    },
    "signIn": {
      "sign-in": "Oturum Açma",
      "forgot-your-password": "Şifrenizi mi unuttunuz?",
      "your-login-V2": "E-posta adresi",
      "your-password": "Şifreniz",
      "sign-in-at-hella-gutmann": "Hella Gutmann'da oturum açın"
    },
    "signUp": {
      "noMatchedPasswords": "Şifreler uyuşmuyor.",
      "noMatchedEmails": "E-posta adresleri eşleşmiyor.",
      "lead": "Hella Gutmann hesabı oluşturmak için bilgilerinizi girin.",
      "descriptionUserAccountV2": "Hella Gutmann kimlik doğrulama prosedürlerini değiştirerek kişisel kullanıcı hesaplarına geçiyor. Kişisel kullanıcı hesabınız için adınızı, soyadınızı ve şifrenizi buraya girin.",
      "password": "Şifre",
      "descriptionLogin": "Doğrulamanın ardından e-posta adresiniz ve şifrenizle giriş yapabilirsiniz.",
      "passwordLead": "Güvenli bir şifre seçin ve onu her iki alana da girin.",
      "familyName": "Soyadı",
      "repeatEmail": "E-posta adresini tekrar girin",
      "header": "Kayıt",
      "email": "E-posta adresi",
      "signup": "Kaydetme",
      "givenName": "Ad",
      "repeatPassword": "Şifreyi tekrarlayın",
      "descriptionUserAccount": "Hella Gutmann kimlik doğrulama prosedürlerini değiştirerek kişisel kullanıcı hesaplarına geçiyor. Kişisel kullanıcı hesabınız için adınızı, soyadınızı, e-posta adresinizi ve şifrenizi buraya girin."
    },
    "signUpComplete": {
      "header": "Kayıt başarılı",
      "info": "Lütfen dikkat edin: Hella Gutmann hesabınıza giriş yapmak için, az önce belirlediğiniz şifreye ek olarak, kayıt e-postasını gönderdiğimiz e-posta adresini kullanacaksınız.",
      "yourUserProfile": "Kullanıcı profiliniz"
    },
    "signUpSuccess": {
      "sendingSuccessful": "Gönderme başarılı",
      "forSecurityReasons": "Güvenlik nedeniyle bu bağlantı sadece 24 saat geçerlidir. Bu süre içinde oturum açmazsanız eski erişim verilerinizle tekrar oturum açın ve süreci yeniden başlatın.",
      "weSentYouAnEmail": "<0>Size bir e-posta</0> girdiğiniz e-posta adresine göderildi. E-posta adresini doğrulamak için posta kutunuza gidin ve <2>e-postadaki</2> doğrulama butonuna tıklayın.",
      "for-security-reasons": "Güvenlik nedeniyle bu bağlantı sadece 24 saat geçerlidir. Bu süre içinde oturum açmazsanız süreci yeniden başlatın."
    },
    "signUpVerify": {
      "description": "Kişiselleştirilmiş kullanıcı hesabınızın oluşturulmasını onaylamak için lütfen butona tıklayın",
      "header": "Kullanıcı hesabının onaylanması",
      "button": "Onayla"
    },
    "verify": {
      "verification-description": "E-posta adresinizi onaylamak için lütfen butona tıklayın",
      "verification-header": "E-Posta adresinin onaylanması",
      "verification-button": "ONAYLA"
    },
    "verifySuccess": {
      "your-user-profile": "Kullanıcı profiliniz",
      "from-now-on-we-will-send-you-messages": "Artık macs365 ile olan tüm iletişimlerimizde yeni e-posta adresinizi kullanacağız.",
      "keep-in-mind-that-this-email": "Yeni e-posta adresinizin aynı zamanda oturum açmak için kullanıcı adı olarak da kullanıldığını lütfen unutmayın.",
      "change-of-email-address-successful": "E-posta adresi değişikliği başarılı oldu."
    },
    "wizard": {
      "close": "Macs365'i kapatın"
    }
  }
}